export default [
    {
        "key": "_",
        "ko": "_",
        "ja": "_",
        "de": "_",
        "en": "_",
        "zh-Hans": "_"
    },
    {
        "key": "1_month",
        "ko": "1개월",
        "ja": "1ヶ月",
        "de": "1 Monat",
        "en": "1 month",
        "zh-Hans": "1个月",
        "zh-Hant": "1個月"
    },
    {
        "key": "1_year",
        "ko": "1년",
        "ja": "1年",
        "de": "1 Jahr",
        "en": "1 year",
        "zh-Hans": "1年",
        "zh-Hant": "1年"
    },
    {
        "key": "14_days",
        "ko": "14일",
        "ja": "14日",
        "de": "14 Tage",
        "en": "14 days",
        "zh-Hans": "14天",
        "zh-Hant": "14天"
    },
    {
        "key": "1st",
        "ko": "1등",
        "ja": "1位",
        "de": "1",
        "en": "1st",
        "zh-Hans": "第1名",
        "zh-Hant": "第1名"
    },
    {
        "key": "2d",
        "ko": "2d",
        "ja": "2d",
        "de": "2d",
        "en": "2d",
        "zh-Hans": "2d",
        "zh-Hant": "2d"
    },
    {
        "key": "3_months",
        "ko": "3개월",
        "ja": "3ヶ月",
        "de": "3 Monate",
        "en": "3 months",
        "zh-Hans": "3个月",
        "zh-Hant": "3個月"
    },
    {
        "key": "30_days",
        "ko": "30일",
        "ja": "30日",
        "de": "30 Tage",
        "en": "30 days",
        "zh-Hans": "30天",
        "zh-Hant": "30天"
    },
    {
        "key": "4_digits",
        "ko": "4자리",
        "ja": "4桁",
        "de": "4 Ziffern",
        "en": "4 digits",
        "zh-Hans": "4位",
        "zh-Hant": "4位"
    },
    {
        "key": "6_digits",
        "ko": "6자리",
        "ja": "6桁数字",
        "de": "6 Ziffern",
        "en": "6 digits",
        "zh-Hans": "6位",
        "zh-Hant": "6位"
    },
    {
        "key": "6_months",
        "ko": "6개월",
        "ja": "6ヶ月",
        "de": "6 Monate",
        "en": "6 months",
        "zh-Hans": "6个月",
        "zh-Hant": "6個月"
    },
    {
        "key": "60_days",
        "ko": "60일",
        "ja": "60日",
        "de": "60 Tage",
        "en": "60 days",
        "zh-Hans": "60天",
        "zh-Hant": "60天"
    },
    {
        "key": "7_days",
        "ko": "7일",
        "ja": "7日",
        "de": "7 Tage",
        "en": "7 days",
        "zh-Hans": "7天",
        "zh-Hant": "7天"
    },
    {
        "key": "a_server_error_occurred_please_try_again_later",
        "ko": "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
        "ja": "サーバーエラーが発生しました。しばらくしてから再度お試しください。",
        "de": "Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        "en": "A server error occurred. Please try again later.",
        "zh-Hans": "发生服务器错误。请稍后再试。",
        "zh-Hant": "發生伺服器錯誤。請稍後再試。"
    },
    {
        "key": "access_denied_please_contact_your_administrator",
        "ko": "접근이 거부되었습니다. 관리자에게 문의해주세요.",
        "ja": "アクセスが拒否されました。管理者にお問い合わせください。",
        "de": "Zugriff verweigert. Bitte kontaktieren Sie Ihren Administrator.",
        "en": "Access denied. Please contact your administrator.",
        "zh-Hans": "访问被拒绝。请联系管理员。",
        "zh-Hant": "存取遭拒。請聯絡管理員。"
    },
    {
        "key": "account",
        "ko": "계정",
        "ja": "アカウント",
        "de": "Konto",
        "en": "Account",
        "zh-Hans": "账号",
        "zh-Hant": "帳號"
    },
    {
        "key": "account_in_use",
        "ko": "이미 사용 중인 계정입니다.",
        "ja": "既に使用中のアカウントです。",
        "de": "Dieses Konto wird bereits verwendet.",
        "en": "This account is already in use.",
        "zh-Hans": "此账号已在使用中。",
        "zh-Hant": "此帳號已在使用中。"
    },
    {
        "key": "account_is_available",
        "ko": "사용 가능한 계정입니다.",
        "ja": "使用可能なアカウントです。",
        "de": "Konto ist verfügbar.",
        "en": "Account is available.",
        "zh-Hans": "账号可用。",
        "zh-Hant": "帳號可用。"
    },
    {
        "key": "account_linking_failed",
        "ko": "계정 연동에 실패했습니다.",
        "ja": "アカウント連携に失敗しました。",
        "de": "Kontoverknüpfung fehlgeschlagen.",
        "en": "Account linking failed.",
        "zh-Hans": "账号关联失败。",
        "zh-Hant": "帳號關聯失敗。"
    },
    {
        "key": "account_password",
        "ko": "계정비밀번호",
        "ja": "アカウントパスワード",
        "de": "Kontopasswort",
        "en": "Account password",
        "zh-Hans": "账号密码",
        "zh-Hant": "帳號密碼"
    },
    {
        "key": "account_password_confirmation",
        "ko": "계정비밀번호확인",
        "ja": "アカウントパスワード確認",
        "de": "Kontopasswort bestätigen",
        "en": "Account password confirmation",
        "zh-Hans": "账号密码确认",
        "zh-Hant": "帳號密碼確認"
    },
    {
        "key": "account_withdrawal_failed",
        "ko": "계정 탈퇴에 실패했습니다.",
        "ja": "アカウント退会に失敗しました。",
        "de": "Kontokündigung fehlgeschlagen.",
        "en": "Account withdrawal failed.",
        "zh-Hans": "账号注销失败。",
        "zh-Hant": "帳號註銷失敗。"
    },
    {
        "key": "account_withdrawn",
        "ko": "계정이 탈퇴되었습니다.",
        "ja": "アカウントが退会されました。",
        "de": "Das Konto wurde gekündigt.",
        "en": "Account has been withdrawn.",
        "zh-Hans": "账号已注销。",
        "zh-Hant": "帳號已註銷。"
    },
    {
        "key": "achieved_of_goal_days_achieved",
        "ko": "목표 {{goal}}일 중 {{achieved}}일 달성",
        "ja": "目標{{goal}}日中{{achieved}}日達成",
        "de": "{{achieved}} of {{goal}} days achieved",
        "en": "{{achieved}} of {{goal}} days achieved",
        "zh-Hans": "已达成 {{goal}} 天目标中的 {{achieved}} 天",
        "zh-Hant": "已達成 {{goal}} 天目標中的 {{achieved}} 天"
    },
    {
        "key": "active_championships_in_organization",
        "ko": "기관내 활성 챔피언십수",
        "ja": "機関内アクティブチャンピオンシップ数",
        "de": "Aktive Meisterschaften in der Organisation",
        "en": "Active championships in organization",
        "zh-Hans": "机构内活跃锦标赛数",
        "zh-Hant": "機構內活躍錦標賽數"
    },
    {
        "key": "activity_calories",
        "ko": "활동 칼로리",
        "ja": "活動カロリー",
        "de": "Aktivitätskalorien",
        "en": "Activity calories",
        "zh-Hans": "活动卡路里",
        "zh-Hant": "活動卡路里"
    },
    {
        "key": "activity_time",
        "ko": "활동 시간",
        "ja": "活動時間",
        "de": "Aktivitätszeit",
        "en": "Activity time",
        "zh-Hans": "活动时间",
        "zh-Hant": "活動時間"
    },
    {
        "key": "add",
        "ko": "추가",
        "ja": "追加",
        "de": "Hinzufügen",
        "en": "Add",
        "zh-Hans": "添加",
        "zh-Hant": "新增"
    },
    {
        "key": "add_affiliated_organization",
        "ko": "소속기관 추가",
        "ja": "所属機関追加",
        "de": "Zugehörige Organisation hinzufügen",
        "en": "Add affiliated organization",
        "zh-Hans": "添加所属机构",
        "zh-Hant": "新增所屬機構"
    },
    {
        "key": "add_championship",
        "ko": "대회 추가",
        "ja": "チャンピオンシップ追加",
        "de": "Meisterschaft hinzufügen",
        "en": "Add championship",
        "zh-Hans": "添加大赛",
        "zh-Hant": "新增大賽"
    },
    {
        "key": "add_organization",
        "ko": "기관추가",
        "ja": "機関追加",
        "de": "Organisation hinzufügen",
        "en": "Add organization",
        "zh-Hans": "添加机构",
        "zh-Hant": "新增機構"
    },
    {
        "key": "add_user",
        "ko": "사용자추가",
        "ja": "ユーザー追加",
        "de": "Benutzer hinzufügen",
        "en": "Add user",
        "zh-Hans": "添加用户",
        "zh-Hant": "新增使用者"
    },
    {
        "key": "address",
        "ko": "주소",
        "ja": "住所",
        "de": "Adresse",
        "en": "Address",
        "zh-Hans": "地址",
        "zh-Hant": "地址"
    },
    {
        "key": "address_detail",
        "ko": "상세주소",
        "ja": "詳細住所",
        "de": "Adressdetails",
        "en": "Address detail",
        "zh-Hans": "详细地址",
        "zh-Hant": "詳細地址"
    },
    {
        "key": "address_zip_code_and_region_are_auto_filled_some_may_require_manual_entry",
        "ko": "주소, 우편번호, 지역은 자동입력되나 일부는 수동 입력이 필요합니다.",
        "ja": "住所・郵便番号・地域は自動入力されますが、一部は手動入力が必要です。",
        "de": "Adresse, Postleitzahl und Region werden automatisch ausgefüllt; einige Angaben müssen ggf. manuell eingegeben werden.",
        "en": "Address, zip code, and region are auto-filled; some may require manual entry.",
        "zh-Hans": "地址、邮政编码和地区会自动填写，部分内容可能需要手动输入。",
        "zh-Hant": "地址、郵遞區號和地區會自動填寫，部分內容可能需要手動輸入。"
    },
    {
        "key": "admin_add_edit",
        "ko": "일반관리자 추가/수정",
        "ja": "一般管理者追加/編集",
        "de": "Allgemeinadministrator hinzufügen/bearbeiten",
        "en": "General administrator add/edit",
        "zh-Hans": "添加/编辑普通管理员",
        "zh-Hant": "新增/編輯普通管理員"
    },
    {
        "key": "admin_only_access",
        "ko": "관리자만 접근 가능합니다.",
        "ja": "管理者のみアクセス可能。",
        "de": "Nur Admin-Zugriff.",
        "en": "Admin only access.",
        "zh-Hans": "仅管理员可访问。",
        "zh-Hant": "僅管理員可存取。"
    },
    {
        "key": "admin_organization_fetch_failed",
        "ko": "어드민 기관 정보 가져오기 실패",
        "ja": "管理者機関情報の取得に失敗しました",
        "de": "Admin-Organisationsinformationen konnten nicht geladen werden",
        "en": "Failed to fetch admin organization",
        "zh-Hans": "获取管理员机构信息失败",
        "zh-Hant": "獲取管理員機構資訊失敗"
    },
    {
        "key": "administrator",
        "ko": "관리자",
        "ja": "管理者",
        "de": "Administrator",
        "en": "Administrator",
        "zh-Hans": "管理员",
        "zh-Hant": "管理員"
    },
    {
        "key": "administrator_account",
        "ko": "관리자 계정",
        "ja": "管理者アカウント",
        "de": "Administratorkonto",
        "en": "Administrator account",
        "zh-Hans": "管理员账号",
        "zh-Hant": "管理員帳號"
    },
    {
        "key": "administrator_name",
        "ko": "관리자명",
        "ja": "管理者名",
        "de": "Administratorname",
        "en": "Administrator name",
        "zh-Hans": "管理员姓名",
        "zh-Hant": "管理員姓名"
    },
    {
        "key": "affiliated_organization",
        "ko": "소속기관",
        "ja": "所属機関",
        "de": "Angeschlossene Organisation",
        "en": "Affiliated organization",
        "zh-Hans": "所属机构",
        "zh-Hant": "所屬機構"
    },
    {
        "key": "age_3",
        "ko": "만3세반",
        "ja": "満3歳クラス",
        "de": "Altersgruppe 3",
        "en": "Age 3",
        "zh-Hans": "3岁班",
        "zh-Hant": "3歲班"
    },
    {
        "key": "age_4",
        "ko": "만4세반",
        "ja": "満4歳クラス",
        "de": "Altersgruppe 4",
        "en": "Age 4",
        "zh-Hans": "4岁班",
        "zh-Hant": "4歲班"
    },
    {
        "key": "age_5",
        "ko": "만5세반",
        "ja": "満5歳クラス",
        "de": "Altersgruppe 5",
        "en": "Age 5",
        "zh-Hans": "5岁班",
        "zh-Hant": "5歲班"
    },
    {
        "key": "agility",
        "ko": "순발력",
        "ja": "敏捷性",
        "de": "Beweglichkeit",
        "en": "Agility",
        "zh-Hans": "敏捷性",
        "zh-Hant": "敏捷性"
    },
    {
        "key": "ai_exercise_recommendation",
        "ko": "AI 운동추천",
        "ja": "AI運動おすすめ",
        "de": "KI-Bewegungsempfehlung",
        "en": "AI Exercise Recommendation",
        "zh-Hans": "AI 运动推荐",
        "zh-Hant": "AI 運動推薦"
    },
    {
        "key": "ai_feedback_table_f0001_message",
        "ko": "$님, 오늘은 랜덤 운동으로 시작해봐요. 디딤 체력측정을 하면 더 정확한 추천을 받을 수 있습니다.",
        "ja": "$さん、今日はランダム運動で始めましょう。ディディム体力測定でより正確なおすすめが受けられます。",
        "de": "$, starten Sie heute mit einem zufälligen Training. Mit der Didim-Fitnessbewertung erhalten Sie genauere Empfehlungen.",
        "en": "$, start with a random workout today. Get a more accurate recommendation with Didim fitness assessment.",
        "zh-Hans": "$，今天先从随机运动开始吧。进行 Didim 体能测评后，可以获得更准确的推荐。",
        "zh-Hant": "$，今天先從隨機運動開始吧。進行 Didim 體能測評後，可以獲得更準確的推薦。"
    },
    {
        "key": "ai_feedback_table_f0002_message",
        "ko": "$님, 지금은 기본 루틴으로 몸을 풀어봐요. 디딤 체력측정을 하면 개인 맞춤 운동을 추천받을 수 있어요.",
        "ja": "$さん、まずは基本ルーティンで体をほぐしましょう。体力測定で個人に合った運動をおすすめします。",
        "de": "$, lockern Sie sich mit der Basis-Routine auf. Die Didim-Fitnessbewertung ermöglicht personalisierte Bewegungsempfehlungen.",
        "en": "$, warm up with the basic routine for now. Didim fitness assessment helps you get personalized exercise recommendations.",
        "zh-Hans": "$，现在先用基础训练热身吧。进行 Didim 体能测评后，可以获得个性化运动推荐。",
        "zh-Hant": "$，現在先用基礎訓練熱身吧。進行 Didim 體能測評後，可以獲得個人化運動推薦。"
    },
    {
        "key": "ai_feedback_table_f0003_message",
        "ko": "$님, 오늘은 랜덤 루틴으로 몸을 움직여볼까요? 체력측정을 하면 나만의 운동 패턴이 만들어집니다.",
        "ja": "$さん、今日はランダムルーティンで体を動かしませんか。体力測定で自分だけの運動パターンが作れます。",
        "de": "$, wie wäre es heute mit einer Zufalls-Routine? Die Fitnessbewertung erstellt Ihr persönliches Bewegungsmuster.",
        "en": "$, how about moving with a random routine today? Fitness assessment will create your own exercise pattern.",
        "zh-Hans": "$，今天要不要用随机训练动一动身体？体能测评后会生成属于你的运动模式。",
        "zh-Hant": "$，今天要不要用隨機訓練動一動身體？體能測評後會生成屬於你的運動模式。"
    },
    {
        "key": "ai_feedback_table_f0004_message",
        "ko": "$님, 아직 개인 데이터가 없네요. 디딤 체력측정으로 정확한 운동 레벨을 확인해보세요.",
        "ja": "$さん、まだ個人データがありません。ディディム体力測定で正確な運動レベルを確認しましょう。",
        "de": "$, Sie haben noch keine persönlichen Daten. Prüfen Sie Ihr Fitnesslevel mit der Didim-Fitnessbewertung.",
        "en": "$, you don't have personal data yet. Check your fitness level with Didim fitness assessment.",
        "zh-Hans": "$，你还没有个人数据。请通过 Didim 体能测评确认准确的运动等级。",
        "zh-Hant": "$，你還沒有個人資料。請通過 Didim 體能測評確認準確的運動等級。"
    },
    {
        "key": "ai_feedback_table_f0005_message",
        "ko": "$님, 오늘은 AI가 준비한 랜덤 루틴이에요. 체력측정을 하면 더 정밀한 운동 추천이 가능해요.",
        "ja": "$さん、今日はAIが用意したランダムルーティンです。体力測定でより精密な運動おすすめが可能です。",
        "de": "$, heute gibt es eine Zufalls-Routine von AI. Die Fitnessbewertung ermöglicht präzisere Empfehlungen.",
        "en": "$, today's a random routine from AI. Fitness assessment enables more precise exercise recommendations.",
        "zh-Hans": "$，今天是 AI 准备的随机训练。进行体能测评后，可以获得更精准的运动推荐。",
        "zh-Hant": "$，今天是 AI 準備的隨機訓練。進行體能測評後，可以獲得更精準的運動推薦。"
    },
    {
        "key": "ai_feedback_table_f0006_message",
        "ko": "$님, 랜덤 루틴으로 시작해요. 체력측정을 하면 $님만을 위한 맞춤 루틴을 드릴게요.",
        "ja": "$さん、ランダムルーティンで始めましょう。体力測定で$さん専用のルーティンをお届けします。",
        "de": "$, starten Sie mit einer Zufalls-Routine. Mit der Fitnessbewertung erhalten Sie eine Routine nur für $.",
        "en": "$, let's start with a random routine. With fitness assessment, we'll give you a routine just for $.",
        "zh-Hans": "$，我们从随机训练开始吧。进行体能测评后，会为 $ 提供专属训练。",
        "zh-Hant": "$，我們從隨機訓練開始吧。進行體能測評後，會為 $ 提供專屬訓練。"
    },
    {
        "key": "ai_feedback_table_f0007_message",
        "ko": "$님, 오늘은 가볍게 랜덤 운동으로 시작해요. 체력측정을 하면 개인화된 운동을 추천받을 수 있습니다.",
        "ja": "$さん、今日は軽くランダム運動で始めましょう。体力測定で個人向け運動をおすすめします。",
        "de": "$, beginnen Sie heute leicht mit einem Zufallstraining. Die Fitnessbewertung liefert personalisierte Empfehlungen.",
        "en": "$, start light with a random workout today. Fitness assessment gives you personalized exercise recommendations.",
        "zh-Hans": "$，今天先轻松地从随机运动开始吧。进行体能测评后，可以获得个性化运动推荐。",
        "zh-Hant": "$，今天先輕松地從隨機運動開始吧。進行體能測評後，可以獲得個人化運動推薦。"
    },
    {
        "key": "ai_feedback_table_f0008_message",
        "ko": "$님, 아직 체력측정 기록이 없네요. 디딤에서 측정하면 맞춤 운동을 추천해드려요.",
        "ja": "$さん、まだ体力測定の記録がありません。ディディムで測定するとおすすめ運動をご案内します。",
        "de": "$, es gibt noch keine Fitnessbewertung. Messen Sie mit Didim für angepasste Empfehlungen.",
        "en": "$, there's no fitness assessment record yet. Measure on Didim to get tailored exercise recommendations.",
        "zh-Hans": "$，还没有体能测评记录。在 Didim 测评后，可获得定制运动推荐。",
        "zh-Hant": "$，還沒有體能測評記錄。在 Didim 測評後，可獲得定制運動推薦。"
    },
    {
        "key": "ai_feedback_table_f0009_message",
        "ko": "$님, 지금은 랜덤 운동으로 체험해보세요. 체력측정을 하면 더 정확한 루틴을 제공합니다.",
        "ja": "$さん、今はランダム運動を体験してみてください。体力測定でより正確なルーティンをご提供します。",
        "de": "$, probieren Sie ein Zufallstraining. Die Fitnessbewertung liefert eine genauere Routine.",
        "en": "$, try a random workout for now. Fitness assessment will provide a more accurate routine.",
        "zh-Hans": "$，现在先体验随机运动吧。进行体能测评后，会提供更准确的训练。",
        "zh-Hant": "$，現在先體驗隨機運動吧。進行體能測評後，會提供更準確的訓練。"
    },
    {
        "key": "ai_feedback_table_f0010_message",
        "ko": "$님, 디딤 체력측정을 통해 나만의 운동 데이터를 만들어보세요. 이후엔 개인 맞춤 운동이 추천됩니다.",
        "ja": "$さん、ディディム体力測定で自分だけの運動データを作りましょう。その後は個人向け運動がおすすめされます。",
        "de": "$, erstellen Sie Ihre Bewegungsdaten mit der Didim-Fitnessbewertung. Danach werden personalisierte Empfehlungen angezeigt.",
        "en": "$, build your own exercise data through Didim fitness assessment. After that, personalized exercise will be recommended.",
        "zh-Hans": "$，通过 Didim 体能测评建立属于你的运动数据吧。之后会推荐个性化运动。",
        "zh-Hant": "$，通過 Didim 體能測評建立屬於你的運動資料吧。之後會推薦個人化運動。"
    },
    {
        "key": "ai_feedback_table_f1101_message",
        "ko": "$님, 어제는 #로 활동량이 조금 적었어요.",
        "ja": "$さん、昨日は#で活動量が少し少なめでした。",
        "de": "$, gestern war die Aktivität bei # etwas niedrig.",
        "en": "$, yesterday's activity was a bit low at #.",
        "zh-Hans": "$，昨天的活动量为 #，有点少。",
        "zh-Hant": "$，昨天的活動量為 #，有點少。"
    },
    {
        "key": "ai_feedback_table_f1102_message",
        "ko": "$님, 어제는 #로 평소보다 덜 걸으셨어요. 오늘은 조금만 더 움직여볼까요?",
        "ja": "$さん、昨日は#でいつもより少なめでした。今日は少しだけ動いてみませんか。",
        "de": "$, gestern sind Sie bei # weniger gelaufen als sonst. Wie wäre es heute mit etwas mehr Bewegung?",
        "en": "$, you walked a bit less than usual yesterday at #. How about moving a little more today?",
        "zh-Hans": "$，你昨天的步数为 #，比平时少一些。今天要不要多动一点？",
        "zh-Hant": "$，你昨天的步數為 #，比平時少一些。今天要不要多動一點？"
    },
    {
        "key": "ai_feedback_table_f1103_message",
        "ko": "$님, 어제는 #로 몸이 휴식한 하루였어요.",
        "ja": "$さん、昨日は#で体が休んだ一日でした。",
        "de": "$, gestern war bei # ein Ruhetag.",
        "en": "$, yesterday was a rest day at #.",
        "zh-Hans": "$，昨天以 # 度过了让身体休息的一天。",
        "zh-Hant": "$，昨天以 # 度過了讓身體休息的一天。"
    },
    {
        "key": "ai_feedback_table_f1104_message",
        "ko": "$님, 어제는 #로 무리하지 않은 하루였어요.",
        "ja": "$さん、昨日は#で無理のない一日でした。",
        "de": "$, gestern bei # war ein Tag ohne Überlastung.",
        "en": "$, yesterday at # was a day without overdoing it.",
        "zh-Hans": "$，昨天以 # 度过了不过度勉强的一天。",
        "zh-Hant": "$，昨天以 # 度過了不過度勉強的一天。"
    },
    {
        "key": "ai_feedback_table_f1105_message",
        "ko": "$님, 어제는 #로 조용한 하루를 보냈어요. 오늘은 몸의 리듬을 되찾아봐요.",
        "ja": "$さん、昨日は#で静かな一日でした。今日は体のリズムを取り戻しましょう。",
        "de": "$, gestern bei # war ein ruhiger Tag. Heute den Rhythmus zurückholen.",
        "en": "$, you had a quiet day at # yesterday. Get your rhythm back today.",
        "zh-Hans": "$，你昨天以 # 度过了安静的一天。今天找回身体节奏吧。",
        "zh-Hant": "$，你昨天以 # 度過了安靜的一天。今天找回身體節奏吧。"
    },
    {
        "key": "ai_feedback_table_f1106_message",
        "ko": "$님, 어제는 #로 잠깐 쉬어간 하루였어요.",
        "ja": "$さん、昨日は#でちょっと休んだ一日でした。",
        "de": "$, gestern bei # war ein kurzer Ruhetag.",
        "en": "$, yesterday at # was a short rest day.",
        "zh-Hans": "$，昨天以 # 是短暂休息的一天。",
        "zh-Hant": "$，昨天以 # 是短暫休息的一天。"
    },
    {
        "key": "ai_feedback_table_f1107_message",
        "ko": "$님, 어제는 #로 컨디션 회복에 집중한 하루였네요.",
        "ja": "$さん、昨日は#でコンディション回復に集中した一日でした。",
        "de": "$, gestern bei # lag der Fokus auf Erholung.",
        "en": "$, yesterday at # you focused on recovery.",
        "zh-Hans": "$，昨天以 # 专注于恢复状态。",
        "zh-Hant": "$，昨天以 # 專注於恢復狀態。"
    },
    {
        "key": "ai_feedback_table_f1108_message",
        "ko": "$님, 어제는 #로 활동량이 낮았어요. 오늘은 조금 더 걸어볼까요?",
        "ja": "$さん、昨日は#で活動量が低めでした。今日はもう少し歩いてみませんか。",
        "de": "$, die Aktivität war gestern bei # niedrig. Heute etwas mehr gehen?",
        "en": "$, activity was low at # yesterday. How about walking a bit more today?",
        "zh-Hans": "$，昨天的活动量为 #，偏低。今天要不要多走一点？",
        "zh-Hant": "$，昨天的活動量為 #，偏低。今天要不要多走一點？"
    },
    {
        "key": "ai_feedback_table_f1109_message",
        "ko": "$님, 어제는 #로 몸이 가벼웠죠? 오늘은 리듬을 다시 올려봐요.",
        "ja": "$さん、昨日は#で体が軽かったですね。今日はリズムを戻しましょう。",
        "de": "$, gestern bei # war der Körper leicht? Heute den Rhythmus wieder anheben.",
        "en": "$, your body was light at # yesterday? Bring the rhythm back up today.",
        "zh-Hans": "$，昨天以 # 身体很轻松吧？今天把节奏再提升起来。",
        "zh-Hant": "$，昨天以 # 身體很輕松吧？今天把節奏再提升起來。"
    },
    {
        "key": "ai_feedback_table_f1110_message",
        "ko": "$님, 어제는 #로 에너지를 비축한 하루였어요.",
        "ja": "$さん、昨日は#でエネルギーを蓄えた一日でした。",
        "de": "$, gestern bei # haben Sie Energie gespeichert.",
        "en": "$, yesterday at # you stored energy for the day.",
        "zh-Hans": "$，昨天以 # 度过了储备能量的一天。",
        "zh-Hant": "$，昨天以 # 度過了儲備能量的一天。"
    },
    {
        "key": "ai_feedback_table_f1201_message",
        "ko": "$님, 어제는 #로 안정적인 하루를 보내셨어요.",
        "ja": "$さん、昨日は#で安定した一日でした。",
        "de": "$, gestern bei # war ein stabiler Tag.",
        "en": "$, you had a stable day at # yesterday.",
        "zh-Hans": "$，你昨天以 # 度过了稳定的一天。",
        "zh-Hant": "$，你昨天以 # 度過了穩定的一天。"
    },
    {
        "key": "ai_feedback_table_f1202_message",
        "ko": "$님, 어제는 #로 꾸준한 리듬을 유지하셨어요. 좋아요!",
        "ja": "$さん、昨日は#で一定のリズムを維持されました。いいですね。",
        "de": "$, gestern bei # haben Sie einen gleichmäßigen Rhythmus gehalten. Gut!",
        "en": "$, you kept a steady rhythm at # yesterday. Nice!",
        "zh-Hans": "$，你昨天以 # 保持了稳定节奏。很好！",
        "zh-Hant": "$，你昨天以 # 保持了穩定節奏。很好！"
    },
    {
        "key": "ai_feedback_table_f1203_message",
        "ko": "$님, 어제는 #로 좋은 흐름이었어요. 지금처럼만 가볼까요?",
        "ja": "$さん、昨日は#で良い流れでした。このまま続けますか。",
        "de": "$, gestern bei # war ein guter Flow. So weitermachen?",
        "en": "$, yesterday at # had a good flow. Keep it up?",
        "zh-Hans": "$，昨天以 # 状态不错。就这样继续下去好吗？",
        "zh-Hant": "$，昨天以 # 狀態不錯。就這樣繼續下去好嗎？"
    },
    {
        "key": "ai_feedback_table_f1204_message",
        "ko": "$님, 어제는 #로 균형 잡힌 하루였어요.",
        "ja": "$さん、昨日は#でバランスの取れた一日でした。",
        "de": "$, gestern bei # war ein ausgewogener Tag.",
        "en": "$, yesterday at # was a balanced day.",
        "zh-Hans": "$，昨天以 # 是平衡的一天。",
        "zh-Hant": "$，昨天以 # 是平衡的一天。"
    },
    {
        "key": "ai_feedback_table_f1205_message",
        "ko": "$님, 어제는 #로 평소와 비슷한 활동량이었어요. 꾸준함이 체력을 만듭니다.",
        "ja": "$さん、昨日は#でいつもと似た活動量でした。続けることが体力を作ります。",
        "de": "$, gestern bei # war die Aktivität wie gewohnt. Kontinuität baut Fitness auf.",
        "en": "$, yesterday at # your activity was similar to usual. Consistency builds fitness.",
        "zh-Hans": "$，昨天以 # 的活动量和平时相近。坚持会造就体能。",
        "zh-Hant": "$，昨天以 # 的活動量和平時相近。堅持會造就體能。"
    },
    {
        "key": "ai_feedback_table_f1206_message",
        "ko": "$님, 어제는 #로 적절한 활동량이었어요.",
        "ja": "$さん、昨日は#で適切な活動量でした。",
        "de": "$, gestern bei # war die Aktivitätsmenge passend.",
        "en": "$, yesterday at # was a good amount of activity.",
        "zh-Hans": "$，昨天以 # 是适当的活动量。",
        "zh-Hant": "$，昨天以 # 是適當的活動量。"
    },
    {
        "key": "ai_feedback_table_f1207_message",
        "ko": "$님, 어제는 #로 무난한 하루를 보내셨어요. 체력이 안정적이에요.",
        "ja": "$さん、昨日は#で穏やかな一日でした。体力は安定しています。",
        "de": "$, gestern bei # war ein ruhiger Tag. Ihre Fitness ist stabil.",
        "en": "$, you had a smooth day at # yesterday. Your fitness is stable.",
        "zh-Hans": "$，你昨天以 # 度过了平稳的一天。体能很稳定。",
        "zh-Hant": "$，你昨天以 # 度過了平穩的一天。體能很穩定。"
    },
    {
        "key": "ai_feedback_table_f1208_message",
        "ko": "$님, 어제는 #로 일정한 페이스를 유지했어요.",
        "ja": "$さん、昨日は#で一定のペースを維持されました。",
        "de": "$, gestern bei # haben Sie ein gleichmäßiges Tempo gehalten.",
        "en": "$, you kept a steady pace at # yesterday.",
        "zh-Hans": "$，昨天以 # 保持了稳定的步调。",
        "zh-Hant": "$，昨天以 # 保持了穩定的步調。"
    },
    {
        "key": "ai_feedback_table_f1209_message",
        "ko": "$님, 어제는 #로 평형감 있는 활동량이었어요.",
        "ja": "$さん、昨日は#でバランスの取れた活動量でした。",
        "de": "$, gestern bei # war die Aktivität gut ausgewogen.",
        "en": "$, yesterday at # your activity was well balanced.",
        "zh-Hans": "$，昨天以 # 活动量很均衡。",
        "zh-Hant": "$，昨天以 # 活動量很均衡。"
    },
    {
        "key": "ai_feedback_table_f1210_message",
        "ko": "$님, 어제는 #로 균형이 잘 잡힌 하루였어요.",
        "ja": "$さん、昨日は#でバランスの良い一日でした。",
        "de": "$, gestern bei # war ein ausgewogener Tag.",
        "en": "$, yesterday at # was a well-balanced day.",
        "zh-Hans": "$，昨天以 # 是平衡良好的一天。",
        "zh-Hant": "$，昨天以 # 是平衡良好的一天。"
    },
    {
        "key": "ai_feedback_table_f1301_message",
        "ko": "$님, 어제는 #로 정말 활발하게 움직이셨어요! 대단해요.",
        "ja": "$さん、昨日は#でとても活発に動かれました。すごいです。",
        "de": "$, gestern bei # haben Sie sich sehr aktiv bewegt. Toll.",
        "en": "$, you moved really actively at # yesterday! Great.",
        "zh-Hans": "$，你昨天以 # 非常活跃地运动了！太棒了。",
        "zh-Hant": "$，你昨天以 # 非常活躍地運動了！太棒了。"
    },
    {
        "key": "ai_feedback_table_f1302_message",
        "ko": "$님, 어제는 #로 에너지가 넘쳤어요. 멋진 하루였네요.",
        "ja": "$さん、昨日は#でエネルギーに満ちた一日でした。",
        "de": "$, gestern bei # waren Sie voller Energie. Schöner Tag.",
        "en": "$, you were full of energy at # yesterday. Nice day.",
        "zh-Hans": "$，昨天以 # 精力充沛。真是美好的一天。",
        "zh-Hant": "$，昨天以 # 精力充沛。真是美好的一天。"
    },
    {
        "key": "ai_feedback_table_f1303_message",
        "ko": "$님, 어제는 #로 목표치를 달성했어요! 훌륭해요.",
        "ja": "$さん、昨日は#で目標を達成されました。素晴らしいです。",
        "de": "$, gestern bei # haben Sie Ihr Ziel erreicht. Gut gemacht.",
        "en": "$, you hit your goal at # yesterday! Well done.",
        "zh-Hans": "$，昨天以 # 达成了目标！做得很棒。",
        "zh-Hant": "$，昨天以 # 達成了目標！做得很棒。"
    },
    {
        "key": "ai_feedback_table_f1304_message",
        "ko": "$님, 어제는 #로 강도 높은 하루였어요.",
        "ja": "$さん、昨日は#で強度の高い一日でした。",
        "de": "$, gestern bei # war ein intensiver Tag.",
        "en": "$, yesterday at # was a high-intensity day.",
        "zh-Hans": "$，昨天以 # 是高强度的一天。",
        "zh-Hant": "$，昨天以 # 是高強度的一天。"
    },
    {
        "key": "ai_feedback_table_f1305_message",
        "ko": "$님, 어제는 #로 체력이 향상된 게 느껴져요.",
        "ja": "$さん、昨日は#で体力の向上が感じられます。",
        "de": "$, gestern bei # spüren Sie die verbesserte Fitness.",
        "en": "$, you can feel your fitness improving at # yesterday.",
        "zh-Hans": "$，昨天以 # 能感受到体能提升。",
        "zh-Hant": "$，昨天以 # 能感受到體能提升。"
    },
    {
        "key": "ai_feedback_table_f1306_message",
        "ko": "$님, 어제는 #로 활동량이 최고 수준이었어요.",
        "ja": "$さん、昨日は#で活動量が最高レベルでした。",
        "de": "$, gestern bei # war die Aktivität auf höchstem Niveau.",
        "en": "$, yesterday at # your activity was top level.",
        "zh-Hans": "$，昨天以 # 活动量达到了最高水平。",
        "zh-Hant": "$，昨天以 # 活動量達到了最高水平。"
    },
    {
        "key": "ai_feedback_table_f1307_message",
        "ko": "$님, 어제는 #로 운동 감각이 완벽했어요.",
        "ja": "$さん、昨日は#で運動感覚が完璧でした。",
        "de": "$, gestern bei # war Ihr Bewegungsgefühl perfekt.",
        "en": "$, your exercise sense was perfect at # yesterday.",
        "zh-Hans": "$，昨天以 # 运动感觉非常完美。",
        "zh-Hant": "$，昨天以 # 運動感覺非常完美。"
    },
    {
        "key": "ai_feedback_table_f1308_message",
        "ko": "$님, 어제는 #로 활기찬 하루를 보내셨네요.",
        "ja": "$さん、昨日は#で活気ある一日でした。",
        "de": "$, gestern bei # war ein energiegeladener Tag.",
        "en": "$, you had an energetic day at # yesterday.",
        "zh-Hans": "$，你昨天以 # 度过了充满活力的一天。",
        "zh-Hant": "$，你昨天以 # 度過了充滿活力的一天。"
    },
    {
        "key": "ai_feedback_table_f1309_message",
        "ko": "$님, 어제는 #로 최상의 컨디션이었어요.",
        "ja": "$さん、昨日は#で最高のコンディションでした。",
        "de": "$, gestern bei # war Ihr bester Zustand.",
        "en": "$, yesterday at # was your best condition.",
        "zh-Hans": "$，昨天以 # 状态最佳。",
        "zh-Hant": "$，昨天以 # 狀態最佳。"
    },
    {
        "key": "ai_feedback_table_f1310_message",
        "ko": "$님, 어제는 #로 정말 에너지가 넘쳤어요! 오늘은 조금 쉬어도 좋아요.",
        "ja": "$さん、昨日は#で本当にエネルギーに満ちていました。今日は少し休んでも大丈夫です。",
        "de": "$, gestern bei # waren Sie voller Energie. Heute etwas kürzerzutreten ist in Ordnung.",
        "en": "$, you were full of energy at # yesterday! It's okay to take it easy today.",
        "zh-Hans": "$，昨天以 # 真是精力充沛！今天稍微休息也没关系。",
        "zh-Hant": "$，昨天以 # 真是精力充沛！今天稍微休息也沒關系。"
    },
    {
        "key": "ai_feedback_table_f1401_message",
        "ko": "$님, 평균 심박수는 &bpm으로 안정적인 하루였어요. 오늘은 몸을 조금 더 움직여볼까요?",
        "ja": "$さん、平均心拍数&bpmで安定した一日でした。今日は体を少し動かしてみませんか。",
        "de": "$, bei durchschnittlich &bpm war es ein stabiler Tag. Heute etwas mehr bewegen?",
        "en": "$, with an average heart rate of &bpm it was a stable day. How about moving a bit more today?",
        "zh-Hans": "$，平均心率为 &bpm，是稳定的一天。今天要不要多动一点身体？",
        "zh-Hant": "$，平均心率為 &bpm，是穩定的一天。今天要不要多動一點身體？"
    },
    {
        "key": "ai_feedback_table_f1402_message",
        "ko": "$님, 어제는 &bpm으로 비교적 조용한 하루였네요. 오늘은 가볍게 몸을 깨워봐요.",
        "ja": "$さん、昨日は&bpmで比較的穏やかな一日でした。今日は軽く体を目覚めさせましょう。",
        "de": "$, gestern bei &bpm war ein ruhiger Tag. Heute den Körper leicht aktivieren.",
        "en": "$, yesterday was a relatively quiet day at &bpm. Wake your body up lightly today.",
        "zh-Hans": "$，昨天以 &bpm 度过了相对安静的一天。今天轻轻唤醒身体吧。",
        "zh-Hant": "$，昨天以 &bpm 度過了相對安靜的一天。今天輕輕喚醒身體吧。"
    },
    {
        "key": "ai_feedback_table_f1403_message",
        "ko": "$님, 평균 &bpm으로 여유 있는 하루를 보냈어요. 오늘은 조금 더 활기차게 걸어보아요.",
        "ja": "$さん、平均&bpmで余裕のある一日でした。今日は少し活気よく歩いてみましょう。",
        "de": "$, bei durchschnittlich &bpm war es ein entspannter Tag. Heute etwas lebhafter gehen.",
        "en": "$, with an average &bpm you had a relaxed day. Walk a bit more lively today.",
        "zh-Hans": "$，平均 &bpm，度过了从容的一天。今天更有活力地走一走吧。",
        "zh-Hant": "$，平均 &bpm，度過了從容的一天。今天更有活力地走一走吧。"
    },
    {
        "key": "ai_feedback_table_f1404_message",
        "ko": "$님, 심박수 &bpm으로 컨디션이 안정적이에요. 오늘은 짧은 운동으로 리듬을 만들어봐요.",
        "ja": "$さん、心拍数&bpmでコンディションは安定しています。今日は短い運動でリズムを作りましょう。",
        "de": "$, bei &bpm ist Ihr Zustand stabil. Heute mit kurzer Bewegung den Rhythmus finden.",
        "en": "$, with &bpm your condition is stable. Build rhythm with a short workout today.",
        "zh-Hans": "$，心率 &bpm，状态很稳定。今天用短时间运动建立节奏吧。",
        "zh-Hant": "$，心率 &bpm，狀態很穩定。今天用短時間運動建立節奏吧。"
    },
    {
        "key": "ai_feedback_table_f1405_message",
        "ko": "$님, 어제의 평균 심박수는 &bpm이에요. 이제 몸이 쉬었으니 조금 더 활동해도 좋아요.",
        "ja": "$さん、昨日の平均心拍数は&bpmでした。体が休んだのでもう少し活動して大丈夫です。",
        "de": "$, gestern war die durchschnittliche Herzfrequenz &bpm. Der Körper hat sich erholt; etwas mehr Aktivität ist okay.",
        "en": "$, yesterday's average heart rate was &bpm. Your body has rested; a bit more activity is fine.",
        "zh-Hans": "$，昨天的平均心率是 &bpm。身体已经休息好了，稍微增加活动也可以。",
        "zh-Hant": "$，昨天的平均心率是 &bpm。身體已經休息好了，稍微增加活動也可以。"
    },
    {
        "key": "ai_feedback_table_f1406_message",
        "ko": "$님, 평균 &bpm으로 편안한 하루였네요. 오늘은 가볍게 움직이며 활력을 더해봐요.",
        "ja": "$さん、平均&bpmで心地よい一日でした。今日は軽く動いて活力を足しましょう。",
        "de": "$, bei durchschnittlich &bpm war es ein angenehmer Tag. Heute mit leichter Bewegung Energie tanken.",
        "en": "$, with an average &bpm it was a comfortable day. Add some energy by moving lightly today.",
        "zh-Hans": "$，平均 &bpm，是舒适的一天。今天轻松活动，为自己增加活力吧。",
        "zh-Hant": "$，平均 &bpm，是舒適的一天。今天輕松活動，為自己增加活力吧。"
    },
    {
        "key": "ai_feedback_table_f1407_message",
        "ko": "$님, 심박수 &bpm으로 안정적인 리듬이었어요. 오늘은 조금 더 활발하게 움직여볼까요?",
        "ja": "$さん、心拍数&bpmで安定したリズムでした。今日はもう少し活発に動いてみませんか。",
        "de": "$, bei &bpm war es ein stabiler Rhythmus. Heute etwas mehr bewegen?",
        "en": "$, with &bpm it was a stable rhythm. How about moving a bit more today?",
        "zh-Hans": "$，心率 &bpm，节奏很稳定。今天要不要更活跃地动一动？",
        "zh-Hant": "$，心率 &bpm，節奏很穩定。今天要不要更活躍地動一動？"
    },
    {
        "key": "ai_feedback_table_f1408_message",
        "ko": "$님, 어제는 몸이 충분히 회복된 하루였어요. 오늘은 조금 더 몸을 써보는 게 좋아요.",
        "ja": "$さん、昨日は体が十分回復した一日でした。今日はもう少し体を使うと良いです。",
        "de": "$, gestern hat sich der Körper gut erholt. Heute etwas mehr Bewegung ist gut.",
        "en": "$, yesterday your body recovered well. It's good to use your body a bit more today.",
        "zh-Hans": "$，昨天身体恢复得很充分。今天可以再多活动一点。",
        "zh-Hant": "$，昨天身體恢復得很充分。今天可以再多活動一點。"
    },
    {
        "key": "ai_feedback_table_f1409_message",
        "ko": "$님, 평균 &bpm으로 조용히 에너지를 충전했어요. 오늘은 활동량을 늘려볼까요?",
        "ja": "$さん、平均&bpmで静かにエネルギーを充電しました。今日は活動量を増やしてみませんか。",
        "de": "$, bei durchschnittlich &bpm haben Sie still Energie getankt. Heute die Aktivität steigern?",
        "en": "$, with an average &bpm you recharged quietly. How about increasing activity today?",
        "zh-Hans": "$，平均 &bpm，安静地补充了能量。今天要不要增加活动量？",
        "zh-Hant": "$，平均 &bpm，安靜地補充了能量。今天要不要增加活動量？"
    },
    {
        "key": "ai_feedback_table_f1410_message",
        "ko": "$님, 심박수 &bpm으로 편안한 하루였네요. 오늘은 리듬을 높여 에너지를 채워봐요.",
        "ja": "$さん、心拍数&bpmで心地よい一日でした。今日はリズムを上げてエネルギーを満たしましょう。",
        "de": "$, bei &bpm war es ein angenehmer Tag. Heute den Rhythmus anheben und Energie tanken.",
        "en": "$, with &bpm it was a comfortable day. Raise the rhythm and fill up with energy today.",
        "zh-Hans": "$，心率 &bpm，是舒适的一天。今天提高节奏，补充能量吧。",
        "zh-Hant": "$，心率 &bpm，是舒適的一天。今天提高節奏，補充能量吧。"
    },
    {
        "key": "ai_feedback_table_f1501_message",
        "ko": "$님, 평균 심박수는 &bpm으로 적당한 활동을 하셨네요. 오늘도 그 리듬을 이어가요.",
        "ja": "$さん、平均心拍数&bpmで適度な活動でした。今日もそのリズムを続けましょう。",
        "de": "$, bei durchschnittlich &bpm war die Aktivität passend. Heute denselben Rhythmus beibehalten.",
        "en": "$, with an average &bpm you had a good amount of activity. Keep that rhythm today.",
        "zh-Hans": "$，平均心率为 &bpm，活动量很适当。今天也继续这个节奏。",
        "zh-Hant": "$，平均心率為 &bpm，活動量很適當。今天也繼續這個節奏。"
    },
    {
        "key": "ai_feedback_table_f1502_message",
        "ko": "$님, 어제는 &bpm으로 활기찬 하루였어요. 오늘도 비슷한 페이스로 가볼까요?",
        "ja": "$さん、昨日は&bpmで活気ある一日でした。今日も同じペースでいきますか。",
        "de": "$, gestern bei &bpm war ein energiegeladener Tag. Heute gleiches Tempo?",
        "en": "$, yesterday at &bpm was an energetic day. Same pace today?",
        "zh-Hans": "$，昨天以 &bpm 度过了充满活力的一天。今天也用相似的步调继续吗？",
        "zh-Hant": "$，昨天以 &bpm 度過了充滿活力的一天。今天也用相似的步調繼續嗎？"
    },
    {
        "key": "ai_feedback_table_f1503_message",
        "ko": "$님, 평균 &bpm으로 좋은 움직임을 보여주셨어요. 오늘도 꾸준히 이어가봐요.",
        "ja": "$さん、平均&bpmで良い動きでした。今日も続けましょう。",
        "de": "$, bei durchschnittlich &bpm war die Bewegung gut. Heute so weitermachen.",
        "en": "$, with an average &bpm you showed good movement. Keep it up today.",
        "zh-Hans": "$，平均 &bpm，展现了良好的活动表现。今天也坚持下去吧。",
        "zh-Hant": "$，平均 &bpm，展現了良好的活動表現。今天也堅持下去吧。"
    },
    {
        "key": "ai_feedback_table_f1504_message",
        "ko": "$님, 심박수 &bpm으로 체력이 안정적으로 유지되고 있어요. 오늘도 자신 있게 나아가요.",
        "ja": "$さん、心拍数&bpmで体力は安定して維持されています。今日も自信を持って進みましょう。",
        "de": "$, bei &bpm ist Ihre Fitness stabil. Heute mit Zuversicht weitermachen.",
        "en": "$, with &bpm your fitness is stable. Move forward with confidence today.",
        "zh-Hans": "$，心率 &bpm，体能保持稳定。今天也自信地前进吧。",
        "zh-Hant": "$，心率 &bpm，體能保持穩定。今天也自信地前進吧。"
    },
    {
        "key": "ai_feedback_table_f1505_message",
        "ko": "$님, 어제는 평균 &bpm으로 활발했어요. 오늘은 조금 더 도전해봐도 좋겠어요.",
        "ja": "$さん、昨日は平均&bpmで活発でした。今日はもう少し挑戦しても良いです。",
        "de": "$, gestern bei durchschnittlich &bpm waren Sie aktiv. Heute dürfen Sie sich etwas mehr fordern.",
        "en": "$, you were active with an average &bpm yesterday. You can challenge a bit more today.",
        "zh-Hans": "$，昨天平均 &bpm，很活跃。今天可以再挑战一点。",
        "zh-Hant": "$，昨天平均 &bpm，很活躍。今天可以再挑戰一點。"
    },
    {
        "key": "ai_feedback_table_f1506_message",
        "ko": "$님, 심박수 &bpm으로 활동량이 적당했어요. 오늘은 유연성 운동을 더해볼까요?",
        "ja": "$さん、心拍数&bpmで活動量は適度でした。今日は柔軟性運動を足してみませんか。",
        "de": "$, bei &bpm war die Aktivität gut. Heute Dehnübungen ergänzen?",
        "en": "$, with &bpm your activity was good. How about adding flexibility exercise today?",
        "zh-Hans": "$，心率 &bpm，活动量很适当。今天要不要加上柔韧性运动？",
        "zh-Hant": "$，心率 &bpm，活動量很適當。今天要不要加上柔韌性運動？"
    },
    {
        "key": "ai_feedback_table_f1507_message",
        "ko": "$님, 어제는 &bpm으로 몸이 잘 반응했어요. 오늘도 꾸준히 리듬을 유지해요.",
        "ja": "$さん、昨日は&bpmで体がよく反応していました。今日もリズムを維持しましょう。",
        "de": "$, gestern bei &bpm hat der Körper gut reagiert. Heute den Rhythmus beibehalten.",
        "en": "$, your body responded well at &bpm yesterday. Keep the rhythm today.",
        "zh-Hans": "$，昨天以 &bpm 身体反应很好。今天也保持稳定节奏吧。",
        "zh-Hant": "$，昨天以 &bpm 身體反應很好。今天也保持穩定節奏吧。"
    },
    {
        "key": "ai_feedback_table_f1508_message",
        "ko": "$님, 평균 &bpm으로 하루 종일 활기찼어요. 오늘은 강도보단 지속이 좋아요.",
        "ja": "$さん、平均&bpmで一日中活気がありました。今日は強度より持続がおすすめです。",
        "de": "$, bei durchschnittlich &bpm waren Sie den Tag über aktiv. Heute Dauer vor Intensität.",
        "en": "$, with an average &bpm you were energetic all day. Today, duration over intensity.",
        "zh-Hans": "$，平均 &bpm，一整天都很有活力。今天比起强度，更适合重视持续时间。",
        "zh-Hant": "$，平均 &bpm，一整天都很有活力。今天比起強度，更適合重視持續時間。"
    },
    {
        "key": "ai_feedback_table_f1509_message",
        "ko": "$님, 어제의 심박수는 &bpm이었어요. 활동량이 좋았어요! 오늘은 스트레칭으로 마무리해요.",
        "ja": "$さん、昨日の心拍数は&bpmでした。活動量は良かったです。今日はストレッチで締めましょう。",
        "de": "$, gestern war die Herzfrequenz &bpm. Gute Aktivität. Heute mit Dehnen abschließen.",
        "en": "$, yesterday's heart rate was &bpm. Good activity! Finish with stretching today.",
        "zh-Hans": "$，昨天的心率是 &bpm。活动量很好！今天用拉伸收尾吧。",
        "zh-Hant": "$，昨天的心率是 &bpm。活動量很好！今天用拉伸收尾吧。"
    },
    {
        "key": "ai_feedback_table_f1510_message",
        "ko": "$님, 평균 &bpm으로 이상적인 활동량이에요. 오늘도 즐겁게 움직여요.",
        "ja": "$さん、平均&bpmで理想的な活動量です。今日も楽しく動きましょう。",
        "de": "$, bei durchschnittlich &bpm ist die Aktivität ideal. Heute in Bewegung bleiben und genießen.",
        "en": "$, with an average &bpm your activity is ideal. Keep moving and enjoy today.",
        "zh-Hans": "$，平均 &bpm，活动量很理想。今天也愉快地动起来吧。",
        "zh-Hant": "$，平均 &bpm，活動量很理想。今天也愉快地動起來吧。"
    },
    {
        "key": "ai_feedback_table_f1601_message",
        "ko": "$님, 평균 심박수는 &bpm으로 활발한 하루를 보냈네요. 오늘은 몸을 조금 쉬게 해주세요.",
        "ja": "$さん、平均心拍数&bpmで活発な一日でした。今日は体を少し休めてください。",
        "de": "$, bei durchschnittlich &bpm war es ein aktiver Tag. Heute dem Körper etwas Ruhe gönnen.",
        "en": "$, with an average &bpm you had an active day. Give your body some rest today.",
        "zh-Hans": "$，平均心率为 &bpm，度过了活跃的一天。今天让身体稍微休息一下吧。",
        "zh-Hant": "$，平均心率為 &bpm，度過了活躍的一天。今天讓身體稍微休息一下吧。"
    },
    {
        "key": "ai_feedback_table_f1602_message",
        "ko": "$님, 어제는 &bpm으로 신체 활동이 많았어요. 오늘은 회복을 위한 시간을 가져요.",
        "ja": "$さん、昨日は&bpmで身体活動が多かったです。今日は回復の時間を取りましょう。",
        "de": "$, gestern bei &bpm war die körperliche Aktivität hoch. Heute Zeit zur Erholung nehmen.",
        "en": "$, you had a lot of physical activity at &bpm yesterday. Take time to recover today.",
        "zh-Hans": "$，昨天以 &bpm 进行了较多身体活动。今天留出恢复时间吧。",
        "zh-Hant": "$，昨天以 &bpm 進行了較多身體活動。今天留出恢復時間吧。"
    },
    {
        "key": "ai_feedback_table_f1603_message",
        "ko": "$님, 평균 &bpm으로 활발하게 움직이셨네요. 오늘은 가벼운 스트레칭으로 마무리해요.",
        "ja": "$さん、平均&bpmで活発に動かれました。今日は軽いストレッチで締めましょう。",
        "de": "$, gestern bei &bpm haben Sie sich aktiv bewegt. Heute mit leichtem Dehnen abschließen.",
        "en": "$, you moved actively at &bpm yesterday. Finish with light stretching today.",
        "zh-Hans": "$，平均 &bpm，昨天活动得很积极。今天用轻度拉伸收尾吧。",
        "zh-Hant": "$，平均 &bpm，昨天活動得很積極。今天用輕度拉伸收尾吧。"
    },
    {
        "key": "ai_feedback_table_f1604_message",
        "ko": "$님, 어제의 심박수는 &bpm이에요. 몸이 수고했어요. 오늘은 천천히 회복해요.",
        "ja": "$さん、昨日の心拍数は&bpmでした。体がよく頑張りました。今日はゆっくり回復しましょう。",
        "de": "$, gestern war die Herzfrequenz &bpm. Der Körper hat gearbeitet. Heute langsam erholen.",
        "en": "$, yesterday's heart rate was &bpm. Your body worked hard. Recover slowly today.",
        "zh-Hans": "$，昨天的心率是 &bpm。身体辛苦了。今天慢慢恢复吧。",
        "zh-Hant": "$，昨天的心率是 &bpm。身體辛苦了。今天慢慢恢復吧。"
    },
    {
        "key": "ai_feedback_table_f1605_message",
        "ko": "$님, 심박수 &bpm으로 활동량이 높았어요. 오늘은 휴식으로 에너지를 다시 채워봐요.",
        "ja": "$さん、心拍数&bpmで活動量が高かったです。今日は休息でエネルギーを充電しましょう。",
        "de": "$, bei &bpm war die Aktivität hoch. Heute mit Ruhe wieder aufladen.",
        "en": "$, with &bpm your activity was high. Recharge with rest today.",
        "zh-Hans": "$，心率 &bpm，活动量较高。今天通过休息重新补充能量吧。",
        "zh-Hant": "$，心率 &bpm，活動量較高。今天通過休息重新補充能量吧。"
    },
    {
        "key": "ai_feedback_table_f1606_message",
        "ko": "$님, 평균 &bpm으로 활기찬 하루였어요. 오늘은 몸의 피로를 풀어주세요.",
        "ja": "$さん、平均&bpmで活気ある一日でした。今日は体の疲れをほぐしてください。",
        "de": "$, bei durchschnittlich &bpm war es ein energiegeladener Tag. Heute die Müdigkeit lösen.",
        "en": "$, with an average &bpm it was an energetic day. Ease fatigue today.",
        "zh-Hans": "$，平均 &bpm，是充满活力的一天。今天请缓解身体疲劳。",
        "zh-Hant": "$，平均 &bpm，是充滿活力的一天。今天請緩解身體疲勞。"
    },
    {
        "key": "ai_feedback_table_f1607_message",
        "ko": "$님, 어제는 많이 움직이셨네요! 심박수 &bpm으로 오늘은 회복이 필요해요.",
        "ja": "$さん、昨日はよく動かれました。心拍数&bpmで今日は回復が必要です。",
        "de": "$, gestern haben Sie sich viel bewegt. Bei &bpm brauchen Sie heute Erholung.",
        "en": "$, you moved a lot yesterday! With &bpm you need recovery today.",
        "zh-Hans": "$，昨天运动了很多！心率 &bpm，今天需要恢复。",
        "zh-Hant": "$，昨天運動了很多！心率 &bpm，今天需要恢復。"
    },
    {
        "key": "ai_feedback_table_f1608_message",
        "ko": "$님, 평균 &bpm으로 몸이 꽤 바빴던 하루였어요. 오늘은 조금 쉬어가요.",
        "ja": "$さん、平均&bpmで体がかなり忙しい一日でした。今日は少し休みましょう。",
        "de": "$, bei durchschnittlich &bpm war der Körper gestern beschäftigt. Heute etwas kürzerzutreten.",
        "en": "$, with an average &bpm your body was busy yesterday. Take it easy today.",
        "zh-Hans": "$，平均 &bpm，昨天身体相当忙碌。今天稍微休息一下吧。",
        "zh-Hant": "$，平均 &bpm，昨天身體相當忙碌。今天稍微休息一下吧。"
    },
    {
        "key": "ai_feedback_table_f1609_message",
        "ko": "$님, 심박수 &bpm으로 컨디션이 높았어요. 오늘은 낮은 강도의 운동으로 이어가요.",
        "ja": "$さん、心拍数&bpmでコンディションは高めでした。今日は低強度の運動で続けましょう。",
        "de": "$, bei &bpm war der Zustand hoch. Heute mit geringerer Intensität weitermachen.",
        "en": "$, with &bpm your condition was high. Continue with lower intensity today.",
        "zh-Hans": "$，心率 &bpm，状态很高。今天用低强度运动继续吧。",
        "zh-Hant": "$，心率 &bpm，狀態很高。今天用低強度運動繼續吧。"
    },
    {
        "key": "ai_feedback_table_f1610_message",
        "ko": "$님, 어제는 정말 활발했어요! 평균 &bpm으로 오늘은 휴식이 어울려요.",
        "ja": "$さん、昨日は本当に活発でした。平均&bpmで今日は休息が合います。",
        "de": "$, gestern waren Sie sehr aktiv. Bei durchschnittlich &bpm passt heute Ruhe.",
        "en": "$, you were really active yesterday! With an average &bpm, rest suits you today.",
        "zh-Hans": "$，昨天真的很活跃！平均 &bpm，今天适合休息。",
        "zh-Hant": "$，昨天真的很活躍！平均 &bpm，今天適合休息。"
    },
    {
        "key": "all",
        "ko": "전체",
        "ja": "全体",
        "de": "Alle",
        "en": "All",
        "zh-Hans": "全部",
        "zh-Hant": "全部"
    },
    {
        "key": "all_didim_h_w",
        "ko": "전체 디딤H/W",
        "ja": "Didim H/W全体",
        "de": "Alle Didim H/W",
        "en": "All Didim H/W",
        "zh-Hans": "全部 Didim H/W",
        "zh-Hant": "全部 Didim H/W"
    },
    {
        "key": "all_excluding_deleted",
        "ko": "삭제 제외한 전체",
        "ja": "削除を除く全体",
        "de": "Alle (ohne gelöschte)",
        "en": "All (excluding deleted)",
        "zh-Hans": "全部（不含已删除）",
        "zh-Hant": "全部（不含已刪除）"
    },
    {
        "key": "all_organizations",
        "ko": "전체 기관",
        "ja": "全機関",
        "de": "Alle Organisationen",
        "en": "All organizations",
        "zh-Hans": "全部机构",
        "zh-Hant": "全部機構"
    },
    {
        "key": "all_period",
        "ko": "기간 전체",
        "ja": "期間全体",
        "de": "Gesamtzeitraum",
        "en": "All period",
        "zh-Hans": "全部期间",
        "zh-Hant": "全部期間"
    },
    {
        "key": "all_types",
        "ko": "유형 전체",
        "ja": "タイプ全体",
        "de": "Alle Typen",
        "en": "All types",
        "zh-Hans": "全部类型",
        "zh-Hant": "全部類型"
    },
    {
        "key": "already_exists",
        "ko": "이미 존재하는 아이디입니다.",
        "ja": "このIDは既に使用されています。",
        "de": "Existiert bereits.",
        "en": "Already exists.",
        "zh-Hans": "已存在。",
        "zh-Hant": "已存在。"
    },
    {
        "key": "already_joined_this_organization",
        "ko": "이미 가입된 소속입니다.",
        "ja": "既に加入している所属です。",
        "de": "Dieser Organisation bereits beigetreten.",
        "en": "Already joined this organization.",
        "zh-Hans": "已加入该机构。",
        "zh-Hant": "已加入該機構。"
    },
    {
        "key": "am",
        "ko": "오전",
        "ja": "午前",
        "de": "AM",
        "en": "AM",
        "zh-Hans": "上午",
        "zh-Hant": "上午"
    },
    {
        "key": "an_account_already_exists_we_will_link_it_with_your_sns_account",
        "ko": "이미 존재하는 일반 계정입니다. 기존 계정과 SNS 계정을 연동하겠습니다.",
        "ja": "既存の一般アカウントがあります。SNSアカウントと連携します。",
        "de": "Ein Konto existiert bereits. Wir verknüpfen es mit Ihrem SNS-Konto.",
        "en": "An account already exists. We will link it with your SNS account.",
        "zh-Hans": "已存在普通账号。将与现有账号关联 SNS 账号。",
        "zh-Hant": "已存在普通帳號。將與現有帳號關聯 SNS 帳號。"
    },
    {
        "key": "an_error_occurred",
        "ko": "오류가 발생했습니다.",
        "ja": "エラーが発生しました。",
        "de": "Ein Fehler ist aufgetreten.",
        "en": "An error occurred.",
        "zh-Hans": "发生错误。",
        "zh-Hant": "發生錯誤。"
    },
    {
        "key": "an_error_occurred_while_loading_data_message",
        "ko": "데이터를 불러오는 중 오류가 발생했습니다.",
        "ja": "データの読み込み中にエラーが発生しました。",
        "de": "Beim Laden der Daten ist ein Fehler aufgetreten.",
        "en": "An error occurred while loading data.",
        "zh-Hans": "加载数据时发生错误。",
        "zh-Hant": "載入資料時發生錯誤。"
    },
    {
        "key": "an_error_occurred_while_processing_please_try_again",
        "ko": "처리 중 오류가 발생했습니다. 다시 시도해주세요.",
        "ja": "処理中にエラーが発生しました。もう一度お試しください。",
        "de": "Bei der Verarbeitung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "en": "An error occurred while processing. Please try again.",
        "zh-Hans": "处理时发生错误。请重试。",
        "zh-Hant": "處理時發生錯誤。請重試。"
    },
    {
        "key": "an_error_occurred_while_processing_the_qr_code",
        "ko": "QR 코드 처리 중 오류가 발생했습니다.",
        "ja": "QRコード処理中にエラーが発生しました。",
        "de": "Beim Verarbeiten des QR-Codes ist ein Fehler aufgetreten.",
        "en": "An error occurred while processing the QR code.",
        "zh-Hans": "处理二维码时发生错误。",
        "zh-Hant": "處理QR 碼時發生錯誤。"
    },
    {
        "key": "an_error_occurred_while_searching",
        "ko": "검색 중 오류가 발생했습니다.",
        "ja": "検索中にエラーが発生しました。",
        "de": "Bei der Suche ist ein Fehler aufgetreten.",
        "en": "An error occurred while searching.",
        "zh-Hans": "搜索时发生错误。",
        "zh-Hant": "搜尋時發生錯誤。"
    },
    {
        "key": "an_error_occurred_while_searching_organizations",
        "ko": "기관 검색 중 오류가 발생했습니다.",
        "ja": "機関検索中にエラーが発生しました。",
        "de": "Bei der Suche nach Organisationen ist ein Fehler aufgetreten.",
        "en": "An error occurred while searching organizations.",
        "zh-Hans": "搜索机构时发生错误。",
        "zh-Hant": "搜尋機構時發生錯誤。"
    },
    {
        "key": "and",
        "ko": "과",
        "ja": "と",
        "de": "und",
        "en": "and",
        "zh-Hans": "和",
        "zh-Hant": "和"
    },
    {
        "key": "app_version",
        "ko": "앱버전",
        "ja": "アプリバージョン",
        "de": "App-Version",
        "en": "App version",
        "zh-Hans": "应用版本",
        "zh-Hant": "App版本"
    },
    {
        "key": "application",
        "ko": "신청",
        "ja": "申請",
        "de": "Antrag",
        "en": "application",
        "zh-Hans": "申请",
        "zh-Hant": "申請"
    },
    {
        "key": "application_date",
        "ko": "가입신청일",
        "ja": "登録申請日",
        "de": "Antragsdatum",
        "en": "Application date",
        "zh-Hans": "申请日期",
        "zh-Hant": "申請日期"
    },
    {
        "key": "application_end_date",
        "ko": "응모마감일",
        "ja": "応募締切日",
        "de": "Bewerbungsende",
        "en": "Application end date",
        "zh-Hans": "报名截止日期",
        "zh-Hant": "報名截止日期"
    },
    {
        "key": "application_has_ended",
        "ko": "응모가 마감되었습니다.",
        "ja": "応募は終了しました。",
        "de": "Die Bewerbung ist beendet.",
        "en": "Application has ended.",
        "zh-Hans": "报名已结束。",
        "zh-Hant": "報名已結束。"
    },
    {
        "key": "application_has_not_started_yet",
        "ko": "응모가 시작 전입니다.",
        "ja": "応募は開始前です。",
        "de": "Die Bewerbung hat noch nicht begonnen.",
        "en": "Application has not started yet.",
        "zh-Hans": "报名尚未开始。",
        "zh-Hant": "報名尚未開始。"
    },
    {
        "key": "application_is_ongoing",
        "ko": "응모가 진행중입니다.",
        "ja": "応募は進行中です。",
        "de": "Die Bewerbung läuft.",
        "en": "Application is ongoing.",
        "zh-Hans": "报名进行中。",
        "zh-Hant": "報名進行中。"
    },
    {
        "key": "application_point",
        "ko": "응모포인트",
        "ja": "応募ポイント",
        "de": "Bewerbungspunkte",
        "en": "Application points",
        "zh-Hans": "报名积分",
        "zh-Hant": "報名積分"
    },
    {
        "key": "application_start_date",
        "ko": "응모게시일",
        "ja": "応募開始日",
        "de": "Bewerbungsbeginn",
        "en": "Application start date",
        "zh-Hans": "报名开始日期",
        "zh-Hant": "報名開始日期"
    },
    {
        "key": "apply",
        "ko": "응모",
        "ja": "応募",
        "de": "Bewerben",
        "en": "Apply",
        "zh-Hans": "报名",
        "zh-Hant": "報名"
    },
    {
        "key": "apply_dark_theme",
        "ko": "다크 테마 적용",
        "ja": "ダークテーマを適用",
        "de": "Dunkles Design anwenden",
        "en": "Apply Dark Theme",
        "zh-Hans": "应用深色主题",
        "zh-Hant": "應用深色主題"
    },
    {
        "key": "apply_light_theme",
        "ko": "라이트 테마 적용",
        "ja": "ライトテーマを適用",
        "de": "Helles Design anwenden",
        "en": "Apply Light Theme",
        "zh-Hans": "应用浅色主题",
        "zh-Hant": "應用淺色主題"
    },
    {
        "key": "apply_title",
        "ko": "응모하기",
        "ja": "応募する",
        "de": "Bewerben",
        "en": "Apply",
        "zh-Hans": "报名",
        "zh-Hant": "報名"
    },
    {
        "key": "approve_failed",
        "ko": "승인에 실패했습니다.",
        "ja": "承認に失敗しました。",
        "de": "Genehmigung fehlgeschlagen.",
        "en": "Approve failed.",
        "zh-Hans": "批准失败。",
        "zh-Hant": "批准失敗。"
    },
    {
        "key": "approve_with_email",
        "ko": "승인 후 이메일 발송",
        "ja": "承認後メール送信",
        "de": "E-Mail nach Genehmigung senden",
        "en": "Send email after approval",
        "zh-Hans": "批准后发送电子邮件",
        "zh-Hant": "批准後發送電子郵件"
    },
    {
        "key": "are_you_sure_you_want_to_delete",
        "ko": "정말 삭제하시겠습니까?",
        "ja": "本当に削除しますか？",
        "de": "Möchten Sie wirklich löschen?",
        "en": "Are you sure you want to delete?",
        "zh-Hans": "确定要删除吗？",
        "zh-Hant": "確定要刪除嗎？"
    },
    {
        "key": "as_of_month_year",
        "ko": "{{year}}년 {{month}}월 기준",
        "ja": "{{year}}年{{month}}月 基準",
        "de": "Stand {{month}}.{{year}}",
        "en": "As of {{month}}/{{year}}",
        "zh-Hans": "截至 {{year}}年 {{month}}月",
        "zh-Hant": "截至 {{year}}年 {{month}}月"
    },
    {
        "key": "attach_photo",
        "ko": "사진첨부",
        "ja": "写真添付",
        "de": "Foto anhängen",
        "en": "Attach photo",
        "zh-Hans": "附加照片",
        "zh-Hant": "附加照片"
    },
    {
        "key": "attach_post_image",
        "ko": "게시 이미지 첨부",
        "ja": "投稿画像添付",
        "de": "Beitragsbild anhängen",
        "en": "Attach post image",
        "zh-Hans": "附加帖子图片",
        "zh-Hant": "附加貼文圖片"
    },
    {
        "key": "attachment",
        "ko": "첨부서류",
        "ja": "添付書類",
        "de": "Anhang",
        "en": "Attachment",
        "zh-Hans": "附件材料",
        "zh-Hant": "附件材料"
    },
    {
        "key": "attachment_file",
        "ko": "첨부파일",
        "ja": "添付ファイル",
        "de": "Anhangdatei",
        "en": "Attachment file",
        "zh-Hans": "附件文件",
        "zh-Hant": "附件檔案"
    },
    {
        "key": "author",
        "ko": "작성자",
        "ja": "作成者",
        "de": "Autor",
        "en": "Author",
        "zh-Hans": "作者",
        "zh-Hant": "作者"
    },
    {
        "key": "auto_filled_from_zip_code",
        "ko": "우편번호로 자동입력",
        "ja": "郵便番号で自動入力",
        "de": "Automatisch ausgefüllt anhand der Postleitzahl",
        "en": "Auto-filled from zip code",
        "zh-Hans": "根据邮政编码自动填写",
        "zh-Hant": "根據郵遞區號自動填寫"
    },
    {
        "key": "auto_filled_when_organization_type_is_edited",
        "ko": "기관유형 편집되면 자동입력",
        "ja": "機関タイプ編集時に自動入力",
        "de": "Automatisch ausgefüllt bei Änderung des Organisationstyps",
        "en": "Auto-filled when organization type is edited",
        "zh-Hans": "编辑机构类型后自动填写",
        "zh-Hant": "編輯機構類型後自動填寫"
    },
    {
        "key": "available_points",
        "ko": "가용포인트",
        "ja": "利用可能ポイント",
        "de": "Verfügbare Punkte",
        "en": "Available points",
        "zh-Hans": "可用积分",
        "zh-Hant": "可用積分"
    },
    {
        "key": "average",
        "ko": "평균",
        "ja": "平均",
        "de": "Durchschnitt",
        "en": "Average",
        "zh-Hans": "平均",
        "zh-Hant": "平均"
    },
    {
        "key": "average_steps",
        "ko": "평균발디딤수",
        "ja": "平均歩数",
        "de": "Durchschnittliche Schritte",
        "en": "Average steps",
        "zh-Hans": "平均步数",
        "zh-Hant": "平均步數"
    },
    {
        "key": "balance",
        "ko": "평형성",
        "ja": "バランス",
        "de": "Balance",
        "en": "Balance",
        "zh-Hans": "平衡性",
        "zh-Hant": "平衡性"
    },
    {
        "key": "basic_info",
        "ko": "기본정보",
        "ja": "基本情報",
        "de": "Grundinformationen",
        "en": "Basic info",
        "zh-Hans": "基本信息",
        "zh-Hant": "基本資訊"
    },
    {
        "key": "based_on_cumulative_experience",
        "ko": "누적경험치 기준",
        "ja": "累計経験値基準",
        "de": "Basierend auf kumulativer Erfahrung",
        "en": "Based on cumulative experience",
        "zh-Hans": "基于累计经验值",
        "zh-Hant": "基於累計經驗值"
    },
    {
        "key": "based_on_cumulative_experience_for_year_month",
        "ko": "{{year}}년 {{month}}월 누적경험치 기준",
        "ja": "{{year}}年{{month}}月累計経験値基準",
        "de": "Basierend auf kumulativer Erfahrung für {{year}}-{{month}}",
        "en": "Based on cumulative experience for {{year}}-{{month}}",
        "zh-Hans": "基于 {{year}}年 {{month}}月累计经验值",
        "zh-Hant": "基於 {{year}}年 {{month}}月累計經驗值"
    },
    {
        "key": "berlin_special_city",
        "ko": "베를린특별시",
        "ja": "ベルリン特別市",
        "de": "Berlin (Stadt)",
        "en": "Berlin",
        "zh-Hans": "柏林",
        "zh-Hant": "柏林"
    },
    {
        "key": "bielefeld_metropolitan_city",
        "ko": "빌레펠트",
        "ja": "ビーレフェルト",
        "de": "Bielefeld",
        "en": "Bielefeld",
        "zh-Hans": "比勒费尔德",
        "zh-Hant": "比勒費爾德"
    },
    {
        "key": "birth_date",
        "ko": "생년월일",
        "ja": "生年月日",
        "de": "Geburtsdatum",
        "en": "Birth date",
        "zh-Hans": "出生日期",
        "zh-Hant": "出生日期"
    },
    {
        "key": "bonn_metropolitan_city",
        "ko": "본",
        "ja": "ボン",
        "de": "Bonn",
        "en": "Bonn",
        "zh-Hans": "波恩",
        "zh-Hant": "波恩"
    },
    {
        "key": "bpm",
        "ko": "bpm",
        "ja": "bpm",
        "de": "bpm",
        "en": "bpm",
        "zh-Hans": "bpm",
        "zh-Hant": "bpm"
    },
    {
        "key": "brain_training",
        "ko": "두뇌훈련",
        "ja": "脳トレーニング",
        "de": "Gehirntraining",
        "en": "Brain training",
        "zh-Hans": "脑力训练",
        "zh-Hant": "腦力訓練"
    },
    {
        "key": "busan",
        "ko": "부산",
        "ja": "釜山",
        "de": "Busan",
        "en": "Busan",
        "zh-Hans": "釜山",
        "zh-Hant": "釜山"
    },
    {
        "key": "busan_metropolitan_city",
        "ko": "부산광역시",
        "ja": "釜山広域市",
        "de": "Metropole Busan",
        "en": "Busan Metropolitan City",
        "zh-Hans": "釜山广域市",
        "zh-Hant": "釜山廣域市"
    },
    {
        "key": "business_registration_or_employment_certificate",
        "ko": "사업자등록증 또는 재직증명서",
        "ja": "事業者登録証または在職証明書",
        "de": "Gewerbeanmeldung oder Beschäftigungsnachweis",
        "en": "Business registration or employment certificate",
        "zh-Hans": "营业执照或在职证明",
        "zh-Hant": "營業執照或在職證明"
    },
    {
        "key": "calories",
        "ko": "칼로리",
        "ja": "カロリー",
        "de": "Kalorien",
        "en": "Calories",
        "zh-Hans": "卡路里",
        "zh-Hant": "卡路里"
    },
    {
        "key": "camera_access_permission_is_required",
        "ko": "카메라 접근 권한이 필요합니다.",
        "ja": "カメラへのアクセス権限が必要です。",
        "de": "Kamerazugriff ist erforderlich.",
        "en": "Camera access permission is required.",
        "zh-Hans": "需要相机访问权限。",
        "zh-Hant": "需要相機存取權限。"
    },
    {
        "key": "camera_capture",
        "ko": "촬영",
        "ja": "撮影",
        "de": "Aufnehmen",
        "en": "Capture",
        "zh-Hans": "拍摄",
        "zh-Hant": "拍攝"
    },
    {
        "key": "camera_capture_failed_try_again",
        "ko": "카메라 촬영에 실패했습니다. 다시 시도해주세요.",
        "ja": "カメラの撮影に失敗しました。もう一度お試しください。",
        "de": "Kameraaufnahme fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "en": "Camera capture failed. Please try again.",
        "zh-Hans": "相机拍摄失败。请重试。",
        "zh-Hant": "相機拍攝失敗。請重試。"
    },
    {
        "key": "camera_is_in_use_by_another_app",
        "ko": "카메라가 다른 앱에서 사용 중입니다.",
        "ja": "カメラは他のアプリで使用中です。",
        "de": "Die Kamera wird von einer anderen App verwendet.",
        "en": "Camera is in use by another app.",
        "zh-Hans": "相机正在被其他应用使用。",
        "zh-Hant": "相機正在被其他應用程式使用。"
    },
    {
        "key": "camera_not_found",
        "ko": "카메라를 찾을 수 없습니다.",
        "ja": "カメラが見つかりません。",
        "de": "Kamera nicht gefunden.",
        "en": "Camera not found.",
        "zh-Hans": "找不到相机。",
        "zh-Hant": "找不到相機。"
    },
    {
        "key": "camera_not_supported_browser",
        "ko": "카메라를 지원하지 않는 브라우저입니다.",
        "ja": "お使いのブラウザはカメラに対応していません。",
        "de": "Ihr Browser unterstützt die Kamera nicht.",
        "en": "Your browser does not support the camera.",
        "zh-Hans": "您的浏览器不支持相机。",
        "zh-Hant": "您的瀏覽器不支持相機。"
    },
    {
        "key": "camera_title",
        "ko": "카메라",
        "ja": "カメラ",
        "de": "Kamera",
        "en": "Camera",
        "zh-Hans": "相机",
        "zh-Hant": "相機"
    },
    {
        "key": "can_add_after_approval",
        "ko": "승인이후도 추가가능",
        "ja": "承認後も追加可能",
        "de": "Nach Genehmigung hinzufügbar",
        "en": "Can add after approval",
        "zh-Hans": "批准后也可添加",
        "zh-Hant": "批准後也可新增"
    },
    {
        "key": "cancel",
        "ko": "취소",
        "ja": "キャンセル",
        "de": "Abbrechen",
        "en": "Cancel",
        "zh-Hans": "取消",
        "zh-Hant": "取消"
    },
    {
        "key": "cannot_fetch_image_data",
        "ko": "이미지 데이터를 가져올 수 없습니다.",
        "ja": "画像データを取得できません。",
        "de": "Bilddaten konnten nicht geladen werden.",
        "en": "Unable to fetch image data.",
        "zh-Hans": "无法获取图片数据。",
        "zh-Hant": "無法獲取圖片資料。"
    },
    {
        "key": "canvas",
        "ko": "캔버스",
        "ja": "キャンバス",
        "de": "canvas",
        "en": "canvas",
        "zh-Hans": "画布",
        "zh-Hant": "畫布"
    },
    {
        "key": "category",
        "ko": "분류",
        "ja": "分類",
        "de": "Kategorie",
        "en": "Category",
        "zh-Hans": "分类",
        "zh-Hant": "分類"
    },
    {
        "key": "challenge",
        "ko": "챌린지",
        "ja": "チャレンジ",
        "de": "Herausforderung",
        "en": "Challenge",
        "zh-Hans": "挑战",
        "zh-Hant": "挑戰"
    },
    {
        "key": "challenge_status",
        "ko": "챌린지 현황",
        "ja": "チャンピオンシップ ステータス",
        "de": "Herausforderungsstatus",
        "en": "Challenge status",
        "zh-Hans": "挑战状态",
        "zh-Hant": "挑戰狀態"
    },
    {
        "key": "challenge_name_physical_heartbeat_daily",
        "ko": "평균심박수 일간챌린지",
        "ja": "平均心拍数 日次チャレンジ",
        "de": "Durchschnittliche Herzfrequenz Tages-Challenge",
        "en": "Average heart rate daily challenge",
        "zh-Hans": "平均心率每日挑战",
        "zh-Hant": "平均心率每日挑戰"
    },
    {
        "key": "challenge_name_physical_step_daily",
        "ko": "걷기 일간챌린지",
        "ja": "歩行 日次チャレンジ",
        "de": "Gehen Tages-Challenge",
        "en": "Walking daily challenge",
        "zh-Hans": "步行每日挑战",
        "zh-Hant": "步行每日挑戰"
    },
    {
        "key": "challenge_name_physical_step_daily_in_weekly",
        "ko": "일6000보 주간챌린지",
        "ja": "1日6000歩 週間チャレンジ",
        "de": "6.000 Schritte Wochen-Challenge",
        "en": "6,000 steps weekly challenge",
        "zh-Hans": "每日6000步每周挑战",
        "zh-Hant": "每日6000步每週挑戰"
    },
    {
        "key": "challenge_name_physical_step_monthly",
        "ko": "걷기 월간챌린지",
        "ja": "歩行 月間チャレンジ",
        "de": "Gehen Monats-Challenge",
        "en": "Walking monthly challenge",
        "zh-Hans": "步行每月挑战",
        "zh-Hant": "步行每月挑戰"
    },
    {
        "key": "challenge_name_physical_step_weekly",
        "ko": "걷기 주간챌린지",
        "ja": "歩行 週間チャレンジ",
        "de": "Gehen Wochen-Challenge",
        "en": "Walking weekly challenge",
        "zh-Hans": "步行每周挑战",
        "zh-Hant": "步行每週挑戰"
    },
    {
        "key": "challenge_name_play_heartbeat_daily",
        "ko": "디딤 최대심박수 일간챌린지",
        "ja": "DIDIM 最大心拍数日次チャレンジ",
        "de": "DIDIM max. Herzfrequenz Tages-Challenge",
        "en": "DIDIM max heart rate daily challenge",
        "zh-Hans": "Didim 最高心率每日挑战",
        "zh-Hant": "Didim 最高心率每日挑戰"
    },
    {
        "key": "challenge_name_play_heartbeat_monthly",
        "ko": "디딤 최대심박수 월간챌린지",
        "ja": "DIDIM 最大心拍数月間チャレンジ",
        "de": "DIDIM max. Herzfrequenz Monats-Challenge",
        "en": "DIDIM max heart rate monthly challenge",
        "zh-Hans": "Didim 最高心率每月挑战",
        "zh-Hant": "Didim 最高心率每月挑戰"
    },
    {
        "key": "challenge_name_play_heartbeat_weekly",
        "ko": "디딤 최대심박수 주간챌린지",
        "ja": "DIDIM 最大心拍数週間チャレンジ",
        "de": "DIDIM max. Herzfrequenz Wochen-Challenge",
        "en": "DIDIM max heart rate weekly challenge",
        "zh-Hans": "Didim 最高心率每周挑战",
        "zh-Hant": "Didim 最高心率每週挑戰"
    },
    {
        "key": "challenge_name_play_step_daily",
        "ko": "디딤 걸음수 일간챌린지",
        "ja": "DIDIM 歩数日次チャレンジ",
        "de": "DIDIM Schritte Tages-Challenge",
        "en": "DIDIM steps daily challenge",
        "zh-Hans": "Didim 步数每日挑战",
        "zh-Hant": "Didim 步數每日挑戰"
    },
    {
        "key": "challenge_name_play_step_daily_in_yearly",
        "ko": "디딤 사용일 보상챌린지",
        "ja": "DIDIM 利用日数報酬チャレンジ",
        "de": "DIDIM Nutzungstage Belohnungs-Challenge",
        "en": "DIDIM usage day reward challenge",
        "zh-Hans": "Didim 使用日奖励挑战",
        "zh-Hant": "Didim 使用日獎勵挑戰"
    },
    {
        "key": "challenge_name_play_step_monthly",
        "ko": "디딤 걸음수 월간챌린지",
        "ja": "DIDIM 歩数月間チャレンジ",
        "de": "DIDIM Schritte Monats-Challenge",
        "en": "DIDIM steps monthly challenge",
        "zh-Hans": "Didim 步数每月挑战",
        "zh-Hant": "Didim 步數每月挑戰"
    },
    {
        "key": "challenge_name_play_step_weekly",
        "ko": "디딤 걸음수 주간챌린지",
        "ja": "DIDIM 歩数週間チャレンジ",
        "de": "DIDIM Schritte Wochen-Challenge",
        "en": "DIDIM steps weekly challenge",
        "zh-Hans": "Didim 步数每周挑战",
        "zh-Hant": "Didim 步數每週挑戰"
    },
    {
        "key": "champion",
        "ko": "챔피언",
        "ja": "チャンピオン",
        "de": "Champion",
        "en": "Champion",
        "zh-Hans": "冠军",
        "zh-Hant": "冠軍"
    },
    {
        "key": "championship",
        "ko": "챔피언십",
        "ja": "チャンピオンシップ",
        "de": "Meisterschaft",
        "en": "Championship",
        "zh-Hans": "锦标赛",
        "zh-Hant": "錦標賽"
    },
    {
        "key": "championship_admin",
        "ko": "대회 관리",
        "ja": "大会管理",
        "de": "Meisterschaftsverwaltung",
        "en": "Championship management",
        "zh-Hans": "大赛管理",
        "zh-Hant": "大賽管理"
    },
    {
        "key": "championship_content",
        "ko": "대회콘텐츠",
        "ja": "大会コンテンツ",
        "de": "Meisterschaftsinhalt",
        "en": "Championship content",
        "zh-Hans": "大赛内容",
        "zh-Hant": "大賽內容"
    },
    {
        "key": "championship_creation_failed",
        "ko": "대회 생성에 실패했습니다.",
        "ja": "大会の作成に失敗しました。",
        "de": "Meisterschaftserstellung fehlgeschlagen.",
        "en": "Championship creation failed.",
        "zh-Hans": "创建大赛失败。",
        "zh-Hant": "創建大賽失敗。"
    },
    {
        "key": "championship_end_date",
        "ko": "대회마감일",
        "ja": "大会締切日",
        "de": "Meisterschafts-Enddatum",
        "en": "Championship end date",
        "zh-Hans": "大赛结束日期",
        "zh-Hant": "大賽結束日期"
    },
    {
        "key": "championship_event",
        "ko": "대회종목",
        "ja": "大会種目",
        "de": "Championship Event",
        "en": "Championship Event",
        "zh-Hans": "大赛项目",
        "zh-Hant": "大賽項目"
    },
    {
        "key": "championship_format",
        "ko": "대회형식",
        "ja": "大会形式",
        "de": "Championship Format",
        "en": "Championship Format",
        "zh-Hans": "大赛形式",
        "zh-Hant": "大賽形式"
    },
    {
        "key": "championship_has_been_created",
        "ko": "대회가 생성되었습니다.",
        "ja": "大会が作成されました。",
        "de": "Meisterschaft wurde erstellt.",
        "en": "Championship has been created.",
        "zh-Hans": "大赛已创建。",
        "zh-Hant": "大賽已創建。"
    },
    {
        "key": "championship_has_been_deleted",
        "ko": "대회가 삭제되었습니다.",
        "ja": "大会が削除されました。",
        "de": "Meisterschaft wurde gelöscht.",
        "en": "Championship has been deleted.",
        "zh-Hans": "大赛已删除。",
        "zh-Hant": "大賽已刪除。"
    },
    {
        "key": "championship_host",
        "ko": "대회주최자",
        "ja": "大会主催者",
        "de": "Meisterschaftsausrichter",
        "en": "Championship host",
        "zh-Hans": "大赛主办方",
        "zh-Hant": "大賽主辦方"
    },
    {
        "key": "championship_info",
        "ko": "챔피언십 정보",
        "ja": "チャンピオンシップ情報",
        "de": "Meisterschafts-Info",
        "en": "Championship info",
        "zh-Hans": "锦标赛信息",
        "zh-Hant": "錦標賽資訊"
    },
    {
        "key": "championship_list",
        "ko": "챔피언십 목록",
        "ja": "チャンピオンシップ一覧",
        "de": "Meisterschaftsliste",
        "en": "Championship list",
        "zh-Hans": "锦标赛列表",
        "zh-Hant": "錦標賽清單"
    },
    {
        "key": "championship_name",
        "ko": "대회이름",
        "ja": "大会名",
        "de": "Championship Name",
        "en": "Championship Name",
        "zh-Hans": "大赛名称",
        "zh-Hant": "大賽名稱"
    },
    {
        "key": "championship_organization",
        "ko": "대회기관",
        "ja": "大会機関",
        "de": "Meisterschaftsorganisation",
        "en": "Championship organization",
        "zh-Hans": "大赛机构",
        "zh-Hant": "大賽機構"
    },
    {
        "key": "championship_period",
        "ko": "대회기간",
        "ja": "大会期間",
        "de": "Championship Period",
        "en": "Championship Period",
        "zh-Hans": "大赛期间",
        "zh-Hant": "大賽期間"
    },
    {
        "key": "championship_scope",
        "ko": "대회범위",
        "ja": "大会範囲",
        "de": "Meisterschaftsbereich",
        "en": "Championship scope",
        "zh-Hans": "大赛范围",
        "zh-Hant": "大賽範圍"
    },
    {
        "key": "championship_start_date",
        "ko": "대회시작일",
        "ja": "大会開始日",
        "de": "Meisterschafts-Startdatum",
        "en": "Championship start date",
        "zh-Hans": "大赛开始日期",
        "zh-Hant": "大賽開始日期"
    },
    {
        "key": "change",
        "ko": "변경하기",
        "ja": "変更する",
        "de": "Ändern",
        "en": "Change",
        "zh-Hans": "更改",
        "zh-Hant": "變更"
    },
    {
        "key": "change_photo",
        "ko": "사진 변경",
        "ja": "プロフィール画像を変更",
        "de": "Foto ändern",
        "en": "Change Photo",
        "zh-Hans": "更改照片",
        "zh-Hant": "變更照片"
    },
    {
        "key": "checking_account_availability",
        "ko": "계정 중복 확인 중...",
        "ja": "アカウント重複確認中...",
        "de": "Checking account availability...",
        "en": "Checking account availability...",
        "zh-Hans": "正在检查账号是否可用...",
        "zh-Hant": "正在檢查帳號是否可用..."
    },
    {
        "key": "checking_app_version",
        "ko": "앱 버전 확인 중...",
        "ja": "アプリバージョンを確認中...",
        "de": "Checking app version...",
        "en": "Checking app version...",
        "zh-Hans": "正在检查应用版本...",
        "zh-Hant": "正在檢查應用版本..."
    },
    {
        "key": "checking_duplicate",
        "ko": "중복확인 중...",
        "ja": "重複確認中...",
        "de": "Duplikat wird geprüft...",
        "en": "Checking for duplicates...",
        "zh-Hans": "正在检查重复...",
        "zh-Hant": "正在檢查重複..."
    },
    {
        "key": "chinese_simplified",
        "ko": "중국어(간체)",
        "ja": "簡体中文",
        "de": "Simplified Chinese",
        "en": "Simplified Chinese",
        "zh-Hans": "简体中文",
        "zh-Hant": "简体中文"
    },
    {
        "key": "chinese_traditional",
        "ko": "중국어(번체)",
        "ja": "繁体中文",
        "de": "Traditional Chinese",
        "en": "Traditional Chinese",
        "zh-Hans": "繁体中文",
        "zh-Hant": "繁体中文"
    },
    {
        "key": "chungbuk",
        "ko": "충북",
        "ja": "忠北",
        "de": "Chungbuk",
        "en": "Chungbuk",
        "zh-Hans": "忠北",
        "zh-Hant": "忠北"
    },
    {
        "key": "chungcheongbuk_do",
        "ko": "충청북도",
        "ja": "忠清北道",
        "de": "Chungcheongbuk-do",
        "en": "Chungcheongbuk-do",
        "zh-Hans": "忠清北道",
        "zh-Hant": "忠清北道"
    },
    {
        "key": "chungcheongnam_do",
        "ko": "충청남도",
        "ja": "忠清南道",
        "de": "Chungcheongnam-do",
        "en": "Chungcheongnam-do",
        "zh-Hans": "忠清南道",
        "zh-Hant": "忠清南道"
    },
    {
        "key": "chungnam",
        "ko": "충남",
        "ja": "忠南",
        "de": "Chungnam",
        "en": "Chungnam",
        "zh-Hans": "忠南",
        "zh-Hant": "忠南"
    },
    {
        "key": "class",
        "ko": "반",
        "ja": "組",
        "de": "Klasse",
        "en": "Class",
        "zh-Hans": "班级",
        "zh-Hant": "班級"
    },
    {
        "key": "class_1",
        "ko": "1반",
        "ja": "1組",
        "de": "Class 1",
        "en": "Class 1",
        "zh-Hans": "1班",
        "zh-Hant": "1班"
    },
    {
        "key": "class_default",
        "ko": "반",
        "ja": "クラス",
        "de": "Klasse",
        "en": "Class",
        "zh-Hans": "班级",
        "zh-Hant": "班級"
    },
    {
        "key": "class_sun",
        "ko": "해님반",
        "ja": "ひまわり組",
        "de": "Sonnengruppe",
        "en": "Sun Class",
        "zh-Hans": "太阳班",
        "zh-Hant": "太陽班"
    },
    {
        "key": "class_name_e_g_example",
        "ko": "반이름 예){{example}}",
        "ja": "クラス名 例）{{example}}",
        "de": "Klassenname z.B. {{example}}",
        "en": "Class name e.g. {{example}}",
        "zh-Hans": "班级名称 例）{{example}}",
        "zh-Hant": "班級名稱 例）{{example}}"
    },
    {
        "key": "class_name_e_g_grade",
        "ko": "반이름(예:{{grade}})",
        "ja": "クラス名（例：{{grade}}）",
        "de": "Klassenname (z.B. {{grade}})",
        "en": "Class name (e.g. {{grade}})",
        "zh-Hans": "班级名称（例：{{grade}}）",
        "zh-Hant": "班級名稱（例：{{grade}}）"
    },
    {
        "key": "click_the_plus_button_in_division_1_to_add_grades",
        "ko": "* 세부소속1의 + 버튼을 눌러 학년을 추가해주세요.",
        "ja": "* 詳細所属1の + ボタンを押して学年を追加してください。",
        "de": "* Klicken Sie auf die + Schaltfläche bei Division 1, um Klassenstufen hinzuzufügen.",
        "en": "* Click the + button in Division 1 to add grades.",
        "zh-Hans": "* 请点击详细所属1的 + 按钮添加年级。",
        "zh-Hant": "* 請點擊詳細所屬1的 + 按鈕新增年級。"
    },
    {
        "key": "click_to_change_photo",
        "ko": "클릭하여 사진 변경",
        "ja": "クリックして写真を変更",
        "de": "Klicken Sie hier, um das Foto zu ändern",
        "en": "Click to change photo",
        "zh-Hans": "点击更改照片",
        "zh-Hant": "點擊變更照片"
    },
    {
        "key": "click_to_upload_photo",
        "ko": "클릭하여 사진 업로드",
        "ja": "クリックして写真をアップロード",
        "de": "Klicken Sie hier, um ein Foto hochzuladen",
        "en": "Click to upload photo",
        "zh-Hans": "点击上传照片",
        "zh-Hant": "點擊上傳照片"
    },
    {
        "key": "close",
        "ko": "닫기",
        "ja": "閉じる",
        "de": "Schließen",
        "en": "Close",
        "zh-Hans": "关闭",
        "zh-Hant": "關閉"
    },
    {
        "key": "complete",
        "ko": "완료",
        "ja": "完了",
        "de": "Abschließen",
        "en": "Complete",
        "zh-Hans": "完成",
        "zh-Hant": "完成"
    },
    {
        "key": "completed",
        "ko": "완료된",
        "ja": "完了",
        "de": "Abgeschlossen",
        "en": "Completed",
        "zh-Hans": "已完成",
        "zh-Hant": "已完成"
    },
    {
        "key": "completed_title",
        "ko": "완료!!",
        "ja": "完了!!",
        "de": "Abschließen!!",
        "en": "Completed!!",
        "zh-Hans": "已完成！！",
        "zh-Hant": "已完成！！"
    },
    {
        "key": "confirm",
        "ko": "확인",
        "ja": "確認",
        "de": "Bestätigen",
        "en": "Confirm",
        "zh-Hans": "确认",
        "zh-Hant": "確認"
    },
    {
        "key": "confirm_account_withdrawal",
        "ko": "계정을 탈퇴하시겠습니까?",
        "ja": "アカウントを退会しますか？",
        "de": "Möchten Sie Ihr Konto wirklich kündigen?",
        "en": "Are you sure you want to withdraw your account?",
        "zh-Hans": "确定要注销账号吗？",
        "zh-Hant": "確定要註銷帳號嗎？"
    },
    {
        "key": "confirm_password",
        "ko": "비밀번호 확인",
        "ja": "パスワード確認",
        "de": "Passwort bestätigen",
        "en": "Confirm password",
        "zh-Hans": "确认密码",
        "zh-Hant": "確認密碼"
    },
    {
        "key": "confirm_your_password",
        "ko": "비밀번호를 다시 입력해주세요.",
        "ja": "パスワード確認を入力してください。",
        "de": "Bestätigen Sie Ihr Passwort.",
        "en": "Confirm your password.",
        "zh-Hans": "请再次输入密码。",
        "zh-Hant": "請再次輸入密碼。"
    },
    {
        "key": "connected",
        "ko": "연결됨",
        "ja": "接続済み",
        "de": "Verbunden",
        "en": "Connected",
        "zh-Hans": "已连接",
        "zh-Hant": "已連接"
    },
    {
        "key": "connecting",
        "ko": "연결중",
        "ja": "接続中",
        "de": "Verbinde",
        "en": "Connecting",
        "zh-Hans": "连接中",
        "zh-Hant": "連接中"
    },
    {
        "key": "contact_email",
        "ko": "담당자 메일",
        "ja": "担当者メール",
        "de": "Kontakt-E-Mail",
        "en": "Contact email",
        "zh-Hans": "联系人邮箱",
        "zh-Hant": "聯絡人郵箱"
    },
    {
        "key": "contact_name",
        "ko": "담당자명",
        "ja": "担当者名",
        "de": "Kontaktname",
        "en": "Contact name",
        "zh-Hans": "联系人姓名",
        "zh-Hant": "聯絡人姓名"
    },
    {
        "key": "contact_phone",
        "ko": "담당자 연락처",
        "ja": "担当者連絡先",
        "de": "Kontakttelefon",
        "en": "Contact phone",
        "zh-Hans": "联系人电话",
        "zh-Hant": "聯絡人電話"
    },
    {
        "key": "contact_title",
        "ko": "담당자직책",
        "ja": "担当者役職",
        "de": "Kontaktbezeichnung",
        "en": "Contact title",
        "zh-Hans": "联系人职务",
        "zh-Hant": "聯絡人職務"
    },
    {
        "key": "content",
        "ko": "내용",
        "ja": "内容",
        "de": "Inhalt",
        "en": "Content",
        "zh-Hans": "内容",
        "zh-Hant": "內容"
    },
    {
        "key": "content_delete_failed",
        "ko": "콘텐츠 삭제에 실패했습니다.",
        "ja": "コンテンツの削除に失敗しました。",
        "de": "Inhalt konnte nicht gelöscht werden.",
        "en": "Content delete failed.",
        "zh-Hans": "删除内容失败。",
        "zh-Hant": "刪除內容失敗。"
    },
    {
        "key": "content_has_been_registered",
        "ko": "콘텐츠 등록이 완료되었습니다.",
        "ja": "コンテンツが登録されました。",
        "de": "Inhalt wurde registriert.",
        "en": "Content has been registered.",
        "zh-Hans": "内容已注册。",
        "zh-Hant": "內容已註冊。"
    },
    {
        "key": "content_has_been_updated",
        "ko": "콘텐츠 수정이 완료되었습니다.",
        "ja": "コンテンツが更新されました。",
        "de": "Inhalt wurde aktualisiert.",
        "en": "Content has been updated.",
        "zh-Hans": "内容已更新。",
        "zh-Hant": "內容已更新。"
    },
    {
        "key": "content_name",
        "ko": "콘텐츠명",
        "ja": "コンテンツ名",
        "de": "Inhaltsname",
        "en": "Content name",
        "zh-Hans": "内容名称",
        "zh-Hant": "內容名稱"
    },
    {
        "key": "content_preview",
        "ko": "내용 미리보기",
        "ja": "内容プレビュー",
        "de": "Inhaltsvorschau",
        "en": "Content preview",
        "zh-Hans": "内容预览",
        "zh-Hant": "內容預覽"
    },
    {
        "key": "content_save_failed",
        "ko": "콘텐츠 저장에 실패했습니다.",
        "ja": "コンテンツの保存に失敗しました。",
        "de": "Inhalt konnte nicht gespeichert werden.",
        "en": "Content save failed.",
        "zh-Hans": "保存内容失败。",
        "zh-Hant": "儲存內容失敗。"
    },
    {
        "key": "contents",
        "ko": "콘텐츠",
        "ja": "コンテンツ",
        "de": "Inhalte",
        "en": "Contents",
        "zh-Hans": "内容",
        "zh-Hant": "內容"
    },
    {
        "key": "contents_add_edit",
        "ko": "콘텐츠 추가/수정",
        "ja": "コンテンツ 追加/編集",
        "de": "Contents add/edit",
        "en": "Contents add/edit",
        "zh-Hans": "添加/编辑内容",
        "zh-Hant": "新增/編輯內容"
    },
    {
        "key": "contents_list",
        "ko": "콘텐츠 목록",
        "ja": "コンテンツ 一覧",
        "de": "Inhaltsliste",
        "en": "Contents list",
        "zh-Hans": "内容列表",
        "zh-Hant": "內容清單"
    },
    {
        "key": "cooperation",
        "ko": "협응력",
        "ja": "協応力",
        "de": "Kooperation",
        "en": "Cooperation",
        "zh-Hans": "协调能力",
        "zh-Hant": "協調能力"
    },
    {
        "key": "count",
        "ko": "{{count}}명",
        "ja": "{{count}}人",
        "de": "{{count}}",
        "en": "{{count}}",
        "zh-Hans": "{{count}}名",
        "zh-Hant": "{{count}}名"
    },
    {
        "key": "country",
        "ko": "국가",
        "ja": "国",
        "de": "Land",
        "en": "Country",
        "zh-Hans": "国家",
        "zh-Hant": "國家"
    },
    {
        "key": "create_championship",
        "ko": "대회 만들기",
        "ja": "大会を作成",
        "de": "Meisterschaft erstellen",
        "en": "Create championship",
        "zh-Hans": "创建大赛",
        "zh-Hant": "創建大賽"
    },
    {
        "key": "create_championship_room",
        "ko": "대회방 만들기",
        "ja": "大会ルームを作成",
        "de": "Meisterschaftsraum erstellen",
        "en": "Create Championship Room",
        "zh-Hans": "创建大赛房间",
        "zh-Hant": "創建大賽房間"
    },
    {
        "key": "create_event",
        "ko": "이벤트만들기",
        "ja": "イベント作成",
        "de": "Veranstaltung erstellen",
        "en": "Create event",
        "zh-Hans": "创建活动",
        "zh-Hant": "創建活動"
    },
    {
        "key": "create_organization_championship",
        "ko": "기관 대회만들기",
        "ja": "機関大会を作成",
        "de": "Organisationsmeisterschaft erstellen",
        "en": "Create organization championship",
        "zh-Hans": "创建机构大赛",
        "zh-Hant": "創建機構大賽"
    },
    {
        "key": "create_supervisor_championship",
        "ko": "슈퍼바이저 대회만들기",
        "ja": "スーパーバイザー大会を作成",
        "de": "Betreuermeisterschaft erstellen",
        "en": "Create supervisor championship",
        "zh-Hans": "创建主管大赛",
        "zh-Hant": "創建主管大賽"
    },
    {
        "key": "cumulative",
        "ko": "누적",
        "ja": "累計",
        "de": "Kumulativ",
        "en": "Cumulative",
        "zh-Hans": "累计",
        "zh-Hant": "累計"
    },
    {
        "key": "cumulative_activity_ranking",
        "ko": "누적활동랭킹",
        "ja": "累計活動ランキング",
        "de": "Kumulatives Aktivitäts-Ranking",
        "en": "Cumulative activity ranking",
        "zh-Hans": "累计活动排名",
        "zh-Hant": "累計活動排名"
    },
    {
        "key": "cumulative_experience_ranking",
        "ko": "누적경험치랭킹",
        "ja": "累計経験値ランキング",
        "de": "Kumulative Erfahrungs-Rangliste",
        "en": "Cumulative experience ranking",
        "zh-Hans": "累计经验值排名",
        "zh-Hant": "累計經驗值排名"
    },
    {
        "key": "cumulative_ranking",
        "ko": "누적랭킹",
        "ja": "累計ランキング",
        "de": "Kumulatives Ranking",
        "en": "Cumulative ranking",
        "zh-Hans": "累计排名",
        "zh-Hant": "累計排名"
    },
    {
        "key": "current_1st",
        "ko": "현재1위",
        "ja": "現在1位",
        "de": "Aktuell 1.",
        "en": "Current 1st",
        "zh-Hans": "当前第1名",
        "zh-Hant": "當前第1名"
    },
    {
        "key": "customer_service",
        "ko": "고객센터",
        "ja": "お客様センター",
        "de": "Kundenservice",
        "en": "Customer service",
        "zh-Hans": "客服中心",
        "zh-Hant": "客服中心"
    },
    {
        "key": "daegu",
        "ko": "대구",
        "ja": "大邱",
        "de": "Daegu",
        "en": "Daegu",
        "zh-Hans": "大邱",
        "zh-Hant": "大邱"
    },
    {
        "key": "daegu_metropolitan_city",
        "ko": "대구광역시",
        "ja": "大邱広域市",
        "de": "Daegu Metropolitan City",
        "en": "Daegu Metropolitan City",
        "zh-Hans": "大邱广域市",
        "zh-Hant": "大邱廣域市"
    },
    {
        "key": "daejeon",
        "ko": "대전",
        "ja": "大田",
        "de": "Daejeon",
        "en": "Daejeon",
        "zh-Hans": "大田",
        "zh-Hant": "大田"
    },
    {
        "key": "daejeon_metropolitan_city",
        "ko": "대전광역시",
        "ja": "大田広域市",
        "de": "Daejeon Metropolitan City",
        "en": "Daejeon Metropolitan City",
        "zh-Hans": "大田广域市",
        "zh-Hant": "大田廣域市"
    },
    {
        "key": "daily",
        "ko": "일간",
        "ja": "日間",
        "de": "Täglich",
        "en": "Daily",
        "zh-Hans": "每日",
        "zh-Hant": "每日"
    },
    {
        "key": "daily_activity",
        "ko": "일일 활동",
        "ja": "一日の活動",
        "de": "Tägliche Aktivität",
        "en": "Daily activity",
        "zh-Hans": "每日活动",
        "zh-Hant": "每日活動"
    },
    {
        "key": "daily_didim_usage",
        "ko": "금일디딤사용",
        "ja": "本日ディディム使用",
        "de": "Daily Didim usage",
        "en": "Daily Didim usage",
        "zh-Hans": "今日 Didim 使用",
        "zh-Hant": "今日 Didim 使用"
    },
    {
        "key": "dashboard",
        "ko": "대시보드",
        "ja": "ダッシュボード",
        "de": "Dashboard",
        "en": "Dashboard",
        "zh-Hans": "仪表盘",
        "zh-Hant": "儀表盤"
    },
    {
        "key": "date_placeholder_year_month_day",
        "ko": "연도. 월. 일",
        "ja": "年. 月. 日",
        "de": "Tag. Monat. Jahr",
        "en": "Month/Day/Year",
        "zh-Hans": "年. 月. 日",
        "zh-Hant": "年. 月. 日"
    },
    {
        "key": "date_time",
        "ko": "일시",
        "ja": "日時",
        "de": "Datum/Uhrzeit",
        "en": "Date/Time",
        "zh-Hans": "日期/时间",
        "zh-Hant": "日期/時間"
    },
    {
        "key": "day",
        "ko": "일",
        "ja": "日",
        "de": "day",
        "en": "day",
        "zh-Hans": "天",
        "zh-Hant": "天"
    },
    {
        "key": "day_with_fewest_steps",
        "ko": "가장 적게 걸은 날",
        "ja": "最も少なく歩いた日",
        "de": "Tag mit den wenigsten Schritten",
        "en": "Day with fewest steps",
        "zh-Hans": "步数最少的日子",
        "zh-Hant": "步數最少的日子"
    },
    {
        "key": "day_with_most_steps",
        "ko": "가장 많이 걸은 날",
        "ja": "最も多く歩いた日",
        "de": "Tag mit den meisten Schritten",
        "en": "Day with most steps",
        "zh-Hans": "步数最多的日子",
        "zh-Hant": "步數最多的日子"
    },
    {
        "key": "delete",
        "ko": "삭제",
        "ja": "削除",
        "de": "Löschen",
        "en": "Delete",
        "zh-Hans": "删除",
        "zh-Hant": "刪除"
    },
    {
        "key": "delete_account",
        "ko": "계정 삭제",
        "ja": "アカウント削除",
        "de": "Konto löschen",
        "en": "delete account",
        "zh-Hans": "删除账号",
        "zh-Hant": "刪除帳號"
    },
    {
        "key": "delete_championship",
        "ko": "대회를 삭제하시겠습니까?",
        "ja": "大会を削除しますか？",
        "de": "Meisterschaft löschen?",
        "en": "Delete championship?",
        "zh-Hans": "确定要删除大赛吗？",
        "zh-Hant": "確定要刪除大賽嗎？"
    },
    {
        "key": "delete_championship_name",
        "ko": "{{name}} 대회를 삭제하시겠습니까?",
        "ja": "「{{name}}」大会を削除しますか？",
        "de": "Meisterschaft \"{{name}}\" löschen?",
        "en": "Delete championship \"{{name}}\"?",
        "zh-Hans": "要删除“{{name}}”大赛吗？",
        "zh-Hant": "要刪除“{{name}}”大賽嗎？"
    },
    {
        "key": "delete_completed",
        "ko": "삭제가 완료되었습니다.",
        "ja": "削除が完了しました。",
        "de": "Löschen abgeschlossen.",
        "en": "Delete completed.",
        "zh-Hans": "删除完成。",
        "zh-Hant": "刪除完成。"
    },
    {
        "key": "delete_failed",
        "ko": "삭제에 실패했습니다.",
        "ja": "削除に失敗しました。",
        "de": "Löschen fehlgeschlagen.",
        "en": "Delete failed.",
        "zh-Hans": "删除失败。",
        "zh-Hant": "刪除失敗。"
    },
    {
        "key": "delete_organization",
        "ko": "기관삭제",
        "ja": "機関削除",
        "de": "Organisation löschen",
        "en": "Delete organization",
        "zh-Hans": "删除机构",
        "zh-Hant": "刪除機構"
    },
    {
        "key": "delete_organization_name",
        "ko": "{{name}} 기관을 삭제하시겠습니까?",
        "ja": "「{{name}}」機関を削除しますか？",
        "de": "Organisation \"{{name}}\" löschen?",
        "en": "Delete organization \"{{name}}\"?",
        "zh-Hans": "要删除“{{name}}”机构吗？",
        "zh-Hant": "要刪除“{{name}}”機構嗎？"
    },
    {
        "key": "deleted_championships_cannot_be_recovered",
        "ko": "삭제된 대회는 복구할 수 없습니다.",
        "ja": "削除した大会は復元できません。",
        "de": "Gelöschte Meisterschaften können nicht wiederhergestellt werden.",
        "en": "Deleted championships cannot be recovered.",
        "zh-Hans": "已删除的大赛无法恢复。",
        "zh-Hant": "已刪除的大賽無法恢復。"
    },
    {
        "key": "deleting",
        "ko": "삭제 중...",
        "ja": "削除中...",
        "de": "Deleting...",
        "en": "Deleting...",
        "zh-Hans": "正在删除...",
        "zh-Hant": "正在刪除..."
    },
    {
        "key": "detail_content",
        "ko": "상세내용",
        "ja": "詳細内容",
        "de": "Inhaltsdetails",
        "en": "Detail content",
        "zh-Hans": "详细内容",
        "zh-Hant": "詳細內容"
    },
    {
        "key": "didim",
        "ko": "디딤",
        "ja": "ディディム",
        "de": "Didim",
        "en": "Didim",
        "zh-Hans": "Didim",
        "zh-Hant": "Didim"
    },
    {
        "key": "didim_activity",
        "ko": "디딤활동",
        "ja": "ディディム活動",
        "de": "Didim-Aktivität",
        "en": "Didim activity",
        "zh-Hans": "Didim 活动",
        "zh-Hant": "Didim 活動"
    },
    {
        "key": "didim_day",
        "ko": "디딤 / 일",
        "ja": "ディディム / 日",
        "de": "Didim / day",
        "en": "Didim / day",
        "zh-Hans": "Didim / 天",
        "zh-Hant": "Didim / 天"
    },
    {
        "key": "didim_edit",
        "ko": "디딤 수정",
        "ja": "ディディム編集",
        "de": "Didim bearbeiten",
        "en": "Didim edit",
        "zh-Hans": "编辑 Didim",
        "zh-Hant": "編輯 Didim"
    },
    {
        "key": "didim_exercise_report",
        "ko": "디딤 운동 리포트",
        "ja": "ディディム 運動 レポート",
        "de": "Didim-Trainingsbericht",
        "en": "Didim exercise report",
        "zh-Hans": "Didim 运动报告",
        "zh-Hant": "Didim 運動報告"
    },
    {
        "key": "didim_h_w",
        "ko": "디딤 H/W",
        "ja": "ディディム H/W",
        "de": "Didim H/W",
        "en": "Didim H/W",
        "zh-Hans": "Didim H/W",
        "zh-Hant": "Didim H/W"
    },
    {
        "key": "didim_h_w_connection",
        "ko": "디딤H/W 연결",
        "ja": "Didim H/W接続",
        "de": "Didim H/W connection",
        "en": "Didim H/W connection",
        "zh-Hans": "Didim H/W 连接",
        "zh-Hant": "Didim H/W 連接"
    },
    {
        "key": "didim_h_w_edit",
        "ko": "디딤 H/W 수정",
        "ja": "Didim H/W編集",
        "de": "Didim H/W edit",
        "en": "Didim H/W edit",
        "zh-Hans": "编辑 Didim H/W",
        "zh-Hant": "編輯 Didim H/W"
    },
    {
        "key": "didim_h_w_list",
        "ko": "디딤 H/W 목록",
        "ja": "Didim H/W一覧",
        "de": "Didim H/W list",
        "en": "Didim H/W list",
        "zh-Hans": "Didim H/W 列表",
        "zh-Hant": "Didim H/W 清單"
    },
    {
        "key": "didim_hq",
        "ko": "디딤 본사",
        "ja": "ディディム本社",
        "de": "Didim HQ",
        "en": "Didim HQ",
        "zh-Hans": "Didim 总部",
        "zh-Hant": "Didim 總部"
    },
    {
        "key": "didim_id",
        "ko": "디딤ID",
        "ja": "ディディムID",
        "de": "Didim ID",
        "en": "Didim ID",
        "zh-Hans": "Didim ID",
        "zh-Hant": "Didim ID"
    },
    {
        "key": "didim_link_info",
        "ko": "디딤연계정보",
        "ja": "ディディム連携情報",
        "de": "Didim-Link-Info",
        "en": "Didim link info",
        "zh-Hans": "Didim 关联信息",
        "zh-Hant": "Didim 關聯資訊"
    },
    {
        "key": "didim_list",
        "ko": "디딤 목록",
        "ja": "ディディム一覧",
        "de": "Didim-Liste",
        "en": "Didim list",
        "zh-Hans": "Didim 列表",
        "zh-Hant": "Didim 清單"
    },
    {
        "key": "didim_name",
        "ko": "디딤 관리명",
        "ja": "Didim管理名",
        "de": "Didim-Name",
        "en": "Didim name",
        "zh-Hans": "Didim 管理名称",
        "zh-Hant": "Didim 管理名稱"
    },
    {
        "key": "didim_organizations_count",
        "ko": "디딤 이용 기관 ({{count}})",
        "ja": "ディディム利用機関 ({{count}})",
        "de": "Didim organizations ({{count}})",
        "en": "Didim organizations ({{count}})",
        "zh-Hans": "Didim 使用机构（{{count}}）",
        "zh-Hant": "Didim 使用機構（{{count}}）"
    },
    {
        "key": "disconnected",
        "ko": "연결끊김",
        "ja": "切断",
        "de": "Getrennt",
        "en": "Disconnected",
        "zh-Hans": "已断开连接",
        "zh-Hant": "已斷開連接"
    },
    {
        "key": "distance_by_activity",
        "ko": "활동으로 이동한 거리",
        "ja": "活動で移動した距離",
        "de": "Strecke nach Aktivität",
        "en": "Distance by activity",
        "zh-Hans": "活动移动距离",
        "zh-Hant": "活動移動距離"
    },
    {
        "key": "division_1",
        "ko": "세부소속1",
        "ja": "細部所属1",
        "de": "Division 1",
        "en": "Division 1",
        "zh-Hans": "详细所属1",
        "zh-Hant": "詳細所屬1"
    },
    {
        "key": "division_2",
        "ko": "세부소속2",
        "ja": "細部所属2",
        "de": "Division 2",
        "en": "Division 2",
        "zh-Hans": "详细所属2",
        "zh-Hant": "詳細所屬2"
    },
    {
        "key": "do_you_want_to_approve_and_send_email",
        "ko": "승인처리하고 메일을 보내겠습니까?",
        "ja": "承認してメールを送信しますか？",
        "de": "Do you want to approve and send email?",
        "en": "Do you want to approve and send email?",
        "zh-Hans": "是否批准并发送电子邮件？",
        "zh-Hant": "是否批准並發送電子郵件？"
    },
    {
        "key": "do_you_want_to_delete_from_pending",
        "ko": "승인대기에서 삭제하시겠습니까?",
        "ja": "承認待ちから削除しますか？",
        "de": "Do you want to delete from pending?",
        "en": "Do you want to delete from pending?",
        "zh-Hans": "是否从待批准中删除？",
        "zh-Hant": "是否從待批准中刪除？"
    },
    {
        "key": "do_you_want_to_reject_and_send_email",
        "ko": "반려처리하고 메일을 보내겠습니까?",
        "ja": "却下してメールを送信しますか？",
        "de": "Do you want to reject and send email?",
        "en": "Do you want to reject and send email?",
        "zh-Hans": "是否驳回并发送电子邮件？",
        "zh-Hant": "是否駁回並發送電子郵件？"
    },
    {
        "key": "do_you_want_to_revert_to_pending_approval",
        "ko": "승인대기로 되돌리시겠습니까?",
        "ja": "承認待ちに戻しますか？",
        "de": "Do you want to revert to pending approval?",
        "en": "Do you want to revert to pending approval?",
        "zh-Hans": "是否恢复为待批准？",
        "zh-Hant": "是否恢復為待批准？"
    },
    {
        "key": "does_not_exist",
        "ko": "존재하지 않는 아이디입니다.",
        "ja": "このIDは存在しません。",
        "de": "Existiert nicht.",
        "en": "Does not exist.",
        "zh-Hans": "不存在。",
        "zh-Hant": "不存在。"
    },
    {
        "key": "don_t_have_an_account",
        "ko": "계정이 없으신가요?",
        "ja": "アカウントをお持ちでないですか？",
        "de": "Don't have an account?",
        "en": "Don't have an account?",
        "zh-Hans": "没有账号？",
        "zh-Hant": "沒有帳號？"
    },
    {
        "key": "drag_or_click_to_replace_with_new_file",
        "ko": "새 파일을 드래그하거나 클릭하여 교체",
        "ja": "新しいファイルをドラッグまたはクリックして置換",
        "de": "Datei per Drag & Drop oder Klick ersetzen",
        "en": "Drag or click to replace with new file",
        "zh-Hans": "拖放或点击以替换为新文件",
        "zh-Hant": "拖放或點擊以替換為新檔案"
    },
    {
        "key": "drag_or_click_to_upload_file",
        "ko": "파일을 드래그하거나 클릭하여 업로드",
        "ja": "ファイルをドラッグまたはクリックしてアップロード",
        "de": "Datei per Drag & Drop oder Klick hochladen",
        "en": "Drag or click to upload file",
        "zh-Hans": "拖放或点击以上传文件",
        "zh-Hant": "拖放或點擊以上傳檔案"
    },
    {
        "key": "dresden_metropolitan_city",
        "ko": "드레스덴",
        "ja": "ドレスデン",
        "de": "Dresden",
        "en": "Dresden",
        "zh-Hans": "德累斯顿",
        "zh-Hant": "德累斯頓"
    },
    {
        "key": "dusseldorf_metropolitan_city",
        "ko": "뒤셀도르프",
        "ja": "デュッセルドルフ",
        "de": "Düsseldorf",
        "en": "Düsseldorf",
        "zh-Hans": "杜塞尔多夫",
        "zh-Hant": "杜塞爾多夫"
    },
    {
        "key": "e_mail",
        "ko": "이메일",
        "ja": "メールアドレス",
        "de": "E-mail",
        "en": "E-mail",
        "zh-Hans": "电子邮件",
        "zh-Hant": "電子郵件"
    },
    {
        "key": "earn",
        "ko": "적립",
        "ja": "貯蓄",
        "de": "Verdienen",
        "en": "Earn",
        "zh-Hans": "获得",
        "zh-Hant": "獲得"
    },
    {
        "key": "edit",
        "ko": "수정",
        "ja": "編集",
        "de": "Bearbeiten",
        "en": "Edit",
        "zh-Hans": "修改",
        "zh-Hant": "修改"
    },
    {
        "key": "edit_button",
        "ko": "편집",
        "ja": "編集",
        "de": "Bearbeiten",
        "en": "Edit",
        "zh-Hans": "编辑",
        "zh-Hant": "編輯"
    },
    {
        "key": "edit_details",
        "ko": "상세수정",
        "ja": "詳細編集",
        "de": "Details bearbeiten",
        "en": "Edit details",
        "zh-Hans": "编辑详情",
        "zh-Hant": "編輯詳情"
    },
    {
        "key": "edit_organization",
        "ko": "기관 수정",
        "ja": "機関修正",
        "de": "Organisation bearbeiten",
        "en": "Edit organization",
        "zh-Hans": "编辑机构",
        "zh-Hant": "編輯機構"
    },
    {
        "key": "elementary_school",
        "ko": "초등학교",
        "ja": "小学校",
        "de": "Elementary School",
        "en": "Elementary School",
        "zh-Hans": "小学",
        "zh-Hant": "小學"
    },
    {
        "key": "email",
        "ko": "이메일",
        "ja": "メール",
        "de": "E-Mail",
        "en": "Email",
        "zh-Hans": "电子邮件",
        "zh-Hant": "電子郵件"
    },
    {
        "key": "email_format",
        "ko": "메일형식",
        "ja": "メール形式",
        "de": "E-Mail-Format",
        "en": "Email format",
        "zh-Hans": "电子邮件格式",
        "zh-Hant": "電子郵件格式"
    },
    {
        "key": "email_format_placeholder",
        "ko": "메일형식",
        "ja": "メール形式",
        "de": "E-Mail-Format",
        "en": "email@example.com",
        "zh-Hans": "email@example.com",
        "zh-Hant": "email@example.com"
    },
    {
        "key": "email_has_been_sent",
        "ko": "메일이 전송되었습니다.",
        "ja": "メールが送信されました。",
        "de": "E-Mail wurde gesendet.",
        "en": "Email has been sent.",
        "zh-Hans": "电子邮件已发送。",
        "zh-Hant": "電子郵件已發送。"
    },
    {
        "key": "email_or_password_is_incorrect",
        "ko": "이메일 또는 비밀번호가 올바르지 않습니다.",
        "ja": "メールまたはパスワードが正しくありません。",
        "de": "E-Mail oder Passwort ist falsch.",
        "en": "Email or password is incorrect.",
        "zh-Hans": "电子邮件或密码不正确。",
        "zh-Hant": "電子郵件或密碼不正確。"
    },
    {
        "key": "endurance",
        "ko": "심폐지구력",
        "ja": "心肺持久力",
        "de": "Ausdauer",
        "en": "Endurance",
        "zh-Hans": "心肺耐力",
        "zh-Hant": "心肺耐力"
    },
    {
        "key": "english",
        "ko": "영어",
        "ja": "英語",
        "de": "Englisch",
        "en": "English",
        "zh-Hans": "英语",
        "zh-Hant": "英語"
    },
    {
        "key": "enter",
        "ko": "입력하세요.",
        "ja": "入力してください。",
        "de": "Eingabe.",
        "en": "Enter.",
        "zh-Hans": "请输入。",
        "zh-Hant": "請輸入。"
    },
    {
        "key": "enter_address",
        "ko": "주소를 입력하세요.",
        "ja": "住所を入力してください。",
        "de": "Adresse eingeben.",
        "en": "Enter address.",
        "zh-Hans": "请输入地址。",
        "zh-Hant": "請輸入地址。"
    },
    {
        "key": "enter_address_detail",
        "ko": "상세주소를 입력하세요.",
        "ja": "詳細住所を入力してください。",
        "de": "Adressdetails eingeben.",
        "en": "Enter address detail.",
        "zh-Hans": "请输入详细地址。",
        "zh-Hant": "請輸入詳細地址。"
    },
    {
        "key": "enter_championship_name",
        "ko": "대회명을 입력해주세요.",
        "ja": "大会名を入力してください。",
        "de": "Meisterschaftsname eingeben.",
        "en": "Enter championship name.",
        "zh-Hans": "请输入大赛名称。",
        "zh-Hant": "請輸入大賽名稱。"
    },
    {
        "key": "enter_championship_organization_name",
        "ko": "대회기관명을 입력해주세요.",
        "ja": "大会機関名を入力してください。",
        "de": "Name der Meisterschaftsorganisation eingeben.",
        "en": "Enter championship organization name.",
        "zh-Hans": "请输入大赛机构名称。",
        "zh-Hant": "請輸入大賽機構名稱。"
    },
    {
        "key": "enter_contact_email",
        "ko": "담당자 메일을 입력하세요.",
        "ja": "担当者メールを入力してください。",
        "de": "Kontakt-E-Mail eingeben.",
        "en": "Enter contact email.",
        "zh-Hans": "请输入联系人邮箱。",
        "zh-Hant": "請輸入聯絡人郵箱。"
    },
    {
        "key": "enter_contact_name",
        "ko": "담당자명을 입력하세요.",
        "ja": "担当者名を入力してください。",
        "de": "Kontaktname eingeben.",
        "en": "Enter contact name.",
        "zh-Hans": "请输入联系人姓名。",
        "zh-Hant": "請輸入聯絡人姓名。"
    },
    {
        "key": "enter_contact_phone",
        "ko": "담당자 연락처를 입력하세요.",
        "ja": "担当者連絡先を入力してください。",
        "de": "Kontakttelefon eingeben.",
        "en": "Enter contact phone.",
        "zh-Hans": "请输入联系人电话。",
        "zh-Hant": "請輸入聯絡人電話。"
    },
    {
        "key": "enter_contact_title",
        "ko": "담당자직책을 입력하세요.",
        "ja": "担当者役職を入力してください。",
        "de": "Kontaktbezeichnung eingeben.",
        "en": "Enter contact title.",
        "zh-Hans": "请输入联系人职务。",
        "zh-Hant": "請輸入聯絡人職務。"
    },
    {
        "key": "enter_content_for_the_organization_contact_when_rejecting_or_deleting",
        "ko": "반려 및 삭제시 기관담당자에게 필요내용을 입력해주세요.",
        "ja": "却下・削除時に機関担当者へ必要な内容を入力してください。",
        "de": "Geben Sie bei Ablehnung oder Löschung einen Inhalt für den Organisationskontakt ein.",
        "en": "Enter content for the organization contact when rejecting or deleting.",
        "zh-Hans": "驳回或删除时，请输入需要告知机构联系人的内容。",
        "zh-Hant": "駁回或刪除時，請輸入需要告知機構聯絡人的內容。"
    },
    {
        "key": "enter_email",
        "ko": "이메일 주소 입력",
        "ja": "メールアドレスを入力してください",
        "de": "E-Mail eingeben",
        "en": "Enter email",
        "zh-Hans": "输入电子邮件",
        "zh-Hant": "輸入電子郵件"
    },
    {
        "key": "enter_latitude",
        "ko": "위도를 입력하세요.",
        "ja": "緯度を入力してください。",
        "de": "Breitengrad eingeben.",
        "en": "Enter latitude.",
        "zh-Hans": "请输入纬度。",
        "zh-Hant": "請輸入緯度。"
    },
    {
        "key": "enter_longitude",
        "ko": "경도를 입력하세요.",
        "ja": "経度を入力してください。",
        "de": "Längengrad eingeben.",
        "en": "Enter longitude.",
        "zh-Hans": "请输入经度。",
        "zh-Hant": "請輸入經度。"
    },
    {
        "key": "enter_name",
        "ko": "이름을 입력하세요.",
        "ja": "名前を入力してください。",
        "de": "Name eingeben.",
        "en": "Enter name.",
        "zh-Hans": "请输入姓名。",
        "zh-Hant": "請輸入姓名。"
    },
    {
        "key": "enter_new_admin_account_password",
        "ko": "새 관리자계정의 비밀번호를 입력하세요.",
        "ja": "新しい管理者アカウントのパスワードを入力してください。",
        "de": "Neues Administratorpasswort eingeben.",
        "en": "Enter new admin account password.",
        "zh-Hans": "请输入新管理员账号的密码。",
        "zh-Hant": "請輸入新管理員帳號的密碼。"
    },
    {
        "key": "enter_new_password_to_change",
        "ko": "비밀번호를 변경하려면 새 비밀번호를 입력하세요.",
        "ja": "パスワードを変更する場合は新しいパスワードを入力してください。",
        "de": "Neues Passwort zur Änderung eingeben.",
        "en": "Enter new password to change.",
        "zh-Hans": "若要更改密码，请输入新密码。",
        "zh-Hant": "若要變更密碼，請輸入新密碼。"
    },
    {
        "key": "enter_organization_name",
        "ko": "기관이름을 입력하세요.",
        "ja": "機関名を入力してください。",
        "de": "Organisationsname eingeben.",
        "en": "Enter organization name.",
        "zh-Hans": "请输入机构名称。",
        "zh-Hant": "請輸入機構名稱。"
    },
    {
        "key": "enter_part_of_address_e_g_seoul_sejong_daero_110",
        "ko": "주소 일부를 입력하세요. (예: 서울시, 세종대로 110)",
        "ja": "住所の一部を入力してください. (例：서울시, 세종대로 110))",
        "de": "Enter part of address (e.g. 서울시, 세종대로 110))",
        "en": "Enter part of address (e.g. 서울시, 세종대로 110))",
        "zh-Hans": "请输入部分地址。（例：首尔市，世宗大路110）",
        "zh-Hant": "請輸入部分地址。（例：首爾市，世宗大路110）"
    },
    {
        "key": "enter_password",
        "ko": "비밀번호 입력",
        "ja": "パスワードを入力",
        "de": "Passwort eingeben",
        "en": "Enter password",
        "zh-Hans": "输入密码",
        "zh-Hant": "輸入密碼"
    },
    {
        "key": "enter_your_email",
        "ko": "이메일을 입력하세요.",
        "ja": "メールアドレスを 입력してください。",
        "de": "E-Mail eingeben.",
        "en": "Enter your email.",
        "zh-Hans": "请输入您的电子邮件。",
        "zh-Hant": "請輸入您的電子郵件。"
    },
    {
        "key": "enter_your_password",
        "ko": "비밀번호를 입력하세요.",
        "ja": "パスワードを入力してください。",
        "de": "Passwort eingeben.",
        "en": "Enter your password.",
        "zh-Hans": "请输入您的密码。",
        "zh-Hant": "請輸入您的密碼。"
    },
    {
        "key": "enter_zip_code",
        "ko": "우편번호를 입력하세요.",
        "ja": "郵便番号を入力してください。",
        "de": "Postleitzahl eingeben.",
        "en": "Enter zip code.",
        "zh-Hans": "请输入邮政编码。",
        "zh-Hant": "請輸入郵遞區號。"
    },
    {
        "key": "error",
        "ko": "오류",
        "ja": "エラー",
        "de": "Fehler",
        "en": "Error",
        "zh-Hans": "错误",
        "zh-Hant": "錯誤"
    },
    {
        "key": "esslingen_metropolitan_city",
        "ko": "에슬링겐",
        "ja": "エスリンゲン",
        "de": "Esslingen",
        "en": "Esslingen",
        "zh-Hans": "埃斯林根",
        "zh-Hant": "埃斯林根"
    },
    {
        "key": "event",
        "ko": "이벤트",
        "ja": "イベント",
        "de": "Veranstaltung",
        "en": "Event",
        "zh-Hans": "活动",
        "zh-Hant": "活動"
    },
    {
        "key": "event_add_edit",
        "ko": "이벤트 추가/수정",
        "ja": "イベント 追加/編集",
        "de": "Event add/edit",
        "en": "Event add/edit",
        "zh-Hans": "添加/编辑活动",
        "zh-Hant": "新增/編輯活動"
    },
    {
        "key": "event_detail",
        "ko": "이벤트 상세",
        "ja": "イベント 詳細",
        "de": "Veranstaltungsdetails",
        "en": "Event detail",
        "zh-Hans": "活动详情",
        "zh-Hant": "活動詳情"
    },
    {
        "key": "event_image",
        "ko": "이벤트 이미지",
        "ja": "イベント画像",
        "de": "Veranstaltungsbild",
        "en": "Event image",
        "zh-Hans": "活动图片",
        "zh-Hant": "活動圖片"
    },
    {
        "key": "event_list",
        "ko": "이벤트 목록",
        "ja": "イベント 一覧",
        "de": "Veranstaltungsliste",
        "en": "Event list",
        "zh-Hans": "活动列表",
        "zh-Hant": "活動清單"
    },
    {
        "key": "event_management",
        "ko": "이벤트 관리",
        "ja": "イベント 管理",
        "de": "Veranstaltungsverwaltung",
        "en": "Event management",
        "zh-Hans": "活动管理",
        "zh-Hant": "活動管理"
    },
    {
        "key": "event_name",
        "ko": "이벤트 명칭",
        "ja": "イベント名",
        "de": "Eventname",
        "en": "Event name",
        "zh-Hans": "活动名称",
        "zh-Hant": "活動名稱"
    },
    {
        "key": "event_post_end_date",
        "ko": "게시마감일",
        "ja": "掲載終了日",
        "de": "Beitragsende",
        "en": "Post end date",
        "zh-Hans": "发布结束日期",
        "zh-Hant": "發布結束日期"
    },
    {
        "key": "event_post_start_date",
        "ko": "게시시작일",
        "ja": "掲載開始日",
        "de": "Beitragsbeginn",
        "en": "Post start date",
        "zh-Hans": "发布开始日期",
        "zh-Hant": "發布開始日期"
    },
    {
        "key": "event_save_failed",
        "ko": "이벤트 저장에 실패했습니다.",
        "ja": "イベントの保存に失敗しました。",
        "de": "Event konnte nicht gespeichert werden.",
        "en": "Failed to save event.",
        "zh-Hans": "保存活动失败。",
        "zh-Hant": "儲存活動失敗。"
    },
    {
        "key": "event_status_before_start",
        "ko": "시작전",
        "ja": "開始前",
        "de": "Vor Start",
        "en": "Before start",
        "zh-Hans": "开始前",
        "zh-Hant": "開始前"
    },
    {
        "key": "event_status_ongoing",
        "ko": "진행중",
        "ja": "進行中",
        "de": "Laufend",
        "en": "Ongoing",
        "zh-Hans": "进行中",
        "zh-Hant": "進行中"
    },
    {
        "key": "event_type",
        "ko": "이벤트타입",
        "ja": "イベントタイプ",
        "de": "Eventtyp",
        "en": "Event type",
        "zh-Hans": "活动类型",
        "zh-Hant": "活動類型"
    },
    {
        "key": "event_winner_count",
        "ko": "당첨자(기관)수",
        "ja": "当選者（機関）数",
        "de": "Gewinner (Organisation) Anzahl",
        "en": "Winner (organization) count",
        "zh-Hans": "中奖者（机构）数",
        "zh-Hant": "中獎者（機構）數"
    },
    {
        "key": "exercise",
        "ko": "운동",
        "ja": "運動",
        "de": "Übung",
        "en": "Exercise",
        "zh-Hans": "运动",
        "zh-Hant": "運動"
    },
    {
        "key": "exercise_activity",
        "ko": "운동 활동",
        "ja": "運動活動",
        "de": "Trainingsaktivität",
        "en": "Exercise activity",
        "zh-Hans": "运动活动",
        "zh-Hant": "運動活動"
    },
    {
        "key": "exercise_report",
        "ko": "운동 리포트",
        "ja": "運動レポート",
        "de": "Trainingsbericht",
        "en": "Exercise report",
        "zh-Hans": "运动报告",
        "zh-Hant": "運動報告"
    },
    {
        "key": "existing",
        "ko": "기존",
        "ja": "既存",
        "de": "Vorhanden",
        "en": "Existing",
        "zh-Hans": "现有",
        "zh-Hant": "現有"
    },
    {
        "key": "existing_attachment",
        "ko": "기존 첨부서류",
        "ja": "既存の添付書類",
        "de": "Vorhandener Anhang",
        "en": "Existing attachment",
        "zh-Hans": "现有附件材料",
        "zh-Hant": "現有附件材料"
    },
    {
        "key": "existing_attachment_file",
        "ko": "기존 첨부파일",
        "ja": "既存の添付ファイル",
        "de": "Vorhandene Anhangdatei",
        "en": "Existing attachment file",
        "zh-Hans": "现有附件文件",
        "zh-Hant": "現有附件檔案"
    },
    {
        "key": "existing_file",
        "ko": "기존 파일",
        "ja": "既存のファイル",
        "de": "Vorhandene Datei",
        "en": "Existing file",
        "zh-Hans": "现有文件",
        "zh-Hant": "現有檔案"
    },
    {
        "key": "exp",
        "ko": "경험치",
        "ja": "経験値",
        "de": "EXP",
        "en": "EXP",
        "zh-Hans": "经验值",
        "zh-Hant": "經驗值"
    },
    {
        "key": "experience",
        "ko": "경험치",
        "ja": "経験値",
        "de": "Erfahrung",
        "en": "Experience",
        "zh-Hans": "经验",
        "zh-Hant": "經驗"
    },
    {
        "key": "expire",
        "ko": "소멸",
        "ja": "失効",
        "de": "Expire",
        "en": "Expire",
        "zh-Hans": "到期",
        "zh-Hant": "到期"
    },
    {
        "key": "expiring_this_month",
        "ko": "이달 소멸예정:",
        "ja": "今月失効予定：",
        "de": "Expiring this month:",
        "en": "Expiring this month:",
        "zh-Hans": "本月即将到期：",
        "zh-Hant": "本月即將到期："
    },
    {
        "key": "failed_title",
        "ko": "아쉬워요 😢",
        "ja": "残念です 😢",
        "de": "Leider 😢",
        "en": "Sorry 😢",
        "zh-Hans": "真可惜 😢",
        "zh-Hant": "真可惜 😢"
    },
    {
        "key": "failed_to_change_password",
        "ko": "비밀번호 변경에 실패했습니다.",
        "ja": "パスワードの変更に失敗しました。",
        "de": "Passwortänderung fehlgeschlagen.",
        "en": "Failed to change password.",
        "zh-Hans": "更改密码失败。",
        "zh-Hant": "變更密碼失敗。"
    },
    {
        "key": "failed_to_delete_championship",
        "ko": "대회 삭제에 실패했습니다.",
        "ja": "大会の削除に失敗しました。",
        "de": "Meisterschaft konnte nicht gelöscht werden.",
        "en": "Failed to delete championship.",
        "zh-Hans": "删除大赛失败。",
        "zh-Hant": "刪除大賽失敗。"
    },
    {
        "key": "failed_to_delete_organization_please_try_again",
        "ko": "기관 삭제에 실패했습니다. 다시 시도해주세요.",
        "ja": "機関の削除に失敗しました。もう一度お試しください。",
        "de": "Organisation konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
        "en": "Failed to delete organization. Please try again.",
        "zh-Hans": "删除机构失败。请重试。",
        "zh-Hant": "刪除機構失敗。請重試。"
    },
    {
        "key": "failed_to_initialize_camera",
        "ko": "카메라 초기화에 실패했습니다.",
        "ja": "カメラの初期化に失敗しました。",
        "de": "Kamera konnte nicht initialisiert werden.",
        "en": "Failed to initialize camera.",
        "zh-Hans": "初始化相机失败。",
        "zh-Hant": "初始化相機失敗。"
    },
    {
        "key": "failed_to_initialize_camera_name",
        "ko": "카메라 초기화에 실패했습니다. ({{name}})",
        "ja": "カメラの初期化に失敗しました。({{name}})",
        "de": "Kamera konnte nicht initialisiert werden. ({{name}})",
        "en": "Failed to initialize camera. ({{name}})",
        "zh-Hans": "初始化相机失败。（{{name}}）",
        "zh-Hant": "初始化相機失敗。（{{name}}）"
    },
    {
        "key": "failed_to_load_championship_list",
        "ko": "챔피언십 목록을 불러오는데 실패했습니다.",
        "ja": "チャンピオンシップ一覧の読み込みに失敗しました。",
        "de": "Meisterschaftsliste konnte nicht geladen werden.",
        "en": "Failed to load championship list.",
        "zh-Hans": "加载锦标赛列表失败。",
        "zh-Hant": "載入錦標賽清單失敗。"
    },
    {
        "key": "failed_to_load_content_list",
        "ko": "콘텐츠 목록을 불러오는데 실패했습니다.",
        "ja": "コンテンツ一覧の読み込みに失敗しました。",
        "de": "Inhaltsliste konnte nicht geladen werden.",
        "en": "Failed to load content list.",
        "zh-Hans": "加载内容列表失败。",
        "zh-Hant": "載入內容清單失敗。"
    },
    {
        "key": "failed_to_load_didim_list",
        "ko": "디딤 목록을 불러오는데 실패했습니다.",
        "ja": "ディディム一覧の読み込みに失敗しました。",
        "de": "Didim-Liste konnte nicht geladen werden.",
        "en": "Failed to load Didim list.",
        "zh-Hans": "加载 Didim 列表失败。",
        "zh-Hant": "載入 Didim 清單失敗。"
    },
    {
        "key": "failed_to_load_event_list",
        "ko": "이벤트 목록을 불러오는데 실패했습니다.",
        "ja": "イベント一覧の読み込みに失敗しました。",
        "de": "Veranstaltungsliste konnte nicht geladen werden.",
        "en": "Failed to load event list.",
        "zh-Hans": "加载活动列表失败。",
        "zh-Hant": "載入活動清單失敗。"
    },
    {
        "key": "failed_to_load_organization_information",
        "ko": "기관 정보를 불러오는데 실패했습니다.",
        "ja": "機関情報の読み込みに失敗しました。",
        "de": "Organisationsinformationen konnten nicht geladen werden.",
        "en": "Failed to load organization information.",
        "zh-Hans": "加载机构信息失败。",
        "zh-Hant": "載入機構資訊失敗。"
    },
    {
        "key": "failed_to_load_organization_list",
        "ko": "기관 목록을 불러오는데 실패했습니다.",
        "ja": "機関一覧の読み込みに失敗しました。",
        "de": "Organisationsliste konnte nicht geladen werden.",
        "en": "Failed to load organization list.",
        "zh-Hans": "加载机构列表失败。",
        "zh-Hant": "載入機構清單失敗。"
    },
    {
        "key": "failed_to_load_organizations",
        "ko": "기관 로드 오류",
        "ja": "機関の読み込みに失敗しました",
        "de": "Organisationen konnten nicht geladen werden",
        "en": "Failed to load organizations",
        "zh-Hans": "加载机构失败",
        "zh-Hant": "載入機構失敗"
    },
    {
        "key": "failed_to_load_user_list",
        "ko": "사용자 데이터를 불러오는데 실패했습니다.",
        "ja": "ユーザーデータの読み込みに失敗しました。",
        "de": "Benutzerliste konnte nicht geladen werden.",
        "en": "Failed to load user list.",
        "zh-Hans": "加载用户列表失败。",
        "zh-Hant": "載入使用者清單失敗。"
    },
    {
        "key": "failed_to_send_verification_code",
        "ko": "인증코드 전송에 실패했습니다.",
        "ja": "認証コードの送信に失敗しました。",
        "de": "Bestätigungscode konnte nicht gesendet werden.",
        "en": "Failed to send verification code.",
        "zh-Hans": "发送验证码失败。",
        "zh-Hant": "發送驗證碼失敗。"
    },
    {
        "key": "failed_to_update_organization_information",
        "ko": "기관 정보 수정에 실패했습니다.",
        "ja": "機関情報の更新に失敗しました。",
        "de": "Organisationsinformationen konnten nicht aktualisiert werden.",
        "en": "Failed to update organization information.",
        "zh-Hans": "更新机构信息失败。",
        "zh-Hant": "更新機構資訊失敗。"
    },
    {
        "key": "failed_to_update_user_information",
        "ko": "사용자 정보 수정에 실패했습니다.",
        "ja": "ユーザー情報の更新に失敗しました。",
        "de": "Benutzerinformationen konnten nicht aktualisiert werden.",
        "en": "Failed to update user information.",
        "zh-Hans": "更新用户信息失败。",
        "zh-Hant": "更新使用者資訊失敗。"
    },
    {
        "key": "failed_to_upload_profile_image",
        "ko": "프로필 이미지 업로드에 실패했습니다.",
        "ja": "プロフィール画像のアップロードに失敗しました。",
        "de": "Profilbild konnte nicht hochgeladen werden.",
        "en": "Failed to upload profile image.",
        "zh-Hans": "上传个人资料图片失败。",
        "zh-Hant": "上傳個人資料圖片失敗。"
    },
    {
        "key": "failed_to_upload_profile_photo_message",
        "ko": "프로필 이미지 업로드 실패: {{message}}",
        "ja": "プロフィール写真のアップロードに失敗しました：{{message}}",
        "de": "Profilfoto konnte nicht hochgeladen werden: {{message}}",
        "en": "Failed to upload profile photo: {{message}}",
        "zh-Hans": "上传个人资料照片失败：{{message}}",
        "zh-Hant": "上傳個人資料照片失敗：{{message}}"
    },
    {
        "key": "female",
        "ko": "여성",
        "ja": "女性",
        "de": "Weiblich",
        "en": "Female",
        "zh-Hans": "女性",
        "zh-Hant": "女性"
    },
    {
        "key": "file",
        "ko": "파일",
        "ja": "ファイル",
        "de": "Datei",
        "en": "File",
        "zh-Hans": "文件",
        "zh-Hant": "檔案"
    },
    {
        "key": "file_selection_failed",
        "ko": "파일 선택에 실패했습니다.",
        "ja": "ファイルの選択に失敗しました。",
        "de": "Dateiauswahl fehlgeschlagen.",
        "en": "File selection failed.",
        "zh-Hans": "文件选择失败。",
        "zh-Hant": "檔案選擇失敗。"
    },
    {
        "key": "file_size_cannot_exceed_10mb",
        "ko": "파일 크기는 10MB를 초과할 수 없습니다.",
        "ja": "ファイルサイズは10MBを超えることはできません。",
        "de": "Die Dateigröße darf 10 MB nicht überschreiten.",
        "en": "File size cannot exceed 10MB.",
        "zh-Hans": "文件大小不能超过 10MB。",
        "zh-Hant": "檔案大小不能超過 10MB。"
    },
    {
        "key": "file_size_max_10mb",
        "ko": "파일 크기는 10MB를 초과할 수 없습니다.",
        "ja": "ファイルサイズは10MBを超えることはできません。",
        "de": "Dateigröße darf 10MB nicht überschreiten.",
        "en": "File size cannot exceed 10MB.",
        "zh-Hans": "文件大小不能超过 10MB。",
        "zh-Hant": "檔案大小不能超過 10MB。"
    },
    {
        "key": "file_size_max_5mb",
        "ko": "파일 크기는 5MB를 초과할 수 없습니다.",
        "ja": "ファイルサイズは5MBを超えることはできません。",
        "de": "Die Dateigröße darf 5 MB nicht überschreiten.",
        "en": "File size cannot exceed 5MB.",
        "zh-Hans": "文件大小不能超过 5MB。",
        "zh-Hant": "檔案大小不能超過 5MB。"
    },
    {
        "key": "final",
        "ko": "2강",
        "ja": "決勝",
        "de": "Final",
        "en": "Final",
        "zh-Hans": "决赛",
        "zh-Hant": "決賽"
    },
    {
        "key": "find_password",
        "ko": "비밀번호 찾기",
        "ja": "パスワードをお忘れの方",
        "de": "Passwort finden",
        "en": "Find password",
        "zh-Hans": "找回密码",
        "zh-Hant": "找回密碼"
    },
    {
        "key": "flexibility",
        "ko": "유연성",
        "ja": "柔軟性",
        "de": "Flexibility",
        "en": "Flexibility",
        "zh-Hans": "柔韧性",
        "zh-Hant": "柔韌性"
    },
    {
        "key": "floors",
        "ko": "층",
        "ja": "階",
        "de": "floors",
        "en": "floors",
        "zh-Hans": "层",
        "zh-Hant": "層"
    },
    {
        "key": "for_grade_and_class_rankings_and_statistics",
        "ko": "* 학년별, 반별 랭킹 및 통계를 위한 소속구분입니다.",
        "ja": "* 学年別・クラス別ランキングと統計のための所属区分です。",
        "de": "* Für Klassen- und Stufen-Rankings sowie Statistiken.",
        "en": "* For grade and class rankings and statistics.",
        "zh-Hans": "* 用于按年级、班级统计排名和数据的所属分类。",
        "zh-Hant": "* 用於按年級、班級統計排名和資料的所屬分類。"
    },
    {
        "key": "force_end",
        "ko": "강제종료",
        "ja": "強制終了",
        "de": "Erzwingen beenden",
        "en": "Force end",
        "zh-Hans": "强制结束",
        "zh-Hant": "強制結束"
    },
    {
        "key": "force_end_failed",
        "ko": "강제종료에 실패했습니다.",
        "ja": "強制終了に失敗しました。",
        "de": "Erzwungenes Beenden fehlgeschlagen.",
        "en": "Force end failed.",
        "zh-Hans": "强制结束失败。",
        "zh-Hant": "強制結束失敗。"
    },
    {
        "key": "frankfurt_metropolitan_city",
        "ko": "프랑크푸르트",
        "ja": "フランクフルト",
        "de": "Frankfurt am Main",
        "en": "Frankfurt",
        "zh-Hans": "法兰克福",
        "zh-Hant": "法蘭克福"
    },
    {
        "key": "fri",
        "ko": "금",
        "ja": "金",
        "de": "Fri",
        "en": "Fri",
        "zh-Hans": "周五",
        "zh-Hant": "周五"
    },
    {
        "key": "fukuoka_metropolitan_city",
        "ko": "후쿠오카",
        "ja": "福岡市",
        "de": "Fukuoka",
        "en": "Fukuoka",
        "zh-Hans": "福冈",
        "zh-Hant": "福岡"
    },
    {
        "key": "gangwon",
        "ko": "강원",
        "ja": "江原",
        "de": "Gangwon",
        "en": "Gangwon",
        "zh-Hans": "江原",
        "zh-Hant": "江原"
    },
    {
        "key": "gangwon_province",
        "ko": "강원도",
        "ja": "江原道",
        "de": "Gangwon Province",
        "en": "Gangwon Province",
        "zh-Hans": "江原道",
        "zh-Hant": "江原道"
    },
    {
        "key": "gender",
        "ko": "성별",
        "ja": "性別",
        "de": "Gender",
        "en": "Gender",
        "zh-Hans": "性别",
        "zh-Hant": "性別"
    },
    {
        "key": "general",
        "ko": "0. 일반",
        "ja": "0. 一般",
        "de": "Allgemein",
        "en": "General",
        "zh-Hans": "0. 普通",
        "zh-Hant": "0. 普通"
    },
    {
        "key": "general_admin_add",
        "ko": "일반관리자 추가",
        "ja": "一般管理者を追加",
        "de": "Allgemeinadministrator hinzufügen",
        "en": "Add general administrator",
        "zh-Hans": "添加普通管理员",
        "zh-Hant": "新增普通管理員"
    },
    {
        "key": "general_admin_confirm_delete",
        "ko": "일반관리자를 삭제하시겠습니까?",
        "ja": "一般管理者を削除しますか？",
        "de": "Möchten Sie diesen Allgemeinadministrator löschen?",
        "en": "Do you want to delete this general administrator?",
        "zh-Hans": "确定要删除此普通管理员吗？",
        "zh-Hant": "確定要刪除此普通管理員嗎？"
    },
    {
        "key": "general_admin_confirm_edit",
        "ko": "일반관리자를 수정하시겠습니까?",
        "ja": "一般管理者を修正しますか？",
        "de": "Möchten Sie diesen Allgemeinadministrator bearbeiten?",
        "en": "Do you want to edit this general administrator?",
        "zh-Hans": "确定要编辑此普通管理员吗？",
        "zh-Hant": "確定要編輯此普通管理員嗎？"
    },
    {
        "key": "general_admin_confirm_register",
        "ko": "일반관리자를 등록하시겠습니까?",
        "ja": "一般管理者を登録しますか？",
        "de": "Möchten Sie diesen Allgemeinadministrator registrieren?",
        "en": "Do you want to register this general administrator?",
        "zh-Hans": "确定要注册此普通管理员吗？",
        "zh-Hant": "確定要註冊此普通管理員嗎？"
    },
    {
        "key": "general_admin_delete_failed",
        "ko": "일반관리자 삭제 중 오류가 발생했습니다. 다시 시도해주세요.",
        "ja": "削除中にエラーが発生しました。もう一度お試しください。",
        "de": "Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "en": "An error occurred while deleting. Please try again.",
        "zh-Hans": "删除时发生错误。请重试。",
        "zh-Hant": "刪除時發生錯誤。請重試。"
    },
    {
        "key": "general_admin_deleted_cannot_recover",
        "ko": "삭제된 일반관리자는 복구할 수 없습니다.",
        "ja": "削除した一般管理者は復元できません。",
        "de": "Gelöschte Allgemeinadministratoren können nicht wiederhergestellt werden.",
        "en": "Deleted general administrator cannot be recovered.",
        "zh-Hans": "已删除的普通管理员无法恢复。",
        "zh-Hant": "已刪除的普通管理員無法恢復。"
    },
    {
        "key": "general_admin_deleted_successfully",
        "ko": "일반관리자가 성공적으로 삭제되었습니다.",
        "ja": "一般管理者が正常に削除されました。",
        "de": "Allgemeinadministrator wurde erfolgreich gelöscht.",
        "en": "General administrator has been deleted successfully.",
        "zh-Hans": "普通管理员已成功删除。",
        "zh-Hant": "普通管理員已成功刪除。"
    },
    {
        "key": "general_admin_list",
        "ko": "일반관리자 목록",
        "ja": "一般管理者一覧",
        "de": "Liste der Allgemeinadministratoren",
        "en": "General administrator list",
        "zh-Hans": "普通管理员列表",
        "zh-Hant": "普通管理員清單"
    },
    {
        "key": "general_admin_list_load_failed",
        "ko": "일반관리자 목록을 불러오는데 실패했습니다.",
        "ja": "一般管理者一覧の読み込みに失敗しました。",
        "de": "Allgemeinadministratorenliste konnte nicht geladen werden.",
        "en": "Failed to load general administrator list.",
        "zh-Hans": "加载普通管理员列表失败。",
        "zh-Hant": "載入普通管理員清單失敗。"
    },
    {
        "key": "general_admin_list_loading",
        "ko": "일반관리자 목록을 불러오는 중...",
        "ja": "一般管理者一覧を読み込み中...",
        "de": "Allgemeinadministratorenliste wird geladen...",
        "en": "Loading general administrator list...",
        "zh-Hans": "正在加载普通管理员列表...",
        "zh-Hant": "正在載入普通管理員清單..."
    },
    {
        "key": "general_admin_no_data",
        "ko": "일반관리자 데이터가 없습니다.",
        "ja": "一般管理者データがありません。",
        "de": "Keine Allgemeinadministratorendaten.",
        "en": "No general administrator data.",
        "zh-Hans": "没有普通管理员数据。",
        "zh-Hant": "沒有普通管理員資料。"
    },
    {
        "key": "general_admin_registered_will_activate",
        "ko": "등록된 일반관리자는 즉시 활성화됩니다.",
        "ja": "登録した一般管理者は即座に有効になります。",
        "de": "Der registrierte Allgemeinadministrator wird sofort aktiviert.",
        "en": "The registered general administrator will be activated immediately.",
        "zh-Hans": "注册的普通管理员将立即启用。",
        "zh-Hant": "註冊的普通管理員將立即啟用。"
    },
    {
        "key": "general_admin_save_failed",
        "ko": "일반관리자 저장 중 오류가 발생했습니다. 다시 시도해주세요.",
        "ja": "保存中にエラーが発生しました。もう一度お試しください。",
        "de": "Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "en": "An error occurred while saving. Please try again.",
        "zh-Hans": "保存时发生错误。请重试。",
        "zh-Hant": "儲存時發生錯誤。請重試。"
    },
    {
        "key": "general_admin_saved_successfully",
        "ko": "일반관리자가 성공적으로 저장되었습니다.",
        "ja": "一般管理者が正常に保存されました。",
        "de": "Allgemeinadministrator wurde erfolgreich gespeichert.",
        "en": "General administrator has been saved successfully.",
        "zh-Hans": "普通管理员已成功保存。",
        "zh-Hant": "普通管理員已成功儲存。"
    },
    {
        "key": "general_admin_updated_will_save",
        "ko": "수정된 내용이 저장됩니다.",
        "ja": "変更内容が保存されます。",
        "de": "Ihre Änderungen werden gespeichert.",
        "en": "Your changes will be saved.",
        "zh-Hans": "修改内容将被保存。",
        "zh-Hant": "修改內容將被儲存。"
    },
    {
        "key": "general_management",
        "ko": "일반 관리",
        "ja": "一般管理",
        "de": "Allgemeine Verwaltung",
        "en": "General management",
        "zh-Hans": "普通管理",
        "zh-Hant": "普通管理"
    },
    {
        "key": "german",
        "ko": "독일어",
        "ja": "ドイツ語",
        "de": "Deutsch",
        "en": "German",
        "zh-Hans": "德语",
        "zh-Hant": "德語"
    },
    {
        "key": "germany",
        "ko": "독일",
        "ja": "ドイツ",
        "de": "Deutschland",
        "en": "Germany",
        "zh-Hans": "德国",
        "zh-Hant": "德國"
    },
    {
        "key": "goal",
        "ko": "목표",
        "ja": "目標",
        "de": "Ziel",
        "en": "Goal",
        "zh-Hans": "目标",
        "zh-Hant": "目標"
    },
    {
        "key": "goal_achieved",
        "ko": "목표 달성",
        "ja": "目標達成",
        "de": "Ziel erreicht",
        "en": "Goal achieved",
        "zh-Hans": "目标达成",
        "zh-Hant": "目標達成"
    },
    {
        "key": "goal_achieved_days",
        "ko": "목표 달성한 날",
        "ja": "目標達成した日",
        "de": "Tage mit Ziel erreicht",
        "en": "Goal achieved days",
        "zh-Hans": "达成目标的天数",
        "zh-Hant": "達成目標的天數"
    },
    {
        "key": "google_account",
        "ko": "구글계정",
        "ja": "Googleアカウント",
        "de": "Google-Konto",
        "en": "Google Account",
        "zh-Hans": "Google 账号",
        "zh-Hant": "Google 帳號"
    },
    {
        "key": "grade",
        "ko": "학년",
        "ja": "学年",
        "de": "Stufe",
        "en": "Grade",
        "zh-Hans": "年级",
        "zh-Hant": "年級"
    },
    {
        "key": "grade_1",
        "ko": "1학년",
        "ja": "1年生",
        "de": "Grade 1",
        "en": "Grade 1",
        "zh-Hans": "1年级",
        "zh-Hant": "1年級"
    },
    {
        "key": "grade_2",
        "ko": "2학년",
        "ja": "2年生",
        "de": "Grade 2",
        "en": "Grade 2",
        "zh-Hans": "2年级",
        "zh-Hant": "2年級"
    },
    {
        "key": "grade_3",
        "ko": "3학년",
        "ja": "3年生",
        "de": "Grade 3",
        "en": "Grade 3",
        "zh-Hans": "3年级",
        "zh-Hant": "3年級"
    },
    {
        "key": "grade_4",
        "ko": "4학년",
        "ja": "4年生",
        "de": "Grade 4",
        "en": "Grade 4",
        "zh-Hans": "4年级",
        "zh-Hant": "4年級"
    },
    {
        "key": "grade_5",
        "ko": "5학년",
        "ja": "5年生",
        "de": "Grade 5",
        "en": "Grade 5",
        "zh-Hans": "5年级",
        "zh-Hant": "5年級"
    },
    {
        "key": "grade_6",
        "ko": "6학년",
        "ja": "6年生",
        "de": "Grade 6",
        "en": "Grade 6",
        "zh-Hans": "6年级",
        "zh-Hant": "6年級"
    },
    {
        "key": "grade_weekend",
        "ko": "주말",
        "ja": "週末",
        "de": "Wochenende",
        "en": "Weekend",
        "zh-Hans": "周末",
        "zh-Hant": "週末"
    },
    {
        "key": "gwangju",
        "ko": "광주",
        "ja": "光州",
        "de": "Gwangju",
        "en": "Gwangju",
        "zh-Hans": "光州",
        "zh-Hant": "光州"
    },
    {
        "key": "gwangju_metropolitan_city",
        "ko": "광주광역시",
        "ja": "光州広域市",
        "de": "Gwangju Metropolitan City",
        "en": "Gwangju Metropolitan City",
        "zh-Hans": "光州广域市",
        "zh-Hant": "光州廣域市"
    },
    {
        "key": "gyeongbuk",
        "ko": "경북",
        "ja": "慶北",
        "de": "Gyeongbuk",
        "en": "Gyeongbuk",
        "zh-Hans": "庆北",
        "zh-Hant": "慶北"
    },
    {
        "key": "gyeonggi",
        "ko": "경기",
        "ja": "京畿",
        "de": "Gyeonggi",
        "en": "Gyeonggi",
        "zh-Hans": "京畿",
        "zh-Hant": "京畿"
    },
    {
        "key": "gyeonggi_province",
        "ko": "경기도",
        "ja": "京畿道",
        "de": "Gyeonggi Province",
        "en": "Gyeonggi Province",
        "zh-Hans": "京畿道",
        "zh-Hant": "京畿道"
    },
    {
        "key": "gyeongnam",
        "ko": "경남",
        "ja": "慶南",
        "de": "Gyeongnam",
        "en": "Gyeongnam",
        "zh-Hans": "庆南",
        "zh-Hant": "慶南"
    },
    {
        "key": "gyeongsangbuk_do",
        "ko": "경상북도",
        "ja": "慶尚北道",
        "de": "Gyeongsangbuk-do",
        "en": "Gyeongsangbuk-do",
        "zh-Hans": "庆尚北道",
        "zh-Hant": "慶尚北道"
    },
    {
        "key": "gyeongsangnam_do",
        "ko": "경상남도",
        "ja": "慶尚南道",
        "de": "Gyeongsangnam-do",
        "en": "Gyeongsangnam-do",
        "zh-Hans": "庆尚南道",
        "zh-Hant": "慶尚南道"
    },
    {
        "key": "hamburg_metropolitan_city",
        "ko": "함부르크",
        "ja": "ハンブルク",
        "de": "Hamburg",
        "en": "Hamburg",
        "zh-Hans": "汉堡",
        "zh-Hant": "漢堡"
    },
    {
        "key": "hannover_metropolitan_city",
        "ko": "하노버",
        "ja": "ハノーファー",
        "de": "Hannover",
        "en": "Hanover",
        "zh-Hans": "汉诺威",
        "zh-Hant": "漢諾威"
    },
    {
        "key": "headcount_ranking",
        "ko": "인원수랭킹",
        "ja": "人数ランキング",
        "de": "Teilnehmer-Ranking",
        "en": "Headcount ranking",
        "zh-Hans": "人数排名",
        "zh-Hant": "人數排名"
    },
    {
        "key": "health_game",
        "ko": "헬스게임",
        "ja": "ヘルスゲーム",
        "de": "Gesundheitsspiel",
        "en": "Health game",
        "zh-Hans": "健康游戏",
        "zh-Hant": "健康遊戲"
    },
    {
        "key": "heart_rate",
        "ko": "심박수",
        "ja": "心拍数",
        "de": "Herzfrequenz",
        "en": "Heart rate",
        "zh-Hans": "心率",
        "zh-Hant": "心率"
    },
    {
        "key": "high",
        "ko": "높음",
        "ja": "高い",
        "de": "High",
        "en": "High",
        "zh-Hans": "高",
        "zh-Hant": "高"
    },
    {
        "key": "high_school",
        "ko": "고등학교",
        "ja": "高等学校",
        "de": "High School",
        "en": "High School",
        "zh-Hans": "高中",
        "zh-Hant": "高中"
    },
    {
        "key": "hiroshima_metropolitan_city",
        "ko": "히로시마",
        "ja": "広島市",
        "de": "Hiroshima",
        "en": "Hiroshima",
        "zh-Hans": "广岛",
        "zh-Hant": "廣島"
    },
    {
        "key": "home",
        "ko": "Home",
        "ja": "ホーム",
        "de": "Startseite",
        "en": "Home",
        "zh-Hans": "首页",
        "zh-Hant": "首頁"
    },
    {
        "key": "host",
        "ko": "주최",
        "ja": "主催",
        "de": "Host",
        "en": "Host",
        "zh-Hans": "主办",
        "zh-Hant": "主辦"
    },
    {
        "key": "hour",
        "ko": "시",
        "ja": "時",
        "de": "Hour",
        "en": "Hour",
        "zh-Hans": "小时",
        "zh-Hant": "小時"
    },
    {
        "key": "hourly_didim_count",
        "ko": "시간별 디딤 수",
        "ja": "時間帯別 ディディム数",
        "de": "Hourly Didim count",
        "en": "Hourly Didim count",
        "zh-Hans": "每小时 Didim 数",
        "zh-Hant": "每小時 Didim 數"
    },
    {
        "key": "hourly_min_max_heart_rate",
        "ko": "시간별 최소 / 최대 심박수",
        "ja": "時間帯別 最小/最大 心拍数",
        "de": "Hourly min/max heart rate",
        "en": "Hourly min/max heart rate",
        "zh-Hans": "每小时最低/最高心率",
        "zh-Hant": "每小時最低/最高心率"
    },
    {
        "key": "hr_feedback_level0_message1",
        "ko": "평온한 상태예요. 마음이 잘 안정되어 있습니다.",
        "ja": "穏やかな状態です。心がよく落ち着いています。",
        "de": "Sie sind in ruhigem Zustand. Der Geist ist gut zur Ruhe gekommen.",
        "en": "You're in a calm state. Your mind is well at ease.",
        "zh-Hans": "你处于平静状态。内心很稳定。",
        "zh-Hant": "你處於平靜狀態。內心很穩定。"
    },
    {
        "key": "hr_feedback_level0_message2",
        "ko": "지금은 편안한 상태입니다. 좋은 컨디션이에요.",
        "ja": "今は心地よい状態です。良いコンディションですね。",
        "de": "Sie fühlen sich jetzt wohl. Guter Zustand.",
        "en": "You're comfortable now. Good condition.",
        "zh-Hans": "你现在处于舒适状态。状态很好。",
        "zh-Hant": "你現在處於舒適狀態。狀態很好。"
    },
    {
        "key": "hr_feedback_level0_message3",
        "ko": "안정적인 상태로 보입니다. 이대로 유지해보세요.",
        "ja": "安定した状態のようです。このまま維持しましょう。",
        "de": "Sie wirken stabil. So können Sie weitermachen.",
        "en": "You seem stable. Keep it up.",
        "zh-Hans": "看起来状态很稳定。请继续保持。",
        "zh-Hant": "看起來狀態很穩定。請繼續保持。"
    },
    {
        "key": "hr_feedback_level0_message4",
        "ko": "균형 잡힌 상태입니다. 무리하지 않고 천천히 하루를 보내세요.",
        "ja": "バランスの取れた状態です。無理せずゆっくり過ごしてください。",
        "de": "Sie sind im Gleichgewicht. Gehen Sie es ruhig an.",
        "en": "You're in balance. Take it easy and enjoy your day.",
        "zh-Hans": "你处于平衡状态。不要勉强，慢慢度过今天吧。",
        "zh-Hant": "你處於平衡狀態。不要勉強，慢慢度過今天吧。"
    },
    {
        "key": "hr_feedback_level0_message5",
        "ko": "마음이 차분하고 안정된 상태예요.",
        "ja": "心が落ち着いて安定した状態です。",
        "de": "Der Geist ist ruhig und stabil.",
        "en": "Your mind is calm and stable.",
        "zh-Hans": "内心平静而稳定。",
        "zh-Hant": "內心平靜而穩定。"
    },
    {
        "key": "hr_feedback_level1_message1",
        "ko": "지금 아주 편안한 상태예요. 이 기분을 유지해보세요.",
        "ja": "今はとても心地よい状態です。この気分を維持しましょう。",
        "de": "Sie sind jetzt sehr entspannt. Behalten Sie diese Stimmung bei.",
        "en": "You're very comfortable now. Keep this mood.",
        "zh-Hans": "你现在非常舒适。请保持这种心情。",
        "zh-Hant": "你現在非常舒適。請保持這種心情。"
    },
    {
        "key": "hr_feedback_level1_message2",
        "ko": "마음이 안정되어 있어요. 좋은 컨디션입니다.",
        "ja": "心が安定しています。良いコンディションです。",
        "de": "Der Geist ist ruhig. Guter Zustand.",
        "en": "Your mind is at ease. Good condition.",
        "zh-Hans": "你的内心很安定。状态很好。",
        "zh-Hant": "你的內心很安定。狀態很好。"
    },
    {
        "key": "hr_feedback_level1_message3",
        "ko": "차분한 하루를 보내고 계시네요.",
        "ja": "穏やかな一日を過ごされていますね。",
        "de": "Sie haben einen ruhigen Tag.",
        "en": "You're having a calm day.",
        "zh-Hans": "你正在度过平静的一天。",
        "zh-Hant": "你正在度過平靜的一天。"
    },
    {
        "key": "hr_feedback_level1_message4",
        "ko": "몸과 마음이 잘 균형을 이루고 있어요.",
        "ja": "心と体のバランスが取れています。",
        "de": "Körper und Geist sind im Gleichgewicht.",
        "en": "Your body and mind are in good balance.",
        "zh-Hans": "身心保持着良好平衡。",
        "zh-Hant": "身心保持著良好平衡。"
    },
    {
        "key": "hr_feedback_level1_message5",
        "ko": "평온한 상태예요. 이대로 유지해보세요.",
        "ja": "穏やかな状態です。このまま維持しましょう。",
        "de": "Sie sind ruhig. So können Sie weitermachen.",
        "en": "You're calm. Keep it up.",
        "zh-Hans": "你处于平静状态。请继续保持。",
        "zh-Hant": "你處於平靜狀態。請繼續保持。"
    },
    {
        "key": "hr_feedback_level2_message1",
        "ko": "약간의 긴장감이 느껴져요. 가볍게 심호흡해보세요.",
        "ja": "少し緊張感を感じます。軽く深呼吸してみましょう。",
        "de": "Sie spüren vielleicht leichte Anspannung. Atmen Sie einmal tief ein.",
        "en": "You may feel a bit tense. Try a light deep breath.",
        "zh-Hans": "感觉有些紧张。试着轻轻深呼吸。",
        "zh-Hant": "感覺有些緊張。試著輕輕深呼吸。"
    },
    {
        "key": "hr_feedback_level2_message2",
        "ko": "살짝 긴장된 상태예요. 천천히 호흡해보세요.",
        "ja": "少し緊張した状態です。ゆっくり呼吸してみましょう。",
        "de": "Sie sind leicht angespannt. Atmen Sie langsam.",
        "en": "You're slightly tense. Breathe slowly.",
        "zh-Hans": "你稍微有些紧张。请慢慢呼吸。",
        "zh-Hant": "你稍微有些緊張。請慢慢呼吸。"
    },
    {
        "key": "hr_feedback_level2_message3",
        "ko": "살짝 예민해진 순간이에요. 어깨를 한번 돌려볼까요?",
        "ja": "少し敏感になった瞬間です。肩を回してみませんか。",
        "de": "Ein etwas sensibler Moment. Rollen Sie die Schultern.",
        "en": "A slightly sensitive moment. Try rolling your shoulders.",
        "zh-Hans": "这是稍微敏感的时刻。要不要转动一下肩膀？",
        "zh-Hant": "這是稍微敏感的時刻。要不要轉動一下肩膀？"
    },
    {
        "key": "hr_feedback_level2_message4",
        "ko": "집중도가 높아진 상태예요. 잠시 시선을 멀리 두세요.",
        "ja": "集中度が高まった状態です。少し視線を遠くに置きましょう。",
        "de": "Die Konzentration ist hoch. Schauen Sie kurz in die Ferne.",
        "en": "Your focus is high. Look away for a moment.",
        "zh-Hans": "你的专注度很高。请把视线移远片刻。",
        "zh-Hant": "你的專注度很高。請把視線移遠片刻。"
    },
    {
        "key": "hr_feedback_level2_message5",
        "ko": "잠깐의 여유를 가지면 곧 편안해질 거예요.",
        "ja": "少し余裕を持つとすぐ楽になります。",
        "de": "Eine kurze Pause hilft, bald wieder entspannt zu sein.",
        "en": "A short break will help you feel at ease soon.",
        "zh-Hans": "稍微放松一下，很快就会变得舒适。",
        "zh-Hant": "稍微放鬆一下，很快就會變得舒適。"
    },
    {
        "key": "hr_feedback_level3_message1",
        "ko": "긴장도가 조금 높아지고 있어요. 짧은 휴식이 좋습니다.",
        "ja": "緊張度が少し高まっています。短い休息がおすすめです。",
        "de": "Die Anspannung steigt etwas. Eine kurze Pause tut gut.",
        "en": "Tension is rising a bit. A short rest is good.",
        "zh-Hans": "紧张程度正在稍微升高。短暂休息会很好。",
        "zh-Hant": "緊張程度正在稍微升高。短暫休息會很好。"
    },
    {
        "key": "hr_feedback_level3_message2",
        "ko": "몸이 긴장되어 있어요. 짧은 휴식을 취해보세요.",
        "ja": "体が緊張しています。短い休息を取ってみましょう。",
        "de": "Der Körper ist angespannt. Gönnen Sie sich eine kurze Pause.",
        "en": "Your body is tense. Take a short break.",
        "zh-Hans": "你的身体处于紧张状态。请短暂休息一下。",
        "zh-Hant": "你的身體處於緊張狀態。請短暫休息一下。"
    },
    {
        "key": "hr_feedback_level3_message3",
        "ko": "잠시 긴장된 순간이에요. 자리에서 일어나 스트레칭을 해보세요.",
        "ja": "少し緊張した瞬間です。席から立ちストレッチしてみましょう。",
        "de": "Ein angespannter Moment. Stehen Sie auf und dehnen Sie sich.",
        "en": "A tense moment. Get up and try stretching.",
        "zh-Hans": "这是短暂紧张的时刻。请从座位上站起来做做拉伸。",
        "zh-Hant": "這是短暫緊張的時刻。請從座位上站起來做做拉伸。"
    },
    {
        "key": "hr_feedback_level3_message4",
        "ko": "휴식이 필요할 때입니다. 눈을 감고 잠시 쉬어보세요.",
        "ja": "休息が必要なときです。目を閉じて少し休みましょう。",
        "de": "Zeit für eine Pause. Schließen Sie die Augen und ruhen Sie kurz.",
        "en": "Time for a break. Close your eyes and rest a moment.",
        "zh-Hans": "现在是需要休息的时候。闭上眼睛稍微休息一下。",
        "zh-Hant": "現在是需要休息的時候。閉上眼睛稍微休息一下。"
    },
    {
        "key": "hr_feedback_level3_message5",
        "ko": "몸이 살짝 경직될 수 있어요. 부드럽게 이완해보세요.",
        "ja": "体が少し硬くなっているかもしれません。優しくほぐしましょう。",
        "de": "Der Körper kann etwas verspannt sein. Lockern Sie sanft.",
        "en": "Your body may be a bit stiff. Try to relax gently.",
        "zh-Hans": "身体可能会有些僵硬。请轻柔地放松。",
        "zh-Hant": "身體可能會有些僵硬。請輕柔地放鬆。"
    },
    {
        "key": "hr_feedback_level4_message1",
        "ko": "긴장감이 높은 상태입니다. 짧게라도 쉬어보세요.",
        "ja": "緊張が高い状態です。短くても休みましょう。",
        "de": "Die Anspannung ist hoch. Ruhen Sie sich kurz aus.",
        "en": "Tension is high. Rest even briefly.",
        "zh-Hans": "处于高度紧张状态。哪怕短暂休息也好。",
        "zh-Hant": "處於高度緊張狀態。哪怕短暫休息也好。"
    },
    {
        "key": "hr_feedback_level4_message2",
        "ko": "피로가 쌓이고 있는 신호예요. 몸을 조금 풀어주세요.",
        "ja": "疲れがたまっているサインです。体を少しほぐしましょう。",
        "de": "Anzeichen von Müdigkeit. Lockern Sie den Körper etwas.",
        "en": "Signs of building fatigue. Loosen up a bit.",
        "zh-Hans": "这是疲劳正在累积的信号。请稍微活动放松身体。",
        "zh-Hant": "這是疲勞正在累積的信號。請稍微活動放鬆身體。"
    },
    {
        "key": "hr_feedback_level4_message3",
        "ko": "마음이 무거워질 때는 한두 번 깊게 호흡하는 게 좋아요.",
        "ja": "心が重いときは、深呼吸が効果的です。",
        "de": "Wenn der Geist schwer wird, helfen ein paar tiefe Atemzüge.",
        "en": "When your mind feels heavy, a few deep breaths help.",
        "zh-Hans": "心情沉重时，深呼吸一两次会有帮助。",
        "zh-Hant": "心情沉重時，深呼吸一兩次會有幫助。"
    },
    {
        "key": "hr_feedback_level4_message4",
        "ko": "짧은 휴식이 컨디션 회복에 도움이 됩니다.",
        "ja": "短い休息がコンディション回復に役立ちます。",
        "de": "Eine kurze Pause unterstützt die Erholung.",
        "en": "A short break helps recovery.",
        "zh-Hans": "短暂休息有助于恢复状态。",
        "zh-Hant": "短暫休息有助於恢復狀態。"
    },
    {
        "key": "hr_feedback_level4_message5",
        "ko": "의식적으로 호흡을 천천히 하면서 몸을 이완해보세요.",
        "ja": "意識的にゆっくり呼吸しながら体をほぐしましょう。",
        "de": "Atmen Sie bewusst langsam und entspannen Sie den Körper.",
        "en": "Breathe slowly and consciously while relaxing.",
        "zh-Hans": "有意识地慢慢呼吸，同时放松身体。",
        "zh-Hant": "有意識地慢慢呼吸，同時放鬆身體。"
    },
    {
        "key": "hr_feedback_level5_message1",
        "ko": "긴장이 많이 쌓였어요. 잠시 휴식을 권장합니다.",
        "ja": "緊張がかなりたまっています。少し休息することをおすすめします。",
        "de": "Die Anspannung ist gestiegen. Eine Pause wird empfohlen.",
        "en": "Tension has built up. A short rest is recommended.",
        "zh-Hans": "紧张感累积较多。建议短暂休息。",
        "zh-Hant": "緊張感累積較多。建議短暫休息。"
    },
    {
        "key": "hr_feedback_level5_message2",
        "ko": "스트레스가 많이 쌓인 상태예요. 충분한 휴식을 권장합니다.",
        "ja": "ストレスがたまった状態です。十分な休息をおすすめします。",
        "de": "Der Stress hat sich aufgestaut. Ausreichend Erholung wird empfohlen.",
        "en": "Stress has built up. Plenty of rest is recommended.",
        "zh-Hans": "压力累积较多。建议充分休息。",
        "zh-Hant": "壓力累積較多。建議充分休息。"
    },
    {
        "key": "hr_feedback_level5_message3",
        "ko": "지금은 잠시 멈추고 몸과 마음을 쉬게 해주세요.",
        "ja": "今は少し立ち止まり、心と体を休めてください。",
        "de": "Machen Sie kurz Pause und gönnen Sie Körper und Geist Ruhe.",
        "en": "Pause for a moment and let your body and mind rest.",
        "zh-Hans": "现在请暂停片刻，让身心休息。",
        "zh-Hant": "現在請暫停片刻，讓身心休息。"
    },
    {
        "key": "hr_feedback_level5_message4",
        "ko": "피로가 누적된 듯해요. 짧은 산책이 도움이 됩니다.",
        "ja": "疲れがたまっているようです。短い散歩が役立ちます。",
        "de": "Die Müdigkeit scheint sich anzusammeln. Ein kurzer Spaziergang hilft.",
        "en": "Fatigue seems to have built up. A short walk helps.",
        "zh-Hans": "疲劳似乎已经累积。短暂散步会有帮助。",
        "zh-Hant": "疲勞似乎已經累積。短暫散步會有幫助。"
    },
    {
        "key": "hr_feedback_level5_message5",
        "ko": "편안한 음악이나 조용한 공간에서 잠시 쉬면 도움이 됩니다.",
        "ja": "穏やかな音楽や静かな空間で少し休むと効果的です。",
        "de": "Ruhe mit ruhiger Musik oder an einem ruhigen Ort hilft.",
        "en": "Resting with calm music or in a quiet space helps.",
        "zh-Hans": "在舒缓的音乐或安静的空间中稍作休息会有帮助。",
        "zh-Hant": "在舒緩的音樂或安靜的空間中稍作休息會有幫助。"
    },
    {
        "key": "i_agree",
        "ko": "에 동의합니다.",
        "ja": "に同意します。",
        "de": "I agree.",
        "en": "I agree.",
        "zh-Hans": "我同意。",
        "zh-Hant": "我同意。"
    },
    {
        "key": "icon",
        "ko": "아이콘",
        "ja": "アイコン",
        "de": "Icon",
        "en": "Icon",
        "zh-Hans": "图标",
        "zh-Hant": "圖標"
    },
    {
        "key": "image_preview",
        "ko": "이미지 미리보기",
        "ja": "画像プレビュー",
        "de": "Bildvorschau",
        "en": "Image preview",
        "zh-Hans": "图片预览",
        "zh-Hant": "圖片預覽"
    },
    {
        "key": "immediate_upload",
        "ko": "즉시업로드",
        "ja": "即時アップロード",
        "de": "Sofortiger Upload",
        "en": "Immediate upload",
        "zh-Hans": "立即上传",
        "zh-Hant": "立即上傳"
    },
    {
        "key": "in_progress",
        "ko": "진행중",
        "ja": "進行中",
        "de": "In Bearbeitung",
        "en": "In progress",
        "zh-Hans": "进行中",
        "zh-Hant": "進行中"
    },
    {
        "key": "incheon",
        "ko": "인천",
        "ja": "仁川",
        "de": "Incheon",
        "en": "Incheon",
        "zh-Hans": "仁川",
        "zh-Hant": "仁川"
    },
    {
        "key": "incheon_metropolitan_city",
        "ko": "인천광역시",
        "ja": "仁川広域市",
        "de": "Incheon Metropolitan City",
        "en": "Incheon Metropolitan City",
        "zh-Hans": "仁川广域市",
        "zh-Hant": "仁川廣域市"
    },
    {
        "key": "include_at_least_2_types_of_letters_numbers_and_symbols_6_12_characters",
        "ko": "영문자, 숫자, 기호 중 2개 이상을 포함하여, 6~12자로 설정해주세요.",
        "ja": "認証が無効なパスワード。",
        "de": "Include at least 2 types of letters, numbers, and symbols (6-12 characters).",
        "en": "Include at least 2 types of letters, numbers, and symbols (6-12 characters).",
        "zh-Hans": "请包含英文字母、数字、符号中的至少2种，并设置为6~12个字符。",
        "zh-Hant": "請包含英文字母、數字、符號中的至少2種，並設定為6~12個字元。"
    },
    {
        "key": "index",
        "ko": "인덱스",
        "ja": "インデックス",
        "de": "Index",
        "en": "Index",
        "zh-Hans": "索引",
        "zh-Hant": "索引"
    },
    {
        "key": "index_already_exists_please_enter_a_different_index",
        "ko": "존재하는 인덱스입니다. 다른 인덱스를 입력해주세요.",
        "ja": "既存のインデックスです。別のインデックスを入力してください。",
        "de": "Index already exists. Please enter a different index.",
        "en": "Index already exists. Please enter a different index.",
        "zh-Hans": "索引已存在。请输入其他索引。",
        "zh-Hant": "索引已存在。請輸入其他索引。"
    },
    {
        "key": "index_category_and_name_are_required",
        "ko": "인덱스, 분류, 이름은 필수입니다.",
        "ja": "インデックス、分類、名前は必須です。",
        "de": "Index, Kategorie und Name sind erforderlich.",
        "en": "Index, category, and name are required.",
        "zh-Hans": "索引、分类和名称为必填项。",
        "zh-Hant": "索引、分類和名稱為必填項。"
    },
    {
        "key": "indicates_required_fields",
        "ko": "*는 필수 입력내용입니다.",
        "ja": "*は必須入力項目です。",
        "de": "* indicates required fields.",
        "en": "* indicates required fields.",
        "zh-Hans": "* 表示必填项。",
        "zh-Hant": "* 表示必填項。"
    },
    {
        "key": "information_edit",
        "ko": "정보 수정",
        "ja": "情報編集",
        "de": "Informationen bearbeiten",
        "en": "Information edit",
        "zh-Hans": "编辑信息",
        "zh-Hant": "編輯資訊"
    },
    {
        "key": "initial_application_date",
        "ko": "최초 신청날짜",
        "ja": "初回申請日",
        "de": "Erstes Antragsdatum",
        "en": "Initial application date",
        "zh-Hans": "首次申请日期",
        "zh-Hant": "首次申請日期"
    },
    {
        "key": "input",
        "ko": "입력",
        "ja": "入力",
        "de": "Input",
        "en": "Input",
        "zh-Hans": "输入",
        "zh-Hant": "輸入"
    },
    {
        "key": "insufficient_points",
        "ko": "포인트가 부족합니다.",
        "ja": "ポイントが不足しています。",
        "de": "Nicht genügend Punkte.",
        "en": "Insufficient points.",
        "zh-Hans": "积分不足。",
        "zh-Hant": "積分不足。"
    },
    {
        "key": "invalid_verification_code",
        "ko": "잘못된 인증번호입니다.",
        "ja": "認証番号が無効です。",
        "de": "Ungültiger Bestätigungscode.",
        "en": "Invalid verification code.",
        "zh-Hans": "验证码无效。",
        "zh-Hant": "驗證碼無效。"
    },
    {
        "key": "japan",
        "ko": "일본",
        "ja": "日本",
        "de": "Japan",
        "en": "Japan",
        "zh-Hans": "日本",
        "zh-Hant": "日本"
    },
    {
        "key": "japanese",
        "ko": "일본어",
        "ja": "日本語",
        "de": "Japanisch",
        "en": "Japanese",
        "zh-Hans": "日语",
        "zh-Hant": "日語"
    },
    {
        "key": "jeju",
        "ko": "제주",
        "ja": "済州",
        "de": "Jeju",
        "en": "Jeju",
        "zh-Hans": "济州",
        "zh-Hant": "濟州"
    },
    {
        "key": "jeju_special_self_governing_province",
        "ko": "제주특별자치도",
        "ja": "済州特別自治道",
        "de": "Jeju Special Self-Governing Province",
        "en": "Jeju Special Self-Governing Province",
        "zh-Hans": "济州特别自治道",
        "zh-Hant": "濟州特別自治道"
    },
    {
        "key": "jeollabuk_do",
        "ko": "전북특별자치도",
        "ja": "全北特別自治道",
        "de": "Jeollabuk-do",
        "en": "Jeollabuk-do",
        "zh-Hans": "全罗北道特别自治道",
        "zh-Hant": "全羅北道特別自治道"
    },
    {
        "key": "jeollanam_do",
        "ko": "전라남도",
        "ja": "全羅南道",
        "de": "Jeollanam-do",
        "en": "Jeollanam-do",
        "zh-Hans": "全罗南道",
        "zh-Hant": "全羅南道"
    },
    {
        "key": "jeonbuk",
        "ko": "전북",
        "ja": "全北",
        "de": "Jeonbuk",
        "en": "Jeonbuk",
        "zh-Hans": "全北",
        "zh-Hant": "全北"
    },
    {
        "key": "jeonnam",
        "ko": "전남",
        "ja": "全南",
        "de": "Jeonnam",
        "en": "Jeonnam",
        "zh-Hans": "全南",
        "zh-Hant": "全南"
    },
    {
        "key": "kakao_account",
        "ko": "카카오계정",
        "ja": "カカオアカウント",
        "de": "Kakao Account",
        "en": "Kakao Account",
        "zh-Hans": "Kakao 账号",
        "zh-Hant": "Kakao 帳號"
    },
    {
        "key": "karlsruhe_metropolitan_city",
        "ko": "카를스루에",
        "ja": "カールスルーエ",
        "de": "Karlsruhe",
        "en": "Karlsruhe",
        "zh-Hans": "卡尔斯鲁厄",
        "zh-Hant": "卡爾斯魯厄"
    },
    {
        "key": "kindergarten",
        "ko": "유치원",
        "ja": "幼稚園",
        "de": "Kindergarten",
        "en": "Kindergarten",
        "zh-Hans": "幼儿园",
        "zh-Hant": "幼兒園"
    },
    {
        "key": "kitakyushu_metropolitan_city",
        "ko": "기타큐슈",
        "ja": "北九州市",
        "de": "Kitakyūshū",
        "en": "Kitakyushu",
        "zh-Hans": "北九州",
        "zh-Hant": "北九州"
    },
    {
        "key": "korean",
        "ko": "한국어",
        "ja": "韓国語",
        "de": "Koreanisch",
        "en": "Korean",
        "zh-Hans": "韩语",
        "zh-Hant": "韓語"
    },
    {
        "key": "language_settings",
        "ko": "언어설정",
        "ja": "言語設定",
        "de": "Spracheinstellungen",
        "en": "Language settings",
        "zh-Hans": "语言设置",
        "zh-Hant": "語言設定"
    },
    {
        "key": "last_1_month",
        "ko": "최근 1개월",
        "ja": "最近1か月",
        "de": "Last 1 month",
        "en": "Last 1 month",
        "zh-Hans": "最近1个月",
        "zh-Hant": "最近1個月"
    },
    {
        "key": "last_2_years",
        "ko": "기간 2년",
        "ja": "期間2年",
        "de": "Last 2 years",
        "en": "Last 2 years",
        "zh-Hans": "最近2年",
        "zh-Hant": "最近2年"
    },
    {
        "key": "last_3_months",
        "ko": "최근 3개월",
        "ja": "最近3か月",
        "de": "Last 3 months",
        "en": "Last 3 months",
        "zh-Hans": "最近3个月",
        "zh-Hant": "最近3個月"
    },
    {
        "key": "last_30_days",
        "ko": "기간 30일",
        "ja": "期間30日",
        "de": "Last 30 days",
        "en": "Last 30 days",
        "zh-Hans": "最近30天",
        "zh-Hant": "最近30天"
    },
    {
        "key": "last_7_days",
        "ko": "기간 7일",
        "ja": "期間7日",
        "de": "Last 7 days",
        "en": "Last 7 days",
        "zh-Hans": "最近7天",
        "zh-Hant": "最近7天"
    },
    {
        "key": "last_90_days",
        "ko": "기간 90일",
        "ja": "期間90日",
        "de": "Last 90 days",
        "en": "Last 90 days",
        "zh-Hans": "最近90天",
        "zh-Hant": "最近90天"
    },
    {
        "key": "last_login",
        "ko": "최근로그인",
        "ja": "最終ログイン",
        "de": "Letzte Anmeldung",
        "en": "Last login",
        "zh-Hans": "最近登录",
        "zh-Hant": "最近登入"
    },
    {
        "key": "last_sync",
        "ko": "마지막동기화",
        "ja": "最終同期",
        "de": "Letzte Synchronisation",
        "en": "Last sync",
        "zh-Hans": "最后同步",
        "zh-Hant": "最後同步"
    },
    {
        "key": "latitude",
        "ko": "위도",
        "ja": "緯度",
        "de": "Latitude",
        "en": "Latitude",
        "zh-Hans": "纬度",
        "zh-Hant": "緯度"
    },
    {
        "key": "latitude_and_longitude_are_auto_filled_from_address_zip_code_adjust_as_needed_for_accuracy",
        "ko": "위경도는 주소, 우편번호에 의해 자동입력되나 상세수정으로 정확한 위치를 잡아주세요.",
        "ja": "緯度・経度は住所・郵便番号から自動入力されますが、詳細に修正して正確な位置を指定してください。",
        "de": "Breiten- und Längengrad werden aus Adresse/Postleitzahl automatisch ausgefüllt; bei Bedarf für Genauigkeit anpassen.",
        "en": "Latitude and longitude are auto-filled from address/zip code; adjust as needed for accuracy.",
        "zh-Hans": "纬度和经度会根据地址、邮政编码自动填写；请通过详细编辑设置准确位置。",
        "zh-Hant": "緯度和經度會根據地址、郵遞區號自動填寫；請通過詳細編輯設定準確位置。"
    },
    {
        "key": "latitude_and_longitude_have_been_updated",
        "ko": "위경도가 수정되었습니다.",
        "ja": "緯度・経度が更新されました。",
        "de": "Breiten- und Längengrad wurden aktualisiert.",
        "en": "Latitude and longitude have been updated.",
        "zh-Hans": "纬度和经度已更新。",
        "zh-Hant": "緯度和經度已更新。"
    },
    {
        "key": "latitude_longitude",
        "ko": "위도/경도",
        "ja": "緯度/経度",
        "de": "Breiten-/Längengrad",
        "en": "Latitude/Longitude",
        "zh-Hans": "纬度/经度",
        "zh-Hant": "緯度/經度"
    },
    {
        "key": "leave_blank_if_you_do_not_want_to_change_password",
        "ko": "비밀번호를 변경하지 않으려면 비워두세요.",
        "ja": "パスワードを変更しない場合は空欄にしてください。",
        "de": "Leer lassen, wenn Sie das Passwort nicht ändern möchten.",
        "en": "Leave blank if you do not want to change password.",
        "zh-Hans": "如果不想更改密码，请留空。",
        "zh-Hant": "如果不想變更密碼，請留空。"
    },
    {
        "key": "leipzig_metropolitan_city",
        "ko": "라이프치히",
        "ja": "ライプツィヒ",
        "de": "Leipzig",
        "en": "Leipzig",
        "zh-Hans": "莱比锡",
        "zh-Hant": "萊比錫"
    },
    {
        "key": "level_up",
        "ko": "레벨업",
        "ja": "レベルアップ",
        "de": "Level aufsteigen",
        "en": "Level up",
        "zh-Hans": "升级",
        "zh-Hant": "升級"
    },
    {
        "key": "level_up_info",
        "ko": "레벨업 정보",
        "ja": "レベルアップ情報",
        "de": "Level-up-Info",
        "en": "Level up info",
        "zh-Hans": "升级信息",
        "zh-Hant": "升級資訊"
    },
    {
        "key": "loading",
        "ko": "로딩 중...",
        "ja": "読み込み中...",
        "de": "Laden...",
        "en": "Loading...",
        "zh-Hans": "加载中...",
        "zh-Hant": "載入中..."
    },
    {
        "key": "loading_content_list",
        "ko": "콘텐츠 목록을 불러오는 중...",
        "ja": "コンテンツ一覧を読み込み中...",
        "de": "Inhaltsliste wird geladen...",
        "en": "Loading content list...",
        "zh-Hans": "正在加载内容列表...",
        "zh-Hant": "正在載入內容清單..."
    },
    {
        "key": "loading_data",
        "ko": "데이터를 불러오는 중...",
        "ja": "データを読み込み中...",
        "de": "Daten werden geladen...",
        "en": "Loading data...",
        "zh-Hans": "正在加载数据...",
        "zh-Hant": "正在載入資料..."
    },
    {
        "key": "loading_didim_h_w_list",
        "ko": "디딤H/W 목록을 불러오는 중...",
        "ja": "Didim H/Wリストを読み込み中...",
        "de": "Didim H/W-Liste wird geladen...",
        "en": "Loading Didim H/W list...",
        "zh-Hans": "正在加载 Didim H/W 列表...",
        "zh-Hant": "正在載入 Didim H/W 清單..."
    },
    {
        "key": "loading_organization_list",
        "ko": "기관 목록을 불러오는 중...",
        "ja": "機関一覧を読み込み中...",
        "de": "Organisationsliste wird geladen...",
        "en": "Loading organization list...",
        "zh-Hans": "正在加载机构列表...",
        "zh-Hant": "正在載入機構清單..."
    },
    {
        "key": "loading_organizations",
        "ko": "기관 불러오는 중...",
        "ja": "機関を読み込み中...",
        "de": "Organisationen werden geladen...",
        "en": "Loading organizations...",
        "zh-Hans": "正在加载机构...",
        "zh-Hant": "正在載入機構..."
    },
    {
        "key": "login_id",
        "ko": "ID",
        "ja": "ID",
        "de": "ID",
        "en": "ID",
        "zh-Hans": "ID",
        "zh-Hant": "ID"
    },
    {
        "key": "logout",
        "ko": "로그아웃",
        "ja": "ログアウト",
        "de": "Abmelden",
        "en": "Logout",
        "zh-Hans": "退出登录",
        "zh-Hant": "退出登入"
    },
    {
        "key": "longitude",
        "ko": "경도",
        "ja": "経度",
        "de": "Longitude",
        "en": "Longitude",
        "zh-Hans": "经度",
        "zh-Hant": "經度"
    },
    {
        "key": "lottery",
        "ko": "1. 응모추첨제",
        "ja": "1. 応募抽選制",
        "de": "Lottery",
        "en": "Lottery",
        "zh-Hans": "1. 报名抽签制",
        "zh-Hant": "1. 報名抽籤制"
    },
    {
        "key": "lottery_result",
        "ko": "추첨결과",
        "ja": "抽選結果",
        "de": "Verlosungsergebnis",
        "en": "Lottery result",
        "zh-Hans": "抽签结果",
        "zh-Hant": "抽籤結果"
    },
    {
        "key": "low",
        "ko": "낮음",
        "ja": "低い",
        "de": "Low",
        "en": "Low",
        "zh-Hans": "低",
        "zh-Hant": "低"
    },
    {
        "key": "main_organization",
        "ko": "메인기관",
        "ja": "メイン機関",
        "de": "Hauptorganisation",
        "en": "Main organization",
        "zh-Hans": "主机构",
        "zh-Hant": "主機構"
    },
    {
        "key": "main_organization_change_limit_exceeded",
        "ko": "주기관 변경 횟수가 초과되었습니다.",
        "ja": "主機関の変更回数が上限を超えました。",
        "de": "Hauptorganisationsänderungslimit überschritten.",
        "en": "Main organization change limit exceeded.",
        "zh-Hans": "主机构更改次数已超出限制。",
        "zh-Hant": "主機構變更次數已超出限制。"
    },
    {
        "key": "main_organization_has_already_been_changed_once_this_month_please_change_it_next_month",
        "ko": "이번달에 이미 메인기관 1회 변경 정보가  존재합니다.  다음달에 변경해주세요.",
        "ja": "今月は既に主機関の1回変更情報が 存在します。  来月に変更してください。",
        "de": "Main organization has already been changed once this month.  Please change it next month.",
        "en": "Main organization has already been changed once this month.  Please change it next month.",
        "zh-Hans": "本月已存在一次主机构更改记录。请下个月再更改。",
        "zh-Hant": "本月已存在一次主機構變更記錄。請下個月再變更。"
    },
    {
        "key": "main_organization_has_been_changed",
        "ko": "메인기관이 변경되었습니다.",
        "ja": "主機関が変更されました。",
        "de": "Hauptorganisation wurde geändert.",
        "en": "Main organization has been changed.",
        "zh-Hans": "主机构已更改。",
        "zh-Hant": "主機構已變更。"
    },
    {
        "key": "main_organization_name",
        "ko": "주기관명",
        "ja": "主機関名",
        "de": "Hauptorganisationsname",
        "en": "Main organization name",
        "zh-Hans": "主机构名称",
        "zh-Hant": "主機構名稱"
    },
    {
        "key": "main_organization_one_only_points_shared",
        "ko": "주기관은 한 개만 선택가능하고 기관포인트가 공유됩니다.",
        "ja": "主機関は1つのみ選択でき、機関ポイントが共有されます。",
        "de": "Es kann nur eine Hauptorganisation ausgewählt werden, und die Organisationspunkte werden geteilt.",
        "en": "Only one main organization can be selected, and organization points are shared.",
        "zh-Hans": "只能选择一个主机构，机构积分将共享。",
        "zh-Hant": "只能選擇一個主機構，機構積分將共享。"
    },
    {
        "key": "male",
        "ko": "남성",
        "ja": "男性",
        "de": "Männlich",
        "en": "Male",
        "zh-Hans": "男性",
        "zh-Hant": "男性"
    },
    {
        "key": "mannheim_metropolitan_city",
        "ko": "만하임",
        "ja": "マンハイム",
        "de": "Mannheim",
        "en": "Mannheim",
        "zh-Hans": "曼海姆",
        "zh-Hant": "曼海姆"
    },
    {
        "key": "max_24_characters",
        "ko": "최대 24자",
        "ja": "最大24文字",
        "de": "Max 24 characters",
        "en": "Max 24 characters",
        "zh-Hans": "最多24个字符",
        "zh-Hant": "最多24個字元"
    },
    {
        "key": "max_5_affiliated_organizations",
        "ko": "* 소속기관은 최대 5개까지만 가능합니다.",
        "ja": "* 所属機関は最大5つまで追加できます。",
        "de": "* Sie können maximal 5 zugehörige Organisationen hinzufügen.",
        "en": "* You can add up to 5 affiliated organizations.",
        "zh-Hans": "* 所属机构最多只能添加5个。",
        "zh-Hant": "* 所屬機構最多只能新增5個。"
    },
    {
        "key": "max_value_or_above",
        "ko": "최대 {{value}} 이상",
        "ja": "最大{{value}}以上",
        "de": "Max {{value}} or above",
        "en": "Max {{value}} or above",
        "zh-Hans": "最大 {{value}} 以上",
        "zh-Hant": "最大 {{value}} 以上"
    },
    {
        "key": "maximum_1_attachment_allowed",
        "ko": "첨부파일은 최대 1개까지 가능합니다.",
        "ja": "添付ファイルは1つまでです。",
        "de": "Maximum 1 attachment allowed.",
        "en": "Maximum 1 attachment allowed.",
        "zh-Hans": "最多允许1个附件。",
        "zh-Hant": "最多允許1個附件。"
    },
    {
        "key": "maximum_1_attachment_can_be_uploaded",
        "ko": "첨부파일은 최대 1개까지 업로드 가능합니다.",
        "ja": "添付ファイルは最大1つまでアップロード可能です。",
        "de": "Maximum 1 attachment can be uploaded.",
        "en": "Maximum 1 attachment can be uploaded.",
        "zh-Hans": "最多可上传1个附件。",
        "zh-Hant": "最多可上傳1個附件。"
    },
    {
        "key": "may_18_24",
        "ko": "5월 18 - 24일",
        "ja": "5月18日 - 24日",
        "de": "May 18 - 24",
        "en": "May 18 - 24",
        "zh-Hans": "5月18日 - 24日",
        "zh-Hant": "5月18日 - 24日"
    },
    {
        "key": "memo",
        "ko": "메모",
        "ja": "メモ",
        "de": "Memo",
        "en": "Memo",
        "zh-Hans": "备注",
        "zh-Hant": "備註"
    },
    {
        "key": "menu_settings",
        "ko": "메뉴 설정",
        "ja": "メニュー設定",
        "de": "menu_settings",
        "en": "menu_settings",
        "zh-Hans": "菜单设置",
        "zh-Hant": "選單設定"
    },
    {
        "key": "middle_school",
        "ko": "중학교",
        "ja": "中学校",
        "de": "Middle School",
        "en": "Middle School",
        "zh-Hans": "初中",
        "zh-Hant": "初中"
    },
    {
        "key": "min",
        "ko": "분",
        "ja": "分",
        "de": "min",
        "en": "min",
        "zh-Hans": "分钟",
        "zh-Hant": "分鐘"
    },
    {
        "key": "mobile_preview",
        "ko": "모바일 미리보기",
        "ja": "モバイルプレビュー",
        "de": "Mobile Preview",
        "en": "Mobile Preview",
        "zh-Hans": "移动端预览",
        "zh-Hant": "行動端預覽"
    },
    {
        "key": "model_name",
        "ko": "모델명",
        "ja": "モデル名",
        "de": "Modellname",
        "en": "Model name",
        "zh-Hans": "型号名称",
        "zh-Hant": "型號名稱"
    },
    {
        "key": "mon",
        "ko": "월",
        "ja": "月",
        "de": "Mon",
        "en": "Mon",
        "zh-Hans": "周一",
        "zh-Hant": "周一"
    },
    {
        "key": "month",
        "ko": "월",
        "ja": "月",
        "de": "month_",
        "en": "month_",
        "zh-Hans": "月",
        "zh-Hant": "月"
    },
    {
        "key": "month_label",
        "ko": "{{month}}월",
        "ja": "{{month}}月",
        "de": "{{month}}",
        "en": "{{month}}",
        "zh-Hans": "{{month}}月",
        "zh-Hant": "{{month}}月"
    },
    {
        "key": "monthly",
        "ko": "월간",
        "ja": "月間",
        "de": "Monthly",
        "en": "Monthly",
        "zh-Hans": "每月",
        "zh-Hant": "每月"
    },
    {
        "key": "monthly_experience_ranking",
        "ko": "월간경험치랭킹",
        "ja": "月間経験値ランキング",
        "de": "Monatliche Erfahrungs-Rangliste",
        "en": "Monthly experience ranking",
        "zh-Hans": "每月经验值排名",
        "zh-Hant": "每月經驗值排名"
    },
    {
        "key": "monthly_point_status",
        "ko": "월간 포인트 현황",
        "ja": "月間ポイント状況",
        "de": "Monatlicher Punktestand",
        "en": "Monthly point status",
        "zh-Hans": "每月积分状态",
        "zh-Hant": "每月積分狀態"
    },
    {
        "key": "monthly_ranking",
        "ko": "이달랭킹",
        "ja": "今月ランキング",
        "de": "Monats-Ranking",
        "en": "Monthly ranking",
        "zh-Hans": "本月排名",
        "zh-Hant": "本月排名"
    },
    {
        "key": "monthly_report",
        "ko": "월간 리포트",
        "ja": "月間レポート",
        "de": "Monatsbericht",
        "en": "Monthly report",
        "zh-Hans": "每月报告",
        "zh-Hant": "每月報告"
    },
    {
        "key": "mousedown",
        "ko": "마우스 누름",
        "ja": "マウスダウン",
        "de": "mousedown",
        "en": "mousedown",
        "zh-Hans": "鼠标按下",
        "zh-Hant": "滑鼠按下"
    },
    {
        "key": "munich_metropolitan_city",
        "ko": "뮌헨",
        "ja": "ミュンヘン",
        "de": "München",
        "en": "Munich",
        "zh-Hans": "慕尼黑",
        "zh-Hant": "慕尼黑"
    },
    {
        "key": "muscular_strength",
        "ko": "근력",
        "ja": "筋力",
        "de": "Muskelkraft",
        "en": "Muscular strength",
        "zh-Hans": "肌力",
        "zh-Hant": "肌力"
    },
    {
        "key": "my_affiliation",
        "ko": "나의 소속",
        "ja": "私の所属",
        "de": "Meine Zugehörigkeit",
        "en": "My affiliation",
        "zh-Hans": "我的所属",
        "zh-Hant": "我的所屬"
    },
    {
        "key": "my_championships",
        "ko": "나의 대회",
        "ja": "マイ大会",
        "de": "Meine Meisterschaften",
        "en": "My championships",
        "zh-Hans": "我的大赛",
        "zh-Hant": "我的大賽"
    },
    {
        "key": "my_entries",
        "ko": "나의 응모",
        "ja": "私の応募",
        "de": "Meine Einträge",
        "en": "My entries",
        "zh-Hans": "我的报名",
        "zh-Hant": "我的報名"
    },
    {
        "key": "my_information",
        "ko": "내 정보",
        "ja": "マイ情報",
        "de": "My Information",
        "en": "My Information",
        "zh-Hans": "我的信息",
        "zh-Hant": "我的資訊"
    },
    {
        "key": "my_page",
        "ko": "마이페이지",
        "ja": "マイページ",
        "de": "Meine Seite",
        "en": "My page",
        "zh-Hans": "我的页面",
        "zh-Hant": "我的頁面"
    },
    {
        "key": "my_rank",
        "ko": "My Rank",
        "ja": "My Rank",
        "de": "My Rank",
        "en": "My Rank",
        "zh-Hans": "我的排名",
        "zh-Hant": "我的排名"
    },
    {
        "key": "nagoya_metropolitan_city",
        "ko": "나고야",
        "ja": "名古屋市",
        "de": "Nagoya",
        "en": "Nagoya",
        "zh-Hans": "名古屋",
        "zh-Hant": "名古屋"
    },
    {
        "key": "name",
        "ko": "이름",
        "ja": "名前",
        "de": "Name",
        "en": "Name",
        "zh-Hans": "姓名",
        "zh-Hant": "姓名"
    },
    {
        "key": "name_must_be_2_16_characters",
        "ko": "이름은 2자~16자로 입력해주세요.",
        "ja": "名前は2〜16文字で入力してください。",
        "de": "Der Name muss 2–16 Zeichen haben.",
        "en": "Name must be 2-16 characters.",
        "zh-Hans": "姓名必须为2~16个字符。",
        "zh-Hant": "姓名必須為2~16個字元。"
    },
    {
        "key": "name_must_be_at_least_2_characters_long",
        "ko": "이름은 2자 이상이어야 합니다.",
        "ja": "名前は2文字以上である必要があります。",
        "de": "Der Name muss mindestens 2 Zeichen lang sein.",
        "en": "Name must be at least 2 characters long.",
        "zh-Hans": "姓名至少需要2个字符。",
        "zh-Hant": "姓名至少需要2個字元。"
    },
    {
        "key": "name_placeholder_2_16",
        "ko": "이름(2자~16자)",
        "ja": "名前(2〜16文字)",
        "de": "Name (2-16 Zeichen)",
        "en": "Name (2-16 characters)",
        "zh-Hans": "姓名（2~16个字符）",
        "zh-Hant": "姓名（2~16個字元）"
    },
    {
        "key": "nationwide",
        "ko": "전국",
        "ja": "全国",
        "de": "Nationwide",
        "en": "Nationwide",
        "zh-Hans": "全国",
        "zh-Hant": "全國"
    },
    {
        "key": "new_attachment_file",
        "ko": "새 첨부파일",
        "ja": "新しい添付ファイル",
        "de": "Neue Anhangdatei",
        "en": "New attachment file",
        "zh-Hans": "新附件文件",
        "zh-Hant": "新附件檔案"
    },
    {
        "key": "new_file",
        "ko": "새 파일",
        "ja": "新しいファイル",
        "de": "Neue Datei",
        "en": "New file",
        "zh-Hans": "新文件",
        "zh-Hant": "新檔案"
    },
    {
        "key": "next",
        "ko": "다음",
        "ja": "次へ",
        "de": "Weiter",
        "en": "Next",
        "zh-Hans": "下一步",
        "zh-Hant": "下一步"
    },
    {
        "key": "next_reward",
        "ko": "다음 보상",
        "ja": "次の報酬",
        "de": "Nächste Belohnung",
        "en": "Next reward",
        "zh-Hans": "下一个奖励",
        "zh-Hant": "下一個獎勵"
    },
    {
        "key": "no",
        "ko": "없음",
        "ja": "なし",
        "de": "Nein",
        "en": "No",
        "zh-Hans": "否",
        "zh-Hant": "否"
    },
    {
        "key": "no_activity_data",
        "ko": "활동 데이터 없음.",
        "ja": "活動データがありません。",
        "de": "Keine Aktivitätsdaten.",
        "en": "No activity data.",
        "zh-Hans": "没有活动数据。",
        "zh-Hant": "沒有活動資料。"
    },
    {
        "key": "no_affiliation",
        "ko": "무소속",
        "ja": "無所属",
        "de": "Keine Zugehörigkeit",
        "en": "No affiliation",
        "zh-Hans": "无所属",
        "zh-Hant": "無所屬"
    },
    {
        "key": "no_championship_data",
        "ko": "챔피언십 데이터가 없습니다.",
        "ja": "チャンピオンシップデータがありません。",
        "de": "Keine Meisterschaftsdaten.",
        "en": "No championship data.",
        "zh-Hans": "没有锦标赛数据。",
        "zh-Hant": "沒有錦標賽資料。"
    },
    {
        "key": "no_completed_championship",
        "ko": "완료된 대회가 없습니다.",
        "ja": "完了した大会がありません。",
        "de": "Keine abgeschlossenen Meisterschaften.",
        "en": "No completed championships.",
        "zh-Hans": "没有已完成的大赛。",
        "zh-Hant": "沒有已完成的大賽。"
    },
    {
        "key": "no_content_data",
        "ko": "콘텐츠 데이터가 없습니다.",
        "ja": "コンテンツデータがありません。",
        "de": "Keine Inhaltsdaten.",
        "en": "No content data.",
        "zh-Hans": "没有内容数据。",
        "zh-Hant": "沒有內容資料。"
    },
    {
        "key": "no_content_to_delete",
        "ko": "삭제할 콘텐츠 정보가 없습니다.",
        "ja": "削除するコンテンツがありません。",
        "de": "Kein Inhalt zum Löschen.",
        "en": "No content to delete.",
        "zh-Hans": "没有要删除的内容信息。",
        "zh-Hant": "沒有要刪除的內容資訊。"
    },
    {
        "key": "no_data",
        "ko": "데이터 없음.",
        "ja": "データなし。",
        "de": "Keine Daten.",
        "en": "No data.",
        "zh-Hans": "没有数据。",
        "zh-Hant": "沒有資料。"
    },
    {
        "key": "no_data_available",
        "ko": "해당사항없음.",
        "ja": "データがありません。",
        "de": "Keine Daten verfügbar",
        "en": "No data available",
        "zh-Hans": "无相关数据。",
        "zh-Hant": "無相關資料。"
    },
    {
        "key": "no_didim_data",
        "ko": "디딤 데이터가 없습니다.",
        "ja": "ディディムデータがありません。",
        "de": "Keine Didim-Daten.",
        "en": "No Didim data.",
        "zh-Hans": "没有 Didim 数据。",
        "zh-Hant": "沒有 Didim 資料。"
    },
    {
        "key": "no_didim_h_w",
        "ko": "디딤H/W가 없습니다.",
        "ja": "Didim H/Wがありません。",
        "de": "Keine Didim H/W.",
        "en": "No Didim H/W.",
        "zh-Hans": "没有 Didim H/W。",
        "zh-Hant": "沒有 Didim H/W。"
    },
    {
        "key": "no_event_data",
        "ko": "이벤트 데이터가 없습니다.",
        "ja": "イベントデータがありません。",
        "de": "Keine Veranstaltungsdaten.",
        "en": "No event data.",
        "zh-Hans": "没有活动数据。",
        "zh-Hant": "沒有活動資料。"
    },
    {
        "key": "no_events",
        "ko": "이벤트가 없습니다.",
        "ja": "イベントがありません。",
        "de": "Keine Veranstaltungen.",
        "en": "No events.",
        "zh-Hans": "没有活动。",
        "zh-Hant": "沒有活動。"
    },
    {
        "key": "no_exercise_records",
        "ko": "운동 기록이 없습니다.",
        "ja": "運動記録がありません。",
        "de": "Keine Trainingsaufzeichnungen.",
        "en": "No exercise records.",
        "zh-Hans": "没有运动记录。",
        "zh-Hant": "沒有運動記錄。"
    },
    {
        "key": "no_experience_history",
        "ko": "경험치 내역이 없습니다.",
        "ja": "経験値履歴がありません。",
        "de": "Keine Erfahrungshistorie.",
        "en": "No experience history.",
        "zh-Hans": "没有经验值记录。",
        "zh-Hant": "沒有經驗值記錄。"
    },
    {
        "key": "no_image",
        "ko": "이미지 없음.",
        "ja": "画像なし。",
        "de": "Kein Bild.",
        "en": "No image.",
        "zh-Hans": "没有图片。",
        "zh-Hant": "沒有圖片。"
    },
    {
        "key": "no_monthly_data",
        "ko": "월간 데이터 없음.",
        "ja": "月間データなし。",
        "de": "Keine Monatsdaten.",
        "en": "No monthly data.",
        "zh-Hans": "没有月度数据。",
        "zh-Hant": "沒有月度資料。"
    },
    {
        "key": "no_my_championship",
        "ko": "내가 만든 대회가 없습니다.",
        "ja": "作成した大会がありません。",
        "de": "Sie haben keine Meisterschaften.",
        "en": "You have no championships.",
        "zh-Hans": "你没有创建的大赛。",
        "zh-Hant": "你沒有創建的大賽。"
    },
    {
        "key": "no_notices_registered",
        "ko": "등록된 공지사항이 없습니다.",
        "ja": "登録されたお知らせがありません。",
        "de": "Keine Mitteilungen registriert.",
        "en": "No notices registered.",
        "zh-Hans": "没有已注册的公告。",
        "zh-Hant": "沒有已註冊的公告。"
    },
    {
        "key": "no_notifications",
        "ko": "알림이 없습니다.",
        "ja": "通知がありません。",
        "de": "Keine Benachrichtigungen.",
        "en": "No notifications.",
        "zh-Hans": "没有通知。",
        "zh-Hant": "沒有通知。"
    },
    {
        "key": "no_ongoing_championship",
        "ko": "진행중인 대회가 없습니다.",
        "ja": "進行中の大会がありません。",
        "de": "Keine laufenden Meisterschaften.",
        "en": "No ongoing championships.",
        "zh-Hans": "没有进行中的大赛。",
        "zh-Hant": "沒有進行中的大賽。"
    },
    {
        "key": "no_organization",
        "ko": "기관 없음.",
        "ja": "機関なし。",
        "de": "Keine Organisation.",
        "en": "No organization.",
        "zh-Hans": "没有机构。",
        "zh-Hant": "沒有機構。"
    },
    {
        "key": "no_organization_data",
        "ko": "기관 데이터가 없습니다.",
        "ja": "機関データがありません。",
        "de": "Keine Organisationsdaten.",
        "en": "No organization data.",
        "zh-Hans": "没有机构数据。",
        "zh-Hant": "沒有機構資料。"
    },
    {
        "key": "no_organization_to_delete",
        "ko": "삭제할 기관 정보가 없습니다.",
        "ja": "削除する機関情報がありません。",
        "de": "Keine Organisation zum Löschen.",
        "en": "No organization to delete.",
        "zh-Hans": "没有要删除的机构信息。",
        "zh-Hant": "沒有要刪除的機構資訊。"
    },
    {
        "key": "no_participants",
        "ko": "참가자가 존재하지 않습니다.",
        "ja": "参加者が存在しません。",
        "de": "Es gibt keine Teilnehmer.",
        "en": "No participants exist.",
        "zh-Hans": "不存在参与者。",
        "zh-Hant": "不存在參與者。"
    },
    {
        "key": "no_participation_data",
        "ko": "참여 데이터가 없습니다.",
        "ja": "参加データがありません。",
        "de": "Keine Teilnahmedaten.",
        "en": "No participation data.",
        "zh-Hans": "没有参与数据。",
        "zh-Hant": "沒有參與資料。"
    },
    {
        "key": "no_point_history",
        "ko": "포인트 내역이 없습니다.",
        "ja": "ポイント履歴がありません。",
        "de": "Keine Punktehistorie.",
        "en": "No point history.",
        "zh-Hans": "没有积分记录。",
        "zh-Hant": "沒有積分記錄。"
    },
    {
        "key": "no_push_notifications_registered",
        "ko": "등록된 알림이 없습니다.",
        "ja": "登録されたプッシュ通知がありません。",
        "de": "Keine Push-Benachrichtigungen registriert.",
        "en": "No push notifications registered.",
        "zh-Hans": "没有已注册的推送通知。",
        "zh-Hant": "沒有已註冊的推播通知。"
    },
    {
        "key": "no_result_data",
        "ko": "결과 데이터가 없습니다.",
        "ja": "結果データがありません。",
        "de": "Keine Ergebnisdaten.",
        "en": "No result data.",
        "zh-Hans": "没有结果数据。",
        "zh-Hant": "沒有結果資料。"
    },
    {
        "key": "no_search_results",
        "ko": "검색 결과가 없습니다.",
        "ja": "検索結果がありません。",
        "de": "Keine Suchergebnisse.",
        "en": "No search results.",
        "zh-Hans": "没有搜索结果。",
        "zh-Hant": "沒有搜尋結果。"
    },
    {
        "key": "no_unregistered_didim_h_w",
        "ko": "미등록 디딤H/W가 없습니다.",
        "ja": "未登録Didim H/Wがありません。",
        "de": "Keine unregistrierten Didim H/W.",
        "en": "No unregistered Didim H/W.",
        "zh-Hans": "没有未注册的 Didim H/W。",
        "zh-Hant": "沒有未註冊的 Didim H/W。"
    },
    {
        "key": "no_user",
        "ko": "사용자 없음.",
        "ja": "ユーザーなし。",
        "de": "Kein Benutzer.",
        "en": "No user.",
        "zh-Hans": "没有用户。",
        "zh-Hant": "沒有使用者。"
    },
    {
        "key": "no_user_data",
        "ko": "사용자 데이터가 없습니다.",
        "ja": "ユーザーデータがありません。",
        "de": "Keine Benutzerdaten.",
        "en": "No user data.",
        "zh-Hans": "没有用户数据。",
        "zh-Hant": "沒有使用者資料。"
    },
    {
        "key": "no_weekly_data",
        "ko": "주간 데이터 없음.",
        "ja": "週間データなし。",
        "de": "Keine wöchentlichen Daten.",
        "en": "No weekly data.",
        "zh-Hans": "没有周度数据。",
        "zh-Hant": "沒有週度資料。"
    },
    {
        "key": "no_yearly_data",
        "ko": "연간 데이터 없음.",
        "ja": "年間データなし。",
        "de": "Keine jährlichen Daten.",
        "en": "No yearly data.",
        "zh-Hans": "没有年度数据。",
        "zh-Hant": "沒有年度資料。"
    },
    {
        "key": "normal",
        "ko": "보통",
        "ja": "普通",
        "de": "Normal",
        "en": "Normal",
        "zh-Hans": "普通",
        "zh-Hant": "普通"
    },
    {
        "key": "north_chungcheong_province",
        "ko": "충청북도",
        "ja": "忠清北道",
        "de": "North Chungcheong Province",
        "en": "North Chungcheong Province",
        "zh-Hans": "忠清北道",
        "zh-Hant": "忠清北道"
    },
    {
        "key": "north_gyeongsang_province",
        "ko": "경상북도",
        "ja": "慶尚北道",
        "de": "North Gyeongsang Province",
        "en": "North Gyeongsang Province",
        "zh-Hans": "庆尚北道",
        "zh-Hant": "慶尚北道"
    },
    {
        "key": "north_jeolla_province",
        "ko": "전라북도",
        "ja": "全羅北道",
        "de": "North Jeolla Province",
        "en": "North Jeolla Province",
        "zh-Hans": "全罗北道",
        "zh-Hant": "全羅北道"
    },
    {
        "key": "not_connected",
        "ko": "미연결",
        "ja": "未接続",
        "de": "Nicht verbunden",
        "en": "Not connected",
        "zh-Hans": "未连接",
        "zh-Hant": "未連接"
    },
    {
        "key": "note",
        "ko": "비고",
        "ja": "備考",
        "de": "Note",
        "en": "Note",
        "zh-Hans": "备注",
        "zh-Hant": "備註"
    },
    {
        "key": "notice",
        "ko": "공지사항",
        "ja": "お知らせ",
        "de": "Hinweis",
        "en": "Notice",
        "zh-Hans": "公告",
        "zh-Hant": "公告"
    },
    {
        "key": "notice_and_event",
        "ko": "공지 및 이벤트",
        "ja": "お知らせおよびイベント",
        "de": "Hinweis und Event",
        "en": "Notice and Event",
        "zh-Hans": "公告和活动",
        "zh-Hant": "公告和活動"
    },
    {
        "key": "notice_and_push",
        "ko": "공지사항 및 푸시알림",
        "ja": "お知らせ お プッシュ通知",
        "de": "Mitteilungen und Push",
        "en": "Notices and push",
        "zh-Hans": "公告及推送",
        "zh-Hant": "公告及推播"
    },
    {
        "key": "notice_detail",
        "ko": "공지사항 상세",
        "ja": "お知らせ詳細",
        "de": "Mitteilungsdetails",
        "en": "Notice detail",
        "zh-Hans": "公告详情",
        "zh-Hant": "公告詳情"
    },
    {
        "key": "notice_list",
        "ko": "공지사항 목록",
        "ja": "お知らせ一覧",
        "de": "Mitteilungsliste",
        "en": "Notice list",
        "zh-Hans": "公告列表",
        "zh-Hant": "公告清單"
    },
    {
        "key": "notice_please_enter_title_content",
        "ko": "제목과 내용을 입력해주세요.",
        "ja": "タイトルと内容を入力してください。",
        "de": "Bitte geben Sie Titel und Inhalt ein.",
        "en": "Please enter title and content.",
        "zh-Hans": "请输入标题和内容。",
        "zh-Hant": "請輸入標題和內容。"
    },
    {
        "key": "notice_register_failed",
        "ko": "공지 등록에 실패했습니다.",
        "ja": "お知らせの登録に失敗しました。",
        "de": "Ankündigungsregistrierung fehlgeschlagen.",
        "en": "Notice registration failed.",
        "zh-Hans": "公告注册失败。",
        "zh-Hant": "公告註冊失敗。"
    },
    {
        "key": "notice_registered_successfully",
        "ko": "공지사항이 성공적으로 등록되었습니다.",
        "ja": "お知らせが正常に登録されました。",
        "de": "Mitteilung erfolgreich registriert.",
        "en": "Notice registered successfully.",
        "zh-Hans": "公告已成功注册。",
        "zh-Hant": "公告已成功註冊。"
    },
    {
        "key": "notice_updated",
        "ko": "공지가 수정되었습니다.",
        "ja": "お知らせが更新されました。",
        "de": "Die Ankündigung wurde aktualisiert.",
        "en": "Notice has been updated.",
        "zh-Hans": "公告已更新。",
        "zh-Hant": "公告已更新。"
    },
    {
        "key": "notices",
        "ko": "공지사항",
        "ja": "お知らせ",
        "de": "Hinweise",
        "en": "Notices",
        "zh-Hans": "公告",
        "zh-Hant": "公告"
    },
    {
        "key": "notices_and_push",
        "ko": "공지 및 푸시",
        "ja": "お知らせ・プッシュ",
        "de": "Hinweise & Push",
        "en": "Notices & Push",
        "zh-Hans": "公告及推送",
        "zh-Hant": "公告及推播"
    },
    {
        "key": "notification_register_failed",
        "ko": "알림 등록에 실패했습니다.",
        "ja": "通知の登録に失敗しました。",
        "de": "Benachrichtigungsregistrierung fehlgeschlagen.",
        "en": "Notification registration failed.",
        "zh-Hans": "通知注册失败。",
        "zh-Hant": "通知註冊失敗。"
    },
    {
        "key": "notification_registered",
        "ko": "알림이 등록되었습니다.",
        "ja": "通知が登録されました。",
        "de": "Benachrichtigung wurde registriert.",
        "en": "Notification has been registered.",
        "zh-Hans": "通知已注册。",
        "zh-Hant": "通知已註冊。"
    },
    {
        "key": "notification_updated",
        "ko": "알림이 수정되었습니다.",
        "ja": "通知が更新されました。",
        "de": "Benachrichtigung wurde aktualisiert.",
        "en": "Notification has been updated.",
        "zh-Hans": "通知已更新。",
        "zh-Hant": "通知已更新。"
    },
    {
        "key": "notifications",
        "ko": "알림",
        "ja": "通知",
        "de": "Benachrichtigungen",
        "en": "Notifications",
        "zh-Hans": "通知",
        "zh-Hant": "通知"
    },
    {
        "key": "now",
        "ko": "지금",
        "ja": "今",
        "de": "Now",
        "en": "Now",
        "zh-Hans": "现在",
        "zh-Hant": "現在"
    },
    {
        "key": "number",
        "ko": "번호",
        "ja": "番号",
        "de": "Number",
        "en": "Number",
        "zh-Hans": "编号",
        "zh-Hant": "編號"
    },
    {
        "key": "only_image_files_allowed",
        "ko": "이미지 파일만 업로드 가능합니다.",
        "ja": "画像ファイルのみアップロードできます。",
        "de": "Nur Bilddateien können hochgeladen werden.",
        "en": "Only image files can be uploaded.",
        "zh-Hans": "只能上传图片文件。",
        "zh-Hant": "只能上傳圖片檔案。"
    },
    {
        "key": "only_image_files_can_be_selected",
        "ko": "이미지 파일만 선택할 수 있습니다.",
        "ja": "画像ファイルのみ選択できます。",
        "de": "Nur Bilddateien können ausgewählt werden.",
        "en": "Only image files can be selected.",
        "zh-Hans": "只能选择图片文件。",
        "zh-Hant": "只能選擇圖片檔案。"
    },
    {
        "key": "only_jpeg_png_upload_allowed",
        "ko": "JPEG, PNG 파일만 업로드 가능합니다.",
        "ja": "JPEG、PNGファイルのみアップロード可能です。",
        "de": "Nur JPEG- und PNG-Dateien können hochgeladen werden.",
        "en": "Only JPEG and PNG files can be uploaded.",
        "zh-Hans": "只能上传 JPEG、PNG 文件。",
        "zh-Hant": "只能上傳 JPEG、PNG 檔案。"
    },
    {
        "key": "only_pdf_jpeg_png_files_are_allowed",
        "ko": "PDF, JPEG, PNG 파일만 업로드 가능합니다.",
        "ja": "PDF、JPEG、PNGファイルのみアップロード可能です。",
        "de": "Only PDF, JPEG, PNG files are allowed.",
        "en": "Only PDF, JPEG, PNG files are allowed.",
        "zh-Hans": "仅允许 PDF、JPEG、PNG 文件。",
        "zh-Hant": "僅允許 PDF、JPEG、PNG 檔案。"
    },
    {
        "key": "org_detail_chart_participants",
        "ko": "참가자수",
        "ja": "参加者数",
        "de": "Participants",
        "en": "Participants",
        "zh-Hans": "参与人数",
        "zh-Hant": "參與人數"
    },
    {
        "key": "org_detail_participants",
        "ko": "참가자",
        "ja": "参加者",
        "de": "Participants",
        "en": "Participants",
        "zh-Hans": "参与者",
        "zh-Hant": "參與者"
    },
    {
        "key": "org_detail_steps",
        "ko": "발디딤",
        "ja": "歩数",
        "de": "Schritte",
        "en": "Steps",
        "zh-Hans": "步数",
        "zh-Hant": "步數"
    },
    {
        "key": "org_top_rank",
        "ko": "기관1위",
        "ja": "機関1位",
        "de": "Org. 1. Platz",
        "en": "Org top rank",
        "zh-Hans": "机构第1名",
        "zh-Hant": "機構第1名"
    },
    {
        "key": "org_total_application",
        "ko": "기관총응모",
        "ja": "機関総応募",
        "de": "Org. Gesamtbewerbungen",
        "en": "Org total applications",
        "zh-Hans": "机构总报名",
        "zh-Hant": "機構總報名"
    },
    {
        "key": "org_type_and_division",
        "ko": "기관 유형 및 세부소속",
        "ja": "機関タイプ・細部所属",
        "de": "org_type_and_division",
        "en": "org_type_and_division",
        "zh-Hans": "机构类型及详细所属",
        "zh-Hant": "機構類型及詳細所屬"
    },
    {
        "key": "org_type_elementary_school",
        "ko": "초등학교",
        "ja": "小学校",
        "de": "Grundschule",
        "en": "Elementary school",
        "zh-Hans": "小学",
        "zh-Hant": "小學"
    },
    {
        "key": "org_type_high_school",
        "ko": "고등학교",
        "ja": "高等学校",
        "de": "Gymnasium",
        "en": "High school",
        "zh-Hans": "高中",
        "zh-Hant": "高中"
    },
    {
        "key": "org_type_kindergarten",
        "ko": "유치원",
        "ja": "幼稚園",
        "de": "Kindergarten",
        "en": "Kindergarten",
        "zh-Hans": "幼儿园",
        "zh-Hant": "幼兒園"
    },
    {
        "key": "org_type_middle_school",
        "ko": "중학교",
        "ja": "中学校",
        "de": "Mittelschule",
        "en": "Middle school",
        "zh-Hans": "初中",
        "zh-Hant": "初中"
    },
    {
        "key": "org_type_other",
        "ko": "기타",
        "ja": "その他",
        "de": "Sonstige",
        "en": "Other",
        "zh-Hans": "其他",
        "zh-Hant": "其他"
    },
    {
        "key": "org_type_welfare_facility",
        "ko": "복지시설",
        "ja": "福祉施設",
        "de": "Sozialeinrichtung",
        "en": "Welfare facility",
        "zh-Hans": "福利设施",
        "zh-Hant": "福利設施"
    },
    {
        "key": "org_type_youth_facility",
        "ko": "청소년시설",
        "ja": "青少年施設",
        "de": "Jugendeinrichtung",
        "en": "Youth facility",
        "zh-Hans": "青少年设施",
        "zh-Hant": "青少年設施"
    },
    {
        "key": "organization",
        "ko": "기관",
        "ja": "機関",
        "de": "Organisation",
        "en": "Organization",
        "zh-Hans": "机构",
        "zh-Hant": "機構"
    },
    {
        "key": "organization_admin_account",
        "ko": "기관관리자계정",
        "ja": "機関管理者アカウント",
        "de": "Organisations-Administratorkonto",
        "en": "Organization admin account",
        "zh-Hans": "机构管理员账号",
        "zh-Hant": "機構管理員帳號"
    },
    {
        "key": "organization_already_added",
        "ko": "이미 추가된 기관입니다.",
        "ja": "既に追加された機関です。",
        "de": "Diese Organisation wurde bereits hinzugefügt.",
        "en": "This organization has already been added.",
        "zh-Hans": "此机构已被添加。",
        "zh-Hant": "此機構已被新增。"
    },
    {
        "key": "organization_application_detail",
        "ko": "승인대기 기관상세목록",
        "ja": "承認待ち機関詳細",
        "de": "Organisationsantrag-Details",
        "en": "Organization application detail",
        "zh-Hans": "待批准机构详细列表",
        "zh-Hant": "待批准機構詳細清單"
    },
    {
        "key": "organization_application_failed",
        "ko": "기관 가입 신청에 실패했습니다.",
        "ja": "機関登録申請に失敗しました。",
        "de": "Organisationsantrag fehlgeschlagen.",
        "en": "Organization application failed.",
        "zh-Hans": "机构加入申请失败。",
        "zh-Hant": "機構加入申請失敗。"
    },
    {
        "key": "organization_application_form",
        "ko": "기관가입신청서",
        "ja": "機関登録申請書",
        "de": "Organization Application Form",
        "en": "Organization Application Form",
        "zh-Hans": "机构加入申请表",
        "zh-Hant": "機構加入申請表"
    },
    {
        "key": "organization_application_list",
        "ko": "승인대기 기관목록",
        "ja": "承認待ち機関一覧",
        "de": "Organisationsantragsliste",
        "en": "Organization application list",
        "zh-Hans": "待批准机构列表",
        "zh-Hant": "待批准機構清單"
    },
    {
        "key": "organization_application_status",
        "ko": "기관 신청 현황",
        "ja": "機関申請状況",
        "de": "Organisationsantragsstatus",
        "en": "Organization application status",
        "zh-Hans": "机构申请状态",
        "zh-Hant": "機構申請狀態"
    },
    {
        "key": "organization_contribution",
        "ko": "기관기여도",
        "ja": "機関貢献度",
        "de": "Organisationsbeitrag",
        "en": "Organization contribution",
        "zh-Hans": "机构贡献度",
        "zh-Hant": "機構貢獻度"
    },
    {
        "key": "organization_created_date",
        "ko": "기관생성일",
        "ja": "機関作成日",
        "de": "Organisationserstellungsdatum",
        "en": "Organization created date",
        "zh-Hans": "机构创建日期",
        "zh-Hant": "機構創建日期"
    },
    {
        "key": "organization_detail",
        "ko": "기관 상세",
        "ja": "機関詳細",
        "de": "Organisationsdetails",
        "en": "Organization detail",
        "zh-Hans": "机构详情",
        "zh-Hant": "機構詳情"
    },
    {
        "key": "organization_has_been_approved",
        "ko": "기관이 승인되었습니다.",
        "ja": "機関が承認されました。",
        "de": "Organisation wurde genehmigt.",
        "en": "Organization has been approved.",
        "zh-Hans": "机构已批准。",
        "zh-Hant": "機構已批准。"
    },
    {
        "key": "organization_has_been_deleted",
        "ko": "기관이 삭제되었습니다.",
        "ja": "機関が削除されました。",
        "de": "Organisation wurde gelöscht.",
        "en": "Organization has been deleted.",
        "zh-Hans": "机构已删除。",
        "zh-Hant": "機構已刪除。"
    },
    {
        "key": "organization_has_been_processed_successfully",
        "ko": "기관이 성공적으로 처리되었습니다.",
        "ja": "機関が正常に処理されました。",
        "de": "Organization has been processed successfully.",
        "en": "Organization has been processed successfully.",
        "zh-Hans": "机构已成功处理。",
        "zh-Hant": "機構已成功處理。"
    },
    {
        "key": "organization_has_been_rejected",
        "ko": "기관이 반려되었습니다.",
        "ja": "機関が却下されました。",
        "de": "Organization has been rejected.",
        "en": "Organization has been rejected.",
        "zh-Hans": "机构已驳回。",
        "zh-Hant": "機構已駁回。"
    },
    {
        "key": "organization_id",
        "ko": "기관ID",
        "ja": "機関ID",
        "de": "Organization ID",
        "en": "Organization ID",
        "zh-Hans": "机构 ID",
        "zh-Hant": "機構 ID"
    },
    {
        "key": "organization_information_has_been_updated",
        "ko": "기관 정보가 수정되었습니다.",
        "ja": "機関情報が更新されました。",
        "de": "Organization information has been updated.",
        "en": "Organization information has been updated.",
        "zh-Hans": "机构信息已更新。",
        "zh-Hant": "機構資訊已更新。"
    },
    {
        "key": "organization_information_not_found",
        "ko": "기관 정보를 찾을 수 없습니다.",
        "ja": "機関情報が見つかりません。",
        "de": "Organization information not found.",
        "en": "Organization information not found.",
        "zh-Hans": "找不到机构信息。",
        "zh-Hant": "找不到機構資訊。"
    },
    {
        "key": "organization_join_date",
        "ko": "기관가입일",
        "ja": "機関加入日",
        "de": "Organisationsbeitrittsdatum",
        "en": "Organization join date",
        "zh-Hans": "机构加入日期",
        "zh-Hant": "機構加入日期"
    },
    {
        "key": "organization_list",
        "ko": "기관 목록",
        "ja": "機関一覧",
        "de": "Organisationsliste",
        "en": "Organization list",
        "zh-Hans": "机构列表",
        "zh-Hant": "機構清單"
    },
    {
        "key": "organization_management",
        "ko": "기관관리",
        "ja": "機関管理",
        "de": "Organisationsverwaltung",
        "en": "Organization management",
        "zh-Hans": "机构管理",
        "zh-Hant": "機構管理"
    },
    {
        "key": "organization_membership_list",
        "ko": "소속기관리스트",
        "ja": "所属機関リスト",
        "de": "Organisationsmitgliederliste",
        "en": "Organization membership list",
        "zh-Hans": "所属机构列表",
        "zh-Hant": "所屬機構清單"
    },
    {
        "key": "organization_name",
        "ko": "기관명",
        "ja": "機関名",
        "de": "Organisationsname",
        "en": "Organization name",
        "zh-Hans": "机构名称",
        "zh-Hant": "機構名稱"
    },
    {
        "key": "organization_name_2_20_characters",
        "ko": "기관명은 2~20자 이내로 입력해주세요.",
        "ja": "機関名（2〜20文字）。",
        "de": "Organization name (2-20 characters).",
        "en": "Organization name (2-20 characters).",
        "zh-Hans": "机构名称（2~20个字符）。",
        "zh-Hant": "機構名稱（2~20個字元）。"
    },
    {
        "key": "organization_name_must_be_2_to_20_characters",
        "ko": "기관명은 2~20자 이내여야 합니다.",
        "ja": "機関名は2文字以上20文字以内で入力してください。",
        "de": "Organization name must be 2 to 20 characters.",
        "en": "Organization name must be 2 to 20 characters.",
        "zh-Hans": "机构名称必须为2到20个字符。",
        "zh-Hant": "機構名稱必須為2到20個字元。"
    },
    {
        "key": "organization_point_history",
        "ko": "기관포인트 내역",
        "ja": "機関ポイント履歴",
        "de": "Organisationspunkteverlauf",
        "en": "Organization point history",
        "zh-Hans": "机构积分记录",
        "zh-Hant": "機構積分記錄"
    },
    {
        "key": "organization_points_earned",
        "ko": "획득기관포인트",
        "ja": "獲得機関ポイント",
        "de": "Von der Organisation verdiente Punkte",
        "en": "Organization points earned",
        "zh-Hans": "获得的机构积分",
        "zh-Hant": "獲得的機構積分"
    },
    {
        "key": "organization_ranking",
        "ko": "2. 기관랭킹제",
        "ja": "2. 機関ランキング制",
        "de": "Organisations-Ranking",
        "en": "Organization ranking",
        "zh-Hans": "2. 机构排名制",
        "zh-Hant": "2. 機構排名制"
    },
    {
        "key": "organization_register",
        "ko": "기관 등록",
        "ja": "機関登録",
        "de": "Organisationsregistrierung",
        "en": "Organization registration",
        "zh-Hans": "机构注册",
        "zh-Hant": "機構註冊"
    },
    {
        "key": "organization_registration",
        "ko": "기관가입신청",
        "ja": "機関登録申請",
        "de": "Organisationsregistrierung",
        "en": "Organization registration",
        "zh-Hans": "机构加入申请",
        "zh-Hant": "機構加入申請"
    },
    {
        "key": "organization_registration_date",
        "ko": "기관등록일",
        "ja": "機関登録日",
        "de": "Organisationsregistrierungsdatum",
        "en": "Organization registration date",
        "zh-Hans": "机构注册日期",
        "zh-Hant": "機構註冊日期"
    },
    {
        "key": "organization_search_error",
        "ko": "기관 검색 중 오류가 발생했습니다.",
        "ja": "機関検索中にエラーが発生しました。",
        "de": "Beim Suchen nach Organisationen ist ein Fehler aufgetreten.",
        "en": "An error occurred while searching for organizations.",
        "zh-Hans": "搜索机构时发生错误。",
        "zh-Hant": "搜尋機構時發生錯誤。"
    },
    {
        "key": "organization_search_hint",
        "ko": "참고) \"서울초등학교\" 라면 \"서울\"로 검색해도 검색가능합니다.",
        "ja": "参考）「ソウル小学校」なら「ソウル」で検索できます。",
        "de": "Hinweis: Sie können mit einem Teil des Namens suchen (z. B. \"Seoul\" für \"Seoul Elementary School\").",
        "en": "Note: You can search with a partial name (e.g. \"Seoul\" for \"Seoul Elementary School\").",
        "zh-Hans": "参考）如果是“首尔小学”，也可以搜索“首尔”。",
        "zh-Hant": "參考）如果是“首爾小學”，也可以搜尋“首爾”。"
    },
    {
        "key": "organization_search_placeholder",
        "ko": "소속기관 이름으로 검색",
        "ja": "所属機関名で検索",
        "de": "Nach Name der zugehörigen Organisation suchen",
        "en": "Search by affiliated organization name",
        "zh-Hans": "按所属机构名称搜索",
        "zh-Hant": "按所屬機構名稱搜尋"
    },
    {
        "key": "organization_type",
        "ko": "기관유형",
        "ja": "機関タイプ",
        "de": "Organisationstyp",
        "en": "Organization type",
        "zh-Hans": "机构类型",
        "zh-Hant": "機構類型"
    },
    {
        "key": "osaka_metropolitan_city",
        "ko": "오사카",
        "ja": "大阪市",
        "de": "Osaka",
        "en": "Osaka",
        "zh-Hans": "大阪",
        "zh-Hant": "大阪"
    },
    {
        "key": "other",
        "ko": "기타",
        "ja": "その他",
        "de": "Other",
        "en": "Other",
        "zh-Hans": "其他",
        "zh-Hant": "其他"
    },
    {
        "key": "other_login_methods",
        "ko": "다른 로그인 방법",
        "ja": "その他のログイン方法",
        "de": "Andere Anmeldemethoden",
        "en": "Other login methods",
        "zh-Hans": "其他登录方式",
        "zh-Hant": "其他登入方式"
    },
    {
        "key": "participant_ranking",
        "ko": "참가자 랭킹",
        "ja": "参加者ランキング",
        "de": "Teilnehmer-Ranking",
        "en": "Participant Ranking",
        "zh-Hans": "参与者排名",
        "zh-Hant": "參與者排名"
    },
    {
        "key": "participants",
        "ko": "참여인원",
        "ja": "参加人数",
        "de": "Participants",
        "en": "Participants",
        "zh-Hans": "参与人数",
        "zh-Hant": "參與人數"
    },
    {
        "key": "password",
        "ko": "비밀번호",
        "ja": "パスワード",
        "de": "Passwort",
        "en": "Password",
        "zh-Hans": "密码",
        "zh-Hant": "密碼"
    },
    {
        "key": "password_mismatch",
        "ko": "비밀번호가 일치하지 않습니다.",
        "ja": "パスワードが一致しません。",
        "de": "Passwörter stimmen nicht überein.",
        "en": "Password mismatch.",
        "zh-Hans": "密码不一致。",
        "zh-Hant": "密碼不一致。"
    },
    {
        "key": "password_requirement_placeholder",
        "ko": "영문자, 숫자, 기호 중 2개이상 포함 6~12자",
        "ja": "英数字・記号のうち2種類以上、6〜12文字",
        "de": "Buchstaben, Zahlen, Symbole (mind. 2 Arten), 6-12 Zeichen",
        "en": "Letters, numbers, symbols (at least 2 types), 6-12 characters",
        "zh-Hans": "英文字母、数字、符号（至少2种），6~12个字符",
        "zh-Hant": "英文字母、數字、符號（至少2種），6~12個字元"
    },
    {
        "key": "passwords_do_not_match",
        "ko": "비밀번호가 일치하지 않습니다.",
        "ja": "パスワードが一致しません。",
        "de": "Passwords do not match.",
        "en": "Passwords do not match.",
        "zh-Hans": "密码不匹配。",
        "zh-Hant": "密碼不匹配。"
    },
    {
        "key": "past_time_cannot_be_selected",
        "ko": "과거 시간은 선택할 수 없습니다.",
        "ja": "過去の時間は選択できません。",
        "de": "Past time cannot be selected.",
        "en": "Past time cannot be selected.",
        "zh-Hans": "不能选择过去的时间。",
        "zh-Hant": "不能選擇過去的時間。"
    },
    {
        "key": "pdf_jpeg_png_only_max_1_file_10mb",
        "ko": "PDF, JPEG, PNG 파일만 가능 (최대 1개, 10MB)",
        "ja": "PDF、JPEG、PNGのみ（最大1ファイル、10MB）",
        "de": "PDF, JPEG, PNG only (max 1 file, 10MB)",
        "en": "PDF, JPEG, PNG only (max 1 file, 10MB)",
        "zh-Hans": "仅限 PDF、JPEG、PNG（最多1个文件，10MB）",
        "zh-Hant": "僅限 PDF、JPEG、PNG（最多1個檔案，10MB）"
    },
    {
        "key": "pending_approval",
        "ko": "승인대기",
        "ja": "承認待ち",
        "de": "Genehmigung ausstehend",
        "en": "Pending Approval",
        "zh-Hans": "待批准",
        "zh-Hant": "待批准"
    },
    {
        "key": "phone_number",
        "ko": "전화번호",
        "ja": "電話番号",
        "de": "Telefonnummer",
        "en": "Phone number",
        "zh-Hans": "电话号码",
        "zh-Hant": "電話號碼"
    },
    {
        "key": "photo_library",
        "ko": "사진 보관함",
        "ja": "フォトライブラリ",
        "de": "Fotobibliothek",
        "en": "Photo Library",
        "zh-Hans": "照片图库",
        "zh-Hant": "照片圖庫"
    },
    {
        "key": "physical_training",
        "ko": "체력단련",
        "ja": "体力トレーニング",
        "de": "Körperliches Training",
        "en": "Physical training",
        "zh-Hans": "体能训练",
        "zh-Hant": "體能訓練"
    },
    {
        "key": "please_attach_post_image",
        "ko": "게시 이미지를 첨부해주세요.",
        "ja": "投稿画像を添付してください。",
        "de": "Bitte fügen Sie ein Beitragsbild bei.",
        "en": "Please attach a post image.",
        "zh-Hans": "请附加帖子图片。",
        "zh-Hant": "請附加貼文圖片。"
    },
    {
        "key": "please_check_your_input",
        "ko": "입력 정보를 확인해주세요.",
        "ja": "入力内容を確認してください。",
        "de": "Please check your input.",
        "en": "Please check your input.",
        "zh-Hans": "请检查输入信息。",
        "zh-Hant": "請檢查輸入資訊。"
    },
    {
        "key": "please_check_your_network_connection",
        "ko": "네트워크 연결을 확인해주세요.",
        "ja": "ネットワーク接続を確認してください。",
        "de": "Please check your network connection.",
        "en": "Please check your network connection.",
        "zh-Hans": "请检查网络连接。",
        "zh-Hant": "請檢查網路連線。"
    },
    {
        "key": "please_enter",
        "ko": "입력해주세요.",
        "ja": "入力してください。",
        "de": "Bitte eingeben.",
        "en": "Please enter.",
        "zh-Hans": "请输入。",
        "zh-Hant": "請輸入。"
    },
    {
        "key": "please_enter_9_11_digit_phone_number",
        "ko": "9~11자리 숫자로 입력해주세요.",
        "ja": "9〜11桁の電話番号を入力してください。",
        "de": "Please enter 9-11 digit phone number.",
        "en": "Please enter 9-11 digit phone number.",
        "zh-Hans": "请输入9~11位电话号码。",
        "zh-Hant": "請輸入9~11位電話號碼。"
    },
    {
        "key": "please_enter_a_4_digit_password",
        "ko": "비밀번호는 4자리로 입력해주세요.",
        "ja": "パスワードは4桁で入力してください。",
        "de": "Please enter a 4-digit password.",
        "en": "Please enter a 4-digit password.",
        "zh-Hans": "请输入4位密码。",
        "zh-Hant": "請輸入4位密碼。"
    },
    {
        "key": "please_enter_a_memo_regarding_the_edit",
        "ko": "수정시 수정관련 메모를 꼭 입력해주세요.",
        "ja": "修正時は修正に関するメモを必ず入力してください。",
        "de": "Please enter a memo regarding the edit.",
        "en": "Please enter a memo regarding the edit.",
        "zh-Hans": "编辑时请务必输入相关备注。",
        "zh-Hant": "編輯時請務必輸入相關備註。"
    },
    {
        "key": "please_enter_a_valid_email_address",
        "ko": "올바른 이메일 형식을 입력해주세요.",
        "ja": "有効なメールアドレスを入力してください。",
        "de": "Please enter a valid email address.",
        "en": "Please enter a valid email address.",
        "zh-Hans": "请输入有效的电子邮件格式。",
        "zh-Hant": "請輸入有效的電子郵件格式。"
    },
    {
        "key": "please_enter_a_valid_zip_code",
        "ko": "우편번호를 올바르게 입력해주세요.",
        "ja": "郵便番号を正しく入力してください。",
        "de": "Please enter a valid zip code.",
        "en": "Please enter a valid zip code.",
        "zh-Hans": "请正确输入邮政编码。",
        "zh-Hant": "請正確輸入郵遞區號。"
    },
    {
        "key": "please_enter_contact_email",
        "ko": "담당자 메일을 입력해주세요.",
        "ja": "担当者メールを入力してください。",
        "de": "Please enter contact email.",
        "en": "Please enter contact email.",
        "zh-Hans": "请输入联系人邮箱。",
        "zh-Hant": "請輸入聯絡人郵箱。"
    },
    {
        "key": "please_enter_contact_phone",
        "ko": "담당자 연락처를 입력해주세요.",
        "ja": "担当者連絡先を入力してください。",
        "de": "Please enter contact phone.",
        "en": "Please enter contact phone.",
        "zh-Hans": "请输入联系人电话。",
        "zh-Hant": "請輸入聯絡人電話。"
    },
    {
        "key": "please_enter_contact_title",
        "ko": "담당자직책을 입력해주세요.",
        "ja": "担当者役職を入力してください。",
        "de": "Please enter contact title.",
        "en": "Please enter contact title.",
        "zh-Hans": "请输入联系人职务。",
        "zh-Hant": "請輸入聯絡人職務。"
    },
    {
        "key": "please_enter_date_of_birth",
        "ko": "생년월일을 입력해주세요.",
        "ja": "生年月日を入力してください。",
        "de": "Please enter date of birth.",
        "en": "Please enter date of birth.",
        "zh-Hans": "请输入出生日期。",
        "zh-Hant": "請輸入出生日期。"
    },
    {
        "key": "please_enter_latitude_and_longitude",
        "ko": "위도와 경도를 입력해주세요.",
        "ja": "緯度と経度を入力してください。",
        "de": "Please enter latitude and longitude.",
        "en": "Please enter latitude and longitude.",
        "zh-Hans": "请输入纬度和经度。",
        "zh-Hant": "請輸入緯度和經度。"
    },
    {
        "key": "please_enter_notification_email",
        "ko": "안내받을 메일을 입력해주세요.",
        "ja": "案内を受け取るメールアドレスを入力してください。",
        "de": "Bitte geben Sie die E-Mail-Adresse für Benachrichtigungen ein.",
        "en": "Please enter the email address to receive notifications.",
        "zh-Hans": "请输入用于接收通知的电子邮件。",
        "zh-Hant": "請輸入用於接收通知的電子郵件。"
    },
    {
        "key": "please_enter_organization_admin_account",
        "ko": "기관관리자계정을 입력해주세요.",
        "ja": "機関管理者アカウントを入力してください。",
        "de": "Please enter organization admin account.",
        "en": "Please enter organization admin account.",
        "zh-Hans": "请输入机构管理员账号。",
        "zh-Hant": "請輸入機構管理員帳號。"
    },
    {
        "key": "please_enter_organization_name",
        "ko": "기관명을 입력해주세요.",
        "ja": "機関名を入力してください。",
        "de": "Please enter organization name.",
        "en": "Please enter organization name.",
        "zh-Hans": "请输入机构名称。",
        "zh-Hant": "請輸入機構名稱。"
    },
    {
        "key": "please_enter_organization_type_and_division_details",
        "ko": "기관유형 및 세부소속을 입력해주세요.",
        "ja": "機関タイプと詳細所属を入力してください。",
        "de": "Bitte geben Sie Organisationsart und Zugehörigkeitsdetails ein.",
        "en": "Please enter organization type and division details.",
        "zh-Hans": "请输入机构类型及详细所属。",
        "zh-Hant": "請輸入機構類型及詳細所屬。"
    },
    {
        "key": "please_enter_password",
        "ko": "비밀번호를 입력해주세요.",
        "ja": "パスワードを入力してください。",
        "de": "Please enter password.",
        "en": "Please enter password.",
        "zh-Hans": "请输入密码。",
        "zh-Hant": "請輸入密碼。"
    },
    {
        "key": "please_enter_password_confirmation",
        "ko": "비밀번호 확인을 입력해주세요.",
        "ja": "パスワード確認を入力してください。",
        "de": "Please enter password confirmation.",
        "en": "Please enter password confirmation.",
        "zh-Hans": "请输入密码确认。",
        "zh-Hant": "請輸入密碼確認。"
    },
    {
        "key": "please_enter_password_first",
        "ko": "비밀번호를 먼저 입력해주세요.",
        "ja": "先にパスワードを入力してください。",
        "de": "Bitte geben Sie zuerst Ihr Passwort ein.",
        "en": "Please enter your password first.",
        "zh-Hans": "请先输入密码。",
        "zh-Hant": "請先輸入密碼。"
    },
    {
        "key": "please_enter_phone_number_numbers_only",
        "ko": "전화번호를 입력해주세요 (예: 01012345678).",
        "ja": "電話番号を入力してください（数字のみ）。",
        "de": "Please enter phone number (numbers only).",
        "en": "Please enter phone number (numbers only).",
        "zh-Hans": "请输入电话号码（例：01012345678）。",
        "zh-Hant": "請輸入電話號碼（例：01012345678）。"
    },
    {
        "key": "please_enter_reward_condition",
        "ko": "보상조건을 입력해주세요.",
        "ja": "報酬条件を入力してください。",
        "de": "Please enter reward condition.",
        "en": "Please enter reward condition.",
        "zh-Hans": "请输入奖励条件。",
        "zh-Hant": "請輸入獎勵條件。"
    },
    {
        "key": "please_enter_the_required_fields",
        "ko": "필수 항목을 입력해주세요.",
        "ja": "必須項目を入力してください。",
        "de": "Bitte geben Sie die Pflichtfelder ein.",
        "en": "Please enter the required fields.",
        "zh-Hans": "请输入必填项。",
        "zh-Hant": "請輸入必填項。"
    },
    {
        "key": "please_enter_verification_code",
        "ko": "인증코드를 입력해주세요.",
        "ja": "認証コードを入力してください。",
        "de": "Please enter verification code.",
        "en": "Please enter verification code.",
        "zh-Hans": "请输入验证码。",
        "zh-Hant": "請輸入驗證碼。"
    },
    {
        "key": "please_enter_within_24_characters",
        "ko": "24자 이내로 입력해주세요.",
        "ja": "24文字以内で入力してください。",
        "de": "Please enter within 24 characters.",
        "en": "Please enter within 24 characters.",
        "zh-Hans": "请输入24个字符以内。",
        "zh-Hant": "請輸入24個字元以內。"
    },
    {
        "key": "please_enter_your_account",
        "ko": "사용자계정을 입력해주세요.",
        "ja": "アカウントを入力してください。",
        "de": "Please enter your account.",
        "en": "Please enter your account.",
        "zh-Hans": "请输入用户账号。",
        "zh-Hant": "請輸入使用者帳號。"
    },
    {
        "key": "please_enter_your_date_of_birth_8_digits",
        "ko": "생년월일 8자리를 입력해주세요.",
        "ja": "生年月日を8桁で入力してください。",
        "de": "Please enter your date of birth (8 digits).",
        "en": "Please enter your date of birth (8 digits).",
        "zh-Hans": "请输入8位出生日期。",
        "zh-Hant": "請輸入8位出生日期。"
    },
    {
        "key": "please_enter_your_email",
        "ko": "이메일을 입력해주세요.",
        "ja": "メールアドレスを入力してください。",
        "de": "Please enter your email.",
        "en": "Please enter your email.",
        "zh-Hans": "请输入您的电子邮件。",
        "zh-Hant": "請輸入您的電子郵件。"
    },
    {
        "key": "please_enter_your_name",
        "ko": "이름을 입력해주세요.",
        "ja": "名前を入力してください。",
        "de": "Please enter your name.",
        "en": "Please enter your name.",
        "zh-Hans": "请输入您的姓名。",
        "zh-Hant": "請輸入您的姓名。"
    },
    {
        "key": "please_enter_your_password",
        "ko": "계정비밀번호를 입력해주세요.",
        "ja": "パスワードを入力してください。",
        "de": "Please enter your password.",
        "en": "Please enter your password.",
        "zh-Hans": "请输入账号密码。",
        "zh-Hant": "請輸入帳號密碼。"
    },
    {
        "key": "please_fill_required_fields",
        "ko": "필수 항목을 모두 입력해주세요.",
        "ja": "必須項目をすべて入力してください。",
        "de": "Bitte füllen Sie alle Pflichtfelder aus.",
        "en": "Please fill in all required fields.",
        "zh-Hans": "请填写所有必填项。",
        "zh-Hant": "請填寫所有必填項。"
    },
    {
        "key": "please_leave_a_reason_memo",
        "ko": "이유 메모를 남겨주세요.",
        "ja": "理由のメモを残してください。",
        "de": "Please leave a reason memo.",
        "en": "Please leave a reason memo.",
        "zh-Hans": "请留下理由备注。",
        "zh-Hant": "請留下理由備註。"
    },
    {
        "key": "please_scan_the_didim_screen_qr_code",
        "ko": "디딤화면 QR을 스캔해주세요.",
        "ja": "ディディム画面のQRコードをスキャンしてください。",
        "de": "Please scan the Didim screen QR code.",
        "en": "Please scan the Didim screen QR code.",
        "zh-Hans": "请扫描 Didim 画面的二维码。",
        "zh-Hant": "請掃描 Didim 畫面的 QR 碼。"
    },
    {
        "key": "please_select",
        "ko": "선택해주세요.",
        "ja": "選択してください。",
        "de": "Please select.",
        "en": "Please select.",
        "zh-Hans": "请选择。",
        "zh-Hant": "請選擇。"
    },
    {
        "key": "please_select_a_main_organization",
        "ko": "주기관을 선택해주세요.",
        "ja": "主機関を選択してください。",
        "de": "Please select a main organization.",
        "en": "Please select a main organization.",
        "zh-Hans": "请选择主机构。",
        "zh-Hant": "請選擇主機構。"
    },
    {
        "key": "please_select_division_1",
        "ko": "세부소속1을 선택하세요.",
        "ja": "詳細所属1を選択してください。",
        "de": "Please select division 1.",
        "en": "Please select division 1.",
        "zh-Hans": "请选择详细所属1。",
        "zh-Hant": "請選擇詳細所屬1。"
    },
    {
        "key": "please_select_division_1_for_organization_n",
        "ko": "기관 {{n}}의 세부소속1을 선택하세요.",
        "ja": "please_select_division_1_for_organization_n。",
        "de": "please_select_division_1_for_organization_n.",
        "en": "please_select_division_1_for_organization_n.",
        "zh-Hans": "请选择机构 {{n}} 的详细所属1。",
        "zh-Hant": "請選擇機構 {{n}} 的詳細所屬1。"
    },
    {
        "key": "please_select_division_2",
        "ko": "세부소속2를 선택하세요.",
        "ja": "詳細所属2を選択してください。",
        "de": "Please select division 2.",
        "en": "Please select division 2.",
        "zh-Hans": "请选择详细所属2。",
        "zh-Hant": "請選擇詳細所屬2。"
    },
    {
        "key": "please_select_division_2_for_organization_n",
        "ko": "기관 {{n}}의 세부소속2를 선택하세요.",
        "ja": "please_select_division_2_for_organization_n。",
        "de": "please_select_division_2_for_organization_n.",
        "en": "please_select_division_2_for_organization_n.",
        "zh-Hans": "请选择机构 {{n}} 的详细所属2。",
        "zh-Hant": "請選擇機構 {{n}} 的詳細所屬2。"
    },
    {
        "key": "please_select_gender",
        "ko": "성별을 선택해주세요.",
        "ja": "性別を選択してください。",
        "de": "Please select gender.",
        "en": "Please select gender.",
        "zh-Hans": "请选择性别。",
        "zh-Hant": "請選擇性別。"
    },
    {
        "key": "please_select_organization_type",
        "ko": "기관유형을 선택해주세요.",
        "ja": "機関タイプを選択してください。",
        "de": "Please select organization type.",
        "en": "Please select organization type.",
        "zh-Hans": "请选择机构类型。",
        "zh-Hant": "請選擇機構類型。"
    },
    {
        "key": "please_select_region",
        "ko": "지역을 선택해주세요.",
        "ja": "地域を選択してください。",
        "de": "Please select region.",
        "en": "Please select region.",
        "zh-Hans": "请选择地区。",
        "zh-Hant": "請選擇地區。"
    },
    {
        "key": "please_try_again",
        "ko": "다시 시도해주세요.",
        "ja": "もう一度お試しください。",
        "de": "Bitte versuchen Sie es erneut.",
        "en": "Please try again.",
        "zh-Hans": "请重试。",
        "zh-Hant": "請重試。"
    },
    {
        "key": "please_upload_attachment",
        "ko": "첨부서류를 업로드해주세요.",
        "ja": "添付書類をアップロードしてください。",
        "de": "Please upload attachment.",
        "en": "Please upload attachment.",
        "zh-Hans": "请上传附件材料。",
        "zh-Hant": "請上傳附件材料。"
    },
    {
        "key": "please_verify_your_email_address",
        "ko": "이메일 주소를 인증해주세요.",
        "ja": "メールアドレスを認証してください。",
        "de": "Please verify your email address.",
        "en": "Please verify your email address.",
        "zh-Hans": "请验证您的电子邮件地址。",
        "zh-Hant": "請驗證您的電子郵件地址。"
    },
    {
        "key": "pm",
        "ko": "오후",
        "ja": "午後",
        "de": "PM",
        "en": "PM",
        "zh-Hans": "下午",
        "zh-Hant": "下午"
    },
    {
        "key": "point_transaction",
        "ko": "포인트 거래",
        "ja": "ポイント取引",
        "de": "Punkte-Transaktion",
        "en": "Point transaction",
        "zh-Hans": "积分交易",
        "zh-Hant": "積分交易"
    },
    {
        "key": "points",
        "ko": "포인트",
        "ja": "ポイント",
        "de": "points",
        "en": "points",
        "zh-Hans": "积分",
        "zh-Hant": "積分"
    },
    {
        "key": "privacy_policy",
        "ko": "개인정보처리방침",
        "ja": "プライバシーポリシー",
        "de": "Datenschutzrichtlinie",
        "en": "Privacy Policy",
        "zh-Hans": "隐私政策",
        "zh-Hant": "隱私權政策"
    },
    {
        "key": "private",
        "ko": "비공개",
        "ja": "非公開",
        "de": "Privat",
        "en": "Private",
        "zh-Hans": "非公开",
        "zh-Hant": "非公開"
    },
    {
        "key": "processing",
        "ko": "처리중...",
        "ja": "処理中...",
        "de": "Wird verarbeitet...",
        "en": "Processing...",
        "zh-Hans": "处理中...",
        "zh-Hant": "處理中..."
    },
    {
        "key": "product_registration_date",
        "ko": "제품등록일",
        "ja": "製品登録日",
        "de": "Produktregistrierungsdatum",
        "en": "Product registration date",
        "zh-Hans": "产品注册日期",
        "zh-Hant": "產品註冊日期"
    },
    {
        "key": "profile_photo",
        "ko": "프로필사진",
        "ja": "プロフィール写真",
        "de": "Profilfoto",
        "en": "Profile photo",
        "zh-Hans": "个人资料照片",
        "zh-Hant": "個人資料照片"
    },
    {
        "key": "progress",
        "ko": "진행유무",
        "ja": "進行有無",
        "de": "Progress",
        "en": "Progress",
        "zh-Hans": "进度",
        "zh-Hant": "進度"
    },
    {
        "key": "progress_status",
        "ko": "진행유무",
        "ja": "進行可否",
        "de": "Fortschritt",
        "en": "Progress",
        "zh-Hans": "进度",
        "zh-Hant": "進度"
    },
    {
        "key": "pts",
        "ko": "점",
        "ja": "pt",
        "de": "pts",
        "en": "pts",
        "zh-Hans": "分",
        "zh-Hant": "分"
    },
    {
        "key": "public",
        "ko": "공개",
        "ja": "公開",
        "de": "Öffentlich",
        "en": "Public",
        "zh-Hans": "公开",
        "zh-Hant": "公開"
    },
    {
        "key": "public_private",
        "ko": "공개/비공개",
        "ja": "公開/非公開",
        "de": "Public/Private",
        "en": "Public/Private",
        "zh-Hans": "公开/非公开",
        "zh-Hant": "公開/非公開"
    },
    {
        "key": "published",
        "ko": "게시됨",
        "ja": "公開済み",
        "de": "Veröffentlicht",
        "en": "Published",
        "zh-Hans": "已发布",
        "zh-Hant": "已發布"
    },
    {
        "key": "push_notification",
        "ko": "푸시알림",
        "ja": "プッシュ通知",
        "de": "Push-Benachrichtigung",
        "en": "Push notification",
        "zh-Hans": "推送通知",
        "zh-Hant": "推播通知"
    },
    {
        "key": "push_notification_settings",
        "ko": "푸시알림설정",
        "ja": "プッシュ通知設定",
        "de": "Push-Benachrichtigungseinstellungen",
        "en": "Push notification settings",
        "zh-Hans": "推送通知设置",
        "zh-Hant": "推播通知設定"
    },
    {
        "key": "push_notifications",
        "ko": "푸시알림",
        "ja": "プッシュ通知",
        "de": "Push-Benachrichtigungen",
        "en": "Push notifications",
        "zh-Hans": "推送通知",
        "zh-Hant": "推播通知"
    },
    {
        "key": "qr_code_scanned_text",
        "ko": "QR 코드가 스캔되었습니다: {{text}}",
        "ja": "QRコードがスキャンされました: {{text}}",
        "de": "QR code scanned: {{text}}",
        "en": "QR code scanned: {{text}}",
        "zh-Hans": "已扫描二维码：{{text}}",
        "zh-Hant": "已掃描 QR 碼：{{text}}"
    },
    {
        "key": "quarter_finals",
        "ko": "8강",
        "ja": "8強",
        "de": "Quarter-finals",
        "en": "Quarter-finals",
        "zh-Hans": "四分之一决赛",
        "zh-Hant": "四分之一決賽"
    },
    {
        "key": "rank",
        "ko": "순위",
        "ja": "順位",
        "de": "Rang",
        "en": "Rank",
        "zh-Hans": "名次",
        "zh-Hant": "名次"
    },
    {
        "key": "rank_suffix",
        "ko": "등",
        "ja": "位",
        "de": ".",
        "zh-Hans": "名",
        "zh-Hant": "名"
    },
    {
        "key": "ranking",
        "ko": "랭킹",
        "ja": "ランキング",
        "de": "Ranking",
        "en": "Ranking",
        "zh-Hans": "排名",
        "zh-Hant": "排名"
    },
    {
        "key": "ranking_cannot_be_viewed_after_3_days_before_deadline",
        "ko": "마감 3일 전부터는 랭킹을 볼 수 없습니다.",
        "ja": "締切3日前からランキングを表示できません。",
        "de": "Nach 3 Tagen vor Ablauf kann das Ranking nicht angezeigt werden.",
        "en": "Ranking cannot be viewed after 3 days before the deadline.",
        "zh-Hans": "截止前3天起无法查看排名。",
        "zh-Hant": "截止前3天起無法查看排名。"
    },
    {
        "key": "ranking_card_main_org_change_confirm_message",
        "ko": "메인 기관은 한달에 한번만 변경가능합니다. 참고) 개인경험치를 이용하여 메인기관 경험치가 상승합니다.  정말 메인기관을 변경하시겠습니까?",
        "ja": "主機関は1ヶ月に1回のみ変更できます。 参考）個人経験値で主機関経験値が上昇します。  本当に主機関を変更しますか？",
        "de": "Die Hauptorganisation kann nur einmal pro Monat geändert werden. Hinweis) Die Erfahrung der Hauptorganisation steigt durch persönliche Erfahrung. Möchten Sie die Hauptorganisation wirklich ändern?",
        "en": "You can change your main organization only once per month. Note) Main organization experience increases through personal experience.  Do you really want to change your main organization?",
        "zh-Hans": "主机构每月只能更改一次。参考）将使用个人经验值提升主机构经验值。确定要更改主机构吗？",
        "zh-Hant": "主機構每月只能變更一次。參考）將使用個人經驗值提升主機構經驗值。確定要變更主機構嗎？"
    },
    {
        "key": "ranking_card_rank_suffix",
        "ko": "등",
        "ja": "位",
        "de": ".",
        "en": "th",
        "zh-Hans": "名",
        "zh-Hant": "名"
    },
    {
        "key": "re_approval_pending",
        "ko": "재승인대기",
        "ja": "再承認待ち",
        "de": "Wiederholte Genehmigung ausstehend",
        "en": "Re-approval Pending",
        "zh-Hans": "重新批准待处理",
        "zh-Hant": "重新批准待處理"
    },
    {
        "key": "re_enter_new_admin_account_password",
        "ko": "새 관리자계정의 비밀번호를 다시 입력해주세요.",
        "ja": "新しい管理者アカウントのパスワードを再入力してください。",
        "de": "Geben Sie das neue Administratorpasswort erneut ein.",
        "en": "Re-enter new admin account password.",
        "zh-Hans": "请再次输入新管理员账号的密码。",
        "zh-Hant": "請再次輸入新管理員帳號的密碼。"
    },
    {
        "key": "re_enter_new_password",
        "ko": "새 비밀번호를 다시 입력하세요.",
        "ja": "新しいパスワードを再入力してください。",
        "de": "Re-enter new password.",
        "en": "Re-enter new password.",
        "zh-Hans": "请再次输入新密码。",
        "zh-Hant": "請再次輸入新密碼。"
    },
    {
        "key": "reached",
        "ko": "도달",
        "ja": "到達",
        "de": "Reached",
        "en": "Reached",
        "zh-Hans": "已达到",
        "zh-Hant": "已達到"
    },
    {
        "key": "recent_record",
        "ko": "최근기록",
        "ja": "最近の記録",
        "de": "Letzte Aufzeichnung",
        "en": "Recent record",
        "zh-Hans": "最近记录",
        "zh-Hant": "最近記錄"
    },
    {
        "key": "region",
        "ko": "지역",
        "ja": "地域",
        "de": "Region",
        "en": "Region",
        "zh-Hans": "地区",
        "zh-Hant": "地區"
    },
    {
        "key": "register_organization",
        "ko": "기관을 등록하시겠습니까?",
        "ja": "機関を登録しますか？",
        "de": "Register organization?",
        "en": "Register organization?",
        "zh-Hans": "要注册机构吗？",
        "zh-Hant": "要註冊機構嗎？"
    },
    {
        "key": "registered",
        "ko": "등록됨",
        "ja": "登録済み",
        "de": "Registriert",
        "en": "Registered",
        "zh-Hans": "已注册",
        "zh-Hant": "已註冊"
    },
    {
        "key": "registered_organization_will_be_activated_after_admin_approval",
        "ko": "등록된 기관은 관리자 승인 후 활성화됩니다.",
        "ja": "登録された機関は管理者承認後に有効化されます。",
        "de": "Registered organization will be activated after admin approval.",
        "en": "Registered organization will be activated after admin approval.",
        "zh-Hans": "注册的机构将在管理员批准后启用。",
        "zh-Hant": "註冊的機構將在管理員批准後啟用。"
    },
    {
        "key": "registration",
        "ko": "등록",
        "ja": "登録",
        "de": "Registrierung",
        "en": "Registration",
        "zh-Hans": "注册",
        "zh-Hant": "註冊"
    },
    {
        "key": "reject_delete_memo",
        "ko": "반려/삭제 메모",
        "ja": "却下/削除メモ",
        "de": "Reject/Delete memo",
        "en": "Reject/Delete memo",
        "zh-Hans": "驳回/删除备注",
        "zh-Hant": "駁回/刪除備註"
    },
    {
        "key": "reject_failed",
        "ko": "반려에 실패했습니다.",
        "ja": "却下に失敗しました。",
        "de": "Reject failed.",
        "en": "Reject failed.",
        "zh-Hans": "驳回失败。",
        "zh-Hant": "駁回失敗。"
    },
    {
        "key": "reject_with_email",
        "ko": "반려 후 이메일 발송",
        "ja": "却下後メール送信",
        "de": "E-Mail nach Ablehnung senden",
        "en": "Send email after rejection",
        "zh-Hans": "驳回后发送电子邮件",
        "zh-Hant": "駁回後發送電子郵件"
    },
    {
        "key": "rejected",
        "ko": "반려",
        "ja": "却下",
        "de": "Abgelehnt",
        "en": "Rejected",
        "zh-Hans": "已驳回",
        "zh-Hant": "已駁回"
    },
    {
        "key": "rejection_memo",
        "ko": "반려메모",
        "ja": "却下メモ",
        "de": "Ablehnungsvermerk",
        "en": "Rejection memo",
        "zh-Hans": "驳回备注",
        "zh-Hant": "駁回備註"
    },
    {
        "key": "relaxed",
        "ko": "이완",
        "ja": "リラックス",
        "de": "Relaxed",
        "en": "Relaxed",
        "zh-Hans": "放松",
        "zh-Hant": "放鬆"
    },
    {
        "key": "remarks",
        "ko": "비고",
        "ja": "備考",
        "de": "Remarks",
        "en": "Remarks",
        "zh-Hans": "备注",
        "zh-Hant": "備註"
    },
    {
        "key": "resend",
        "ko": "다시전송",
        "ja": "再送信",
        "de": "Resend",
        "en": "Resend",
        "zh-Hans": "重新发送",
        "zh-Hant": "重新發送"
    },
    {
        "key": "resend_code",
        "ko": "인증번호 재전송",
        "ja": "認証番号 再送信",
        "de": "Resend Code",
        "en": "Resend Code",
        "zh-Hans": "重新发送验证码",
        "zh-Hant": "重新發送驗證碼"
    },
    {
        "key": "reset_password",
        "ko": "비밀번호 변경",
        "ja": "パスワードをリセット",
        "de": "Passwort zurücksetzen",
        "en": "Reset Password",
        "zh-Hans": "重设密码",
        "zh-Hant": "重設密碼"
    },
    {
        "key": "restore_failed",
        "ko": "되돌리기에 실패했습니다.",
        "ja": "復元に失敗しました。",
        "de": "Restore failed.",
        "en": "Restore failed.",
        "zh-Hans": "恢复失败。",
        "zh-Hant": "恢復失敗。"
    },
    {
        "key": "result",
        "ko": "결과",
        "ja": "結果",
        "de": "Ergebnis",
        "en": "Result",
        "zh-Hans": "结果",
        "zh-Hant": "結果"
    },
    {
        "key": "result_auto_notice",
        "ko": "마감과 동시에 자동으로 결과가 통보됩니다.",
        "ja": "締め切りと同時に結果が自動通知されます。",
        "de": "Die Ergebnisse werden automatisch nach Ende der Bewerbung mitgeteilt.",
        "en": "Results are notified automatically when the application ends.",
        "zh-Hans": "报名结束时将自动通知结果。",
        "zh-Hant": "報名結束時將自動通知結果。"
    },
    {
        "key": "result_notified_after_deadline",
        "ko": "마감과 동시에 자동으로 결과가 통보됩니다.",
        "ja": "締め切りと同時に結果が自動通知されます。",
        "de": "Ergebnisse werden automatisch nach Ablauf der Frist mitgeteilt.",
        "en": "Results are notified automatically when the deadline ends.",
        "zh-Hans": "截止时将自动通知结果。",
        "zh-Hant": "截止時將自動通知結果。"
    },
    {
        "key": "revert_to_pending",
        "ko": "승인대기로 되돌리기",
        "ja": "revert_to_pending",
        "de": "revert_to_pending",
        "en": "revert_to_pending",
        "zh-Hans": "恢复为待批准",
        "zh-Hant": "恢復為待批准"
    },
    {
        "key": "reverted_to_pending_approval",
        "ko": "승인대기로 되돌렸습니다.",
        "ja": "承認待ちに戻しました。",
        "de": "Auf Genehmigung ausstehend zurückgesetzt.",
        "en": "Reverted to pending approval.",
        "zh-Hans": "已恢复为待批准。",
        "zh-Hant": "已恢復為待批准。"
    },
    {
        "key": "reward",
        "ko": "리워드",
        "ja": "報酬",
        "de": "Belohnung",
        "en": "Reward",
        "zh-Hans": "奖励",
        "zh-Hant": "獎勵"
    },
    {
        "key": "reward_condition",
        "ko": "보상조건",
        "ja": "報酬条件",
        "de": "Reward Condition",
        "en": "Reward Condition",
        "zh-Hans": "奖励条件",
        "zh-Hant": "獎勵條件"
    },
    {
        "key": "reward_earned_info",
        "ko": "리워드 획득정보",
        "ja": "リワード獲得情報",
        "de": "Belohnungserhalt-Info",
        "en": "Reward earned info",
        "zh-Hans": "奖励获得信息",
        "zh-Hant": "獎勵獲得資訊"
    },
    {
        "key": "reward_history",
        "ko": "리워드 내역",
        "ja": "報酬履歴",
        "de": "Belohnungsverlauf",
        "en": "Reward history",
        "zh-Hans": "奖励记录",
        "zh-Hant": "獎勵記錄"
    },
    {
        "key": "reward_received",
        "ko": "받은 보상",
        "ja": "受け取った報酬",
        "de": "Belohnung erhalten",
        "en": "Reward received",
        "zh-Hans": "已获得奖励",
        "zh-Hant": "已獲得獎勵"
    },
    {
        "key": "round",
        "ko": "회",
        "ja": "回",
        "de": "round",
        "en": "round",
        "zh-Hans": "次",
        "zh-Hant": "次"
    },
    {
        "key": "round_of_16",
        "ko": "16강",
        "ja": "16強",
        "de": "Round of 16",
        "en": "Round of 16",
        "zh-Hans": "16强",
        "zh-Hant": "16強"
    },
    {
        "key": "sapporo_special_city",
        "ko": "삿포로",
        "ja": "札幌市",
        "de": "Sapporo",
        "en": "Sapporo",
        "zh-Hans": "札幌",
        "zh-Hant": "札幌"
    },
    {
        "key": "sat",
        "ko": "토",
        "ja": "土",
        "de": "Sat",
        "en": "Sat",
        "zh-Hans": "周六",
        "zh-Hant": "周六"
    },
    {
        "key": "save",
        "ko": "저장",
        "ja": "保存",
        "de": "Speichern",
        "en": "Save",
        "zh-Hans": "保存",
        "zh-Hant": "儲存"
    },
    {
        "key": "save_button",
        "ko": "저장하기",
        "ja": "保存",
        "de": "Speichern",
        "en": "Save",
        "zh-Hans": "保存",
        "zh-Hant": "儲存"
    },
    {
        "key": "save_organization_application",
        "ko": "기관가입수정",
        "ja": "機関登録修正",
        "de": "Organisationsantrag speichern",
        "en": "Save organization application",
        "zh-Hans": "保存机构加入申请",
        "zh-Hant": "儲存機構加入申請"
    },
    {
        "key": "saving",
        "ko": "저장 중...",
        "ja": "保存中...",
        "de": "Wird gespeichert...",
        "en": "Saving...",
        "zh-Hans": "保存中...",
        "zh-Hant": "儲存中..."
    },
    {
        "key": "scheduled",
        "ko": "예약됨",
        "ja": "予約済み",
        "de": "Geplant",
        "en": "Scheduled",
        "zh-Hans": "已预约",
        "zh-Hant": "已預約"
    },
    {
        "key": "scheduled_upload",
        "ko": "예약업로드",
        "ja": "予約アップロード",
        "de": "Geplanter Upload",
        "en": "Scheduled upload",
        "zh-Hans": "预约上传",
        "zh-Hant": "預約上傳"
    },
    {
        "key": "search",
        "ko": "검색하기",
        "ja": "検索",
        "de": "Suchen",
        "en": "Search",
        "zh-Hans": "搜索",
        "zh-Hant": "搜尋"
    },
    {
        "key": "search_again",
        "ko": "다시검색",
        "ja": "再検索",
        "de": "Erneut suchen",
        "en": "Search again",
        "zh-Hans": "重新搜索",
        "zh-Hant": "重新搜尋"
    },
    {
        "key": "search_by_championship_name",
        "ko": "대회명으로검색",
        "ja": "大会名で検索",
        "de": "Suche nach Meisterschaftsname",
        "en": "Search by championship name",
        "zh-Hans": "按大赛名称搜索",
        "zh-Hant": "按大賽名稱搜尋"
    },
    {
        "key": "search_by_country_region",
        "ko": "국가/지역별 검색",
        "ja": "国・地域で検索",
        "de": "Search by country/region",
        "en": "Search by country/region",
        "zh-Hans": "按国家/地区搜索",
        "zh-Hant": "按國家/地區搜尋"
    },
    {
        "key": "search_by_didim_name",
        "ko": "디딤 관리명으로 찾기",
        "ja": "Didim管理名で検索",
        "de": "Search by Didim name",
        "en": "Search by Didim name",
        "zh-Hans": "按 Didim 管理名称搜索",
        "zh-Hant": "按 Didim 管理名稱搜尋"
    },
    {
        "key": "search_by_event",
        "ko": "대회종목으로 검색",
        "ja": "大会種目で検索",
        "de": "Suche nach Veranstaltung",
        "en": "Search by event",
        "zh-Hans": "按大赛项目搜索",
        "zh-Hant": "按大賽項目搜尋"
    },
    {
        "key": "search_by_name",
        "ko": "이름으로 검색",
        "ja": "名前で検索",
        "de": "Suche nach Name",
        "en": "Search by name",
        "zh-Hans": "按姓名搜索",
        "zh-Hant": "按姓名搜尋"
    },
    {
        "key": "search_by_org_name",
        "ko": "기관명으로 검색",
        "ja": "機関名で検索",
        "de": "Suche nach Organisationsname",
        "en": "Search by organization name",
        "zh-Hans": "按机构名称搜索",
        "zh-Hant": "按機構名稱搜尋"
    },
    {
        "key": "search_by_organization",
        "ko": "대회기관별검색",
        "ja": "機関別検索",
        "de": "Suche nach Organisation",
        "en": "Search by organization",
        "zh-Hans": "按大赛机构搜索",
        "zh-Hant": "按大賽機構搜尋"
    },
    {
        "key": "search_by_organization_name",
        "ko": "기관명으로 찾기",
        "ja": "機関名で検索",
        "de": "Suche nach Organisationsname",
        "en": "Search by organization name",
        "zh-Hans": "按机构名称查找",
        "zh-Hant": "按機構名稱查找"
    },
    {
        "key": "search_by_organization_type",
        "ko": "기관유형별검색",
        "ja": "機関タイプで検索",
        "de": "Suche nach Organisationstyp",
        "en": "Search by organization type",
        "zh-Hans": "按机构类型搜索",
        "zh-Hant": "按機構類型搜尋"
    },
    {
        "key": "searching",
        "ko": "검색 중...",
        "ja": "検索中...",
        "de": "Suchen...",
        "en": "Searching...",
        "zh-Hans": "搜索中...",
        "zh-Hant": "搜尋中..."
    },
    {
        "key": "sec",
        "ko": "초",
        "ja": "秒",
        "de": "sec",
        "en": "sec",
        "zh-Hans": "秒",
        "zh-Hant": "秒"
    },
    {
        "key": "sejong",
        "ko": "세종",
        "ja": "世宗",
        "de": "Sejong",
        "en": "Sejong",
        "zh-Hans": "世宗",
        "zh-Hant": "世宗"
    },
    {
        "key": "sejong_special_self_governing_city",
        "ko": "세종특별자치시",
        "ja": "世宗特別自治市",
        "de": "Sejong Special Self-Governing City",
        "en": "Sejong Special Self-Governing City",
        "zh-Hans": "世宗特别自治市",
        "zh-Hant": "世宗特別自治市"
    },
    {
        "key": "select",
        "ko": "선택",
        "ja": "選択",
        "de": "Auswählen",
        "en": "Select",
        "zh-Hans": "选择",
        "zh-Hant": "選擇"
    },
    {
        "key": "select_championship_event",
        "ko": "대회 종목 선택",
        "ja": "大会種目選択",
        "de": "Championship-Event auswählen",
        "en": "Select championship event",
        "zh-Hans": "选择大赛项目",
        "zh-Hant": "選擇大賽項目"
    },
    {
        "key": "select_country",
        "ko": "국가 선택",
        "ja": "国を選択",
        "de": "Select country",
        "en": "Select country",
        "zh-Hans": "选择国家",
        "zh-Hant": "選擇國家"
    },
    {
        "key": "select_different_organization",
        "ko": "다른 기관을 선택해주세요.",
        "ja": "他の機関を選択してください。",
        "de": "Bitte wählen Sie eine andere Organisation.",
        "en": "Please select a different organization.",
        "zh-Hans": "请选择其他机构。",
        "zh-Hant": "請選擇其他機構。"
    },
    {
        "key": "select_event",
        "ko": "대회종목을 선택",
        "ja": "大会種目を選択",
        "de": "Veranstaltung auswählen",
        "en": "Select event",
        "zh-Hans": "选择大赛项目",
        "zh-Hant": "選擇大賽項目"
    },
    {
        "key": "select_filter",
        "ko": "필터 선택",
        "ja": "フィルターを選択",
        "de": "Filter auswählen",
        "en": "Select filter",
        "zh-Hans": "选择筛选器",
        "zh-Hant": "選擇篩選器"
    },
    {
        "key": "select_location",
        "ko": "위치 선택",
        "ja": "位置を選択",
        "de": "Standort auswählen",
        "en": "Select location",
        "zh-Hans": "选择位置",
        "zh-Hant": "選擇位置"
    },
    {
        "key": "select_organization",
        "ko": "기관을 선택하세요.",
        "ja": "機関を選択してください。",
        "de": "Select organization.",
        "en": "Select organization.",
        "zh-Hans": "请选择机构。",
        "zh-Hant": "請選擇機構。"
    },
    {
        "key": "select_period",
        "ko": "기간 선택",
        "ja": "期間選択",
        "de": "Zeitraum auswählen",
        "en": "Select period",
        "zh-Hans": "选择期间",
        "zh-Hant": "選擇期間"
    },
    {
        "key": "select_region",
        "ko": "행정구역 선택",
        "ja": "行政区 選択",
        "de": "Region auswählen",
        "en": "Select region",
        "zh-Hans": "选择行政区",
        "zh-Hant": "選擇行政區"
    },
    {
        "key": "select_search_type",
        "ko": "검색 타입 선택",
        "ja": "検索タイプを選択",
        "de": "Suchtyp auswählen",
        "en": "Select search type",
        "zh-Hans": "选择搜索类型",
        "zh-Hant": "選擇搜尋類型"
    },
    {
        "key": "semi_finals",
        "ko": "4강",
        "ja": "4強",
        "de": "Semi-finals",
        "en": "Semi-finals",
        "zh-Hans": "半决赛",
        "zh-Hant": "半決賽"
    },
    {
        "key": "send_code",
        "ko": "인증번호 전송",
        "ja": "認証番号を送信",
        "de": "Send Code",
        "en": "Send Code",
        "zh-Hans": "发送验证码",
        "zh-Hant": "發送驗證碼"
    },
    {
        "key": "send_code",
        "ko": "인증코드 전송",
        "ja": "認証コードを送信",
        "de": "Code senden",
        "en": "Send Code",
        "zh-Hans": "发送验证码",
        "zh-Hant": "發送驗證碼"
    },
    {
        "key": "sendai_metropolitan_city",
        "ko": "센다이",
        "ja": "仙台市",
        "de": "Sendai",
        "en": "Sendai",
        "zh-Hans": "仙台",
        "zh-Hant": "仙台"
    },
    {
        "key": "seoul",
        "ko": "서울",
        "ja": "ソウル",
        "de": "Seoul",
        "en": "Seoul",
        "zh-Hans": "首尔",
        "zh-Hant": "首爾"
    },
    {
        "key": "seoul_special_city",
        "ko": "서울특별시",
        "ja": "ソウル特別市",
        "de": "Seoul Special City",
        "en": "Seoul Special City",
        "zh-Hans": "首尔特别市",
        "zh-Hant": "首爾特別市"
    },
    {
        "key": "serial",
        "ko": "시리얼",
        "ja": "シリアル",
        "de": "Serial",
        "en": "Serial",
        "zh-Hans": "序列号",
        "zh-Hant": "序號"
    },
    {
        "key": "settings_and_account",
        "ko": "설정 및 계정",
        "ja": "設定とアカウント",
        "de": "Einstellungen und Konto",
        "en": "Settings and account",
        "zh-Hans": "设置和账号",
        "zh-Hant": "設定和帳號"
    },
    {
        "key": "sign_in_failed_please_check_your_email_and_password",
        "ko": "로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.",
        "ja": "ログインに失敗しました。メールとパスワードを確認してください。",
        "de": "Sign-in failed. Please check your email and password.",
        "en": "Sign-in failed. Please check your email and password.",
        "zh-Hans": "登录失败。请检查电子邮件和密码。",
        "zh-Hant": "登入失敗。請檢查電子郵件和密碼。"
    },
    {
        "key": "sign_in_failed_please_try_again",
        "ko": "로그인에 실패했습니다. 다시 시도해주세요.",
        "ja": "ログインに失敗しました。再度お試しください。",
        "de": "Sign-in failed. Please try again.",
        "en": "Sign-in failed. Please try again.",
        "zh-Hans": "登录失败。请重试。",
        "zh-Hant": "登入失敗。請重試。"
    },
    {
        "key": "sign_in_with_didim_qr",
        "ko": "QR로 디딤 로그인하기",
        "ja": "QRでディディムログイン",
        "de": "Sign in with Didim QR",
        "en": "Sign in with Didim QR",
        "zh-Hans": "使用 Didim 二维码登录",
        "zh-Hant": "使用 Didim QR 碼登入"
    },
    {
        "key": "sign_up",
        "ko": "회원가입",
        "ja": "新規登録",
        "de": "Registrieren",
        "en": "Sign up",
        "zh-Hans": "注册会员",
        "zh-Hant": "註冊會員"
    },
    {
        "key": "sign_up_failed",
        "ko": "회원가입에 실패했습니다.",
        "ja": "新規登録に失敗しました。",
        "de": "Sign up failed.",
        "en": "Sign up failed.",
        "zh-Hans": "注册会员失败。",
        "zh-Hant": "註冊會員失敗。"
    },
    {
        "key": "signing_in",
        "ko": "로그인 중...",
        "ja": "ログイン中...",
        "de": "Anmeldung...",
        "en": "Signing in...",
        "zh-Hans": "登录中...",
        "zh-Hant": "登入中..."
    },
    {
        "key": "sns_login_failed",
        "ko": "SNS 로그인에 실패했습니다.",
        "ja": "SNS ログインに失敗しました。",
        "de": "SNS login failed.",
        "en": "SNS login failed.",
        "zh-Hans": "SNS 登录失败。",
        "zh-Hant": "SNS 登入失敗。"
    },
    {
        "key": "south_chungcheong_province",
        "ko": "충청남도",
        "ja": "忠清南道",
        "de": "South Chungcheong Province",
        "en": "South Chungcheong Province",
        "zh-Hans": "忠清南道",
        "zh-Hant": "忠清南道"
    },
    {
        "key": "south_gyeongsang_province",
        "ko": "경상남도",
        "ja": "慶尚南道",
        "de": "South Gyeongsang Province",
        "en": "South Gyeongsang Province",
        "zh-Hans": "庆尚南道",
        "zh-Hant": "慶尚南道"
    },
    {
        "key": "south_jeolla_province",
        "ko": "전라남도",
        "ja": "全羅南道",
        "de": "South Jeolla Province",
        "en": "South Jeolla Province",
        "zh-Hans": "全罗南道",
        "zh-Hant": "全羅南道"
    },
    {
        "key": "south_korea",
        "ko": "대한민국",
        "ja": "大韓民国",
        "de": "South Korea",
        "en": "South Korea",
        "zh-Hans": "韩国",
        "zh-Hant": "韓國"
    },
    {
        "key": "start_day",
        "ko": "{{start}} ~ {{day}}일",
        "ja": "{{start}} ～ {{day}}日",
        "de": "{{start}} - {{day}}",
        "en": "{{start}} - {{day}}",
        "zh-Hans": "{{start}} ~ {{day}}日",
        "zh-Hant": "{{start}} ~ {{day}}日"
    },
    {
        "key": "state_normal",
        "ko": "정상",
        "ja": "正常",
        "de": "Normal",
        "en": "Normal",
        "zh-Hans": "正常",
        "zh-Hant": "正常"
    },
    {
        "key": "status",
        "ko": "상태",
        "ja": "状態",
        "de": "Status",
        "en": "Status",
        "zh-Hans": "状态",
        "zh-Hant": "狀態"
    },
    {
        "key": "status_update",
        "ko": "상태 업데이트",
        "ja": "状態更新",
        "de": "Statusaktualisierung",
        "en": "Status update",
        "zh-Hans": "状态更新",
        "zh-Hant": "狀態更新"
    },
    {
        "key": "step_count",
        "ko": "디딤수",
        "ja": "歩数",
        "de": "Step Count",
        "en": "Step Count",
        "zh-Hans": "步数",
        "zh-Hant": "步數"
    },
    {
        "key": "step_count_info",
        "ko": "디딤수(걸음수) 정보",
        "ja": "歩数情報",
        "de": "Schrittzahl-Info",
        "en": "Step count info",
        "zh-Hans": "步数信息",
        "zh-Hant": "步數資訊"
    },
    {
        "key": "steps",
        "ko": "보",
        "ja": "歩",
        "de": "steps",
        "en": "steps",
        "zh-Hans": "步",
        "zh-Hant": "步"
    },
    {
        "key": "strength",
        "ko": "근력근지구력",
        "ja": "筋力・筋持久力",
        "de": "Strength",
        "en": "Strength",
        "zh-Hans": "肌力肌耐力",
        "zh-Hant": "肌力肌耐力"
    },
    {
        "key": "stress_index",
        "ko": "스트레스 지수",
        "ja": "ストレス指数",
        "de": "Stressindex",
        "en": "Stress Index",
        "zh-Hans": "压力指数",
        "zh-Hant": "壓力指數"
    },
    {
        "key": "stuttgart_metropolitan_city",
        "ko": "슈투트가르트",
        "ja": "シュトゥットガルト",
        "de": "Stuttgart",
        "en": "Stuttgart",
        "zh-Hans": "斯图加特",
        "zh-Hant": "斯圖加特"
    },
    {
        "key": "submit_organization_application",
        "ko": "기관가입신청",
        "ja": "機関登録申請",
        "de": "Organisationsantrag einreichen",
        "en": "Submit organization application",
        "zh-Hans": "提交机构加入申请",
        "zh-Hant": "提交機構加入申請"
    },
    {
        "key": "success",
        "ko": "성공",
        "ja": "成功",
        "de": "Erfolg",
        "en": "Success",
        "zh-Hans": "成功",
        "zh-Hant": "成功"
    },
    {
        "key": "sun",
        "ko": "일",
        "ja": "日",
        "de": "Sun",
        "en": "Sun",
        "zh-Hans": "周日",
        "zh-Hant": "周日"
    },
    {
        "key": "sun_class",
        "ko": "햇님반",
        "ja": "太陽組",
        "de": "Sun Class",
        "en": "Sun Class",
        "zh-Hans": "太阳班",
        "zh-Hant": "太陽班"
    },
    {
        "key": "supervisor_championship",
        "ko": "슈퍼바이저개최대회",
        "ja": "スーパーバイザー主催大会",
        "de": "Betreuermeisterschaft",
        "en": "Supervisor championship",
        "zh-Hans": "主管举办大赛",
        "zh-Hant": "主管舉辦大賽"
    },
    {
        "key": "take_photo",
        "ko": "사진 촬영",
        "ja": "写真を撮る",
        "de": "Foto aufnehmen",
        "en": "Take Photo",
        "zh-Hans": "拍照",
        "zh-Hant": "拍照"
    },
    {
        "key": "target_organization",
        "ko": "대상기관",
        "ja": "対象機関",
        "de": "Zielorganisation",
        "en": "Target organization",
        "zh-Hans": "目标机构",
        "zh-Hant": "目標機構"
    },
    {
        "key": "terms_of_service",
        "ko": "이용약관",
        "ja": "利用規約",
        "de": "Terms of Service",
        "en": "Terms of Service",
        "zh-Hans": "服务条款",
        "zh-Hant": "服務條款"
    },
    {
        "key": "the_number_of_attempts_has_been_exceeded_please_try_again_tomorrow",
        "ko": "재시도 한도가 초과했습니다. 다음날 재시도가 가능합니다.",
        "ja": "試行回数が上限に達しました。明日、再試行できます。",
        "de": "The number of attempts has been exceeded. Please try again tomorrow.",
        "en": "The number of attempts has been exceeded. Please try again tomorrow.",
        "zh-Hans": "重试次数已超出限制。请明天再试。",
        "zh-Hant": "重試次數已超出限制。請明天再試。"
    },
    {
        "key": "this_account_is_already_in_use",
        "ko": "이미 사용 중인 계정입니다.",
        "ja": "既に使用中のアカウントです。",
        "de": "This account is already in use.",
        "en": "This account is already in use.",
        "zh-Hans": "此账号已在使用中。",
        "zh-Hant": "此帳號已在使用中。"
    },
    {
        "key": "this_action_cannot_be_undone",
        "ko": "이 작업은 되돌릴 수 없습니다.",
        "ja": "この操作は元に戻せません。",
        "de": "This action cannot be undone.",
        "en": "This action cannot be undone.",
        "zh-Hans": "此操作无法撤销。",
        "zh-Hant": "此操作無法撤銷。"
    },
    {
        "key": "this_month",
        "ko": "이달",
        "ja": "今月",
        "de": "Dieser Monat",
        "en": "This month",
        "zh-Hans": "本月",
        "zh-Hant": "本月"
    },
    {
        "key": "thu",
        "ko": "목",
        "ja": "木",
        "de": "Thu",
        "en": "Thu",
        "zh-Hans": "周四",
        "zh-Hant": "周四"
    },
    {
        "key": "time",
        "ko": "시간",
        "ja": "時間",
        "de": "Zeit",
        "en": "Time",
        "zh-Hans": "时间",
        "zh-Hant": "時間"
    },
    {
        "key": "time_hours_minutes",
        "ko": "{{hours}}시간 {{minutes}}분",
        "ja": "{{hours}}時間{{minutes}}分",
        "de": "{{hours}}h {{minutes}}m",
        "en": "{{hours}}h {{minutes}}m",
        "zh-Hans": "{{hours}}小时 {{minutes}}分钟",
        "zh-Hant": "{{hours}}小時 {{minutes}}分鐘"
    },
    {
        "key": "time_minutes_only",
        "ko": "{{minutes}}분",
        "ja": "{{minutes}}分",
        "de": "{{minutes}}m",
        "en": "{{minutes}}m",
        "zh-Hans": "{{minutes}}分钟",
        "zh-Hant": "{{minutes}}分鐘"
    },
    {
        "key": "title",
        "ko": "제목",
        "ja": "タイトル",
        "de": "Titel",
        "en": "Title",
        "zh-Hans": "标题",
        "zh-Hant": "標題"
    },
    {
        "key": "title_preview",
        "ko": "제목 미리보기",
        "ja": "タイトルプレビュー",
        "de": "Titelvorschau",
        "en": "Title preview",
        "zh-Hans": "标题预览",
        "zh-Hant": "標題預覽"
    },
    {
        "key": "to_be_removed",
        "ko": "해제 예정",
        "ja": "解除予定",
        "de": "Wird entfernt",
        "en": "To be removed",
        "zh-Hans": "计划解除",
        "zh-Hant": "計劃解除"
    },
    {
        "key": "today",
        "ko": "오늘,",
        "ja": "今日、",
        "de": "Heute,",
        "en": "Today,",
        "zh-Hans": "今天，",
        "zh-Hant": "今天，"
    },
    {
        "key": "today_average_steps",
        "ko": "금일 평균발디딤수",
        "ja": "本日平均歩数",
        "de": "Heutige durchschnittliche Schritte",
        "en": "Today's average steps",
        "zh-Hans": "今日平均步数",
        "zh-Hant": "今日平均步數"
    },
    {
        "key": "today_didim_participants",
        "ko": "금일 디딤참가자수",
        "ja": "本日ディディム参加者数",
        "de": "Heutige Didim-Teilnehmer",
        "en": "Today's Didim participants",
        "zh-Hans": "今日 Didim 参与人数",
        "zh-Hant": "今日 Didim 參與人數"
    },
    {
        "key": "today_didim_total_usage_time",
        "ko": "금일 디딤총사용시간",
        "ja": "本日ディディム総使用時間",
        "de": "Heutige Didim-Gesamtnutzungszeit",
        "en": "Today's total Didim usage time",
        "zh-Hans": "今日 Didim 总使用时间",
        "zh-Hant": "今日 Didim 總使用時間"
    },
    {
        "key": "today_total_usage",
        "ko": "금일총사용",
        "ja": "本日総使用",
        "de": "Heutige Gesamtnutzung",
        "en": "Today total usage",
        "zh-Hans": "今日总使用",
        "zh-Hant": "今日總使用"
    },
    {
        "key": "today_usage_time",
        "ko": "금일사용시간",
        "ja": "本日使用時間",
        "de": "Heutige Nutzungszeit",
        "en": "Today usage time",
        "zh-Hans": "今日使用时间",
        "zh-Hant": "今日使用時間"
    },
    {
        "key": "togglemenu",
        "ko": "toggleMenu",
        "ja": "メニュー開閉",
        "de": "toggleMenu",
        "en": "toggleMenu",
        "zh-Hans": "toggleMenu",
        "zh-Hant": "toggleMenu"
    },
    {
        "key": "tokyo_special_city",
        "ko": "도쿄",
        "ja": "東京都",
        "de": "Tokio",
        "en": "Tokyo",
        "zh-Hans": "东京",
        "zh-Hant": "東京"
    },
    {
        "key": "top_percent",
        "ko": "상위 {{percent}}%",
        "ja": "上位{{percent}}%",
        "de": "Top {{percent}}%",
        "en": "Top {{percent}}%",
        "zh-Hans": "前 {{percent}}%",
        "zh-Hant": "前 {{percent}}%"
    },
    {
        "key": "total_application_point",
        "ko": "총응모포인트",
        "ja": "総応募ポイント",
        "de": "Gesamtbewerbungspunkte",
        "en": "Total application points",
        "zh-Hans": "总报名积分",
        "zh-Hant": "總報名積分"
    },
    {
        "key": "total_didim",
        "ko": "총 디딤",
        "ja": "総ディディム",
        "de": "Total Didim",
        "en": "Total Didim",
        "zh-Hans": "总 Didim",
        "zh-Hant": "總 Didim"
    },
    {
        "key": "total_didim_usage_time",
        "ko": "디딤총사용시간",
        "ja": "ディディム総使用時間",
        "de": "Total Didim usage time",
        "en": "Total Didim usage time",
        "zh-Hans": "Didim 总使用时间",
        "zh-Hant": "Didim 總使用時間"
    },
    {
        "key": "total_entries",
        "ko": "총 응모",
        "ja": "総応募",
        "de": "Gesamteinträge",
        "en": "Total entries",
        "zh-Hans": "总报名",
        "zh-Hant": "總報名"
    },
    {
        "key": "total_members",
        "ko": "총사용자수",
        "ja": "総利用者数",
        "de": "Gesamtmitglieder",
        "en": "Total members",
        "zh-Hans": "总用户数",
        "zh-Hant": "總使用者數"
    },
    {
        "key": "tournament",
        "ko": "토너먼트",
        "ja": "トーナメント",
        "de": "Tournament",
        "en": "Tournament",
        "zh-Hans": "锦标赛",
        "zh-Hant": "錦標賽"
    },
    {
        "key": "tournament_participants",
        "ko": "토너먼트 참가수",
        "ja": "トーナメント参加数",
        "de": "Turnierteilnehmer",
        "en": "Tournament participants",
        "zh-Hans": "锦标赛参与人数",
        "zh-Hant": "錦標賽參與人數"
    },
    {
        "key": "try_again",
        "ko": "다시 시도해주세요.",
        "ja": "もう一度お試しください。",
        "de": "Bitte versuchen Sie es erneut.",
        "en": "Please try again.",
        "zh-Hans": "请重试。",
        "zh-Hant": "請重試。"
    },
    {
        "key": "tue",
        "ko": "화",
        "ja": "火",
        "de": "Tue",
        "en": "Tue",
        "zh-Hans": "周二",
        "zh-Hant": "周二"
    },
    {
        "key": "type_delete_account_to_confirm",
        "ko": "확인을 위해 '계정 삭제'를 입력해주세요.",
        "ja": "確認のために「アカウント削除」と入力してください。",
        "de": "Geben Sie zur Bestätigung „Konto löschen“ ein.",
        "en": "Type 'delete account' to confirm:",
        "zh-Hans": "请输入“删除账号”以确认：",
        "zh-Hant": "請輸入“刪除帳號”以確認："
    },
    {
        "key": "uid",
        "ko": "UID",
        "ja": "UID",
        "de": "UID",
        "en": "UID",
        "zh-Hans": "UID",
        "zh-Hant": "UID"
    },
    {
        "key": "ulsan",
        "ko": "울산",
        "ja": "蔚山",
        "de": "Ulsan",
        "en": "Ulsan",
        "zh-Hans": "蔚山",
        "zh-Hant": "蔚山"
    },
    {
        "key": "ulsan_metropolitan_city",
        "ko": "울산광역시",
        "ja": "蔚山広域市",
        "de": "Ulsan Metropolitan City",
        "en": "Ulsan Metropolitan City",
        "zh-Hans": "蔚山广域市",
        "zh-Hant": "蔚山廣域市"
    },
    {
        "key": "unlink",
        "ko": "연결해지",
        "ja": "接続解除",
        "de": "Unlink",
        "en": "Unlink",
        "zh-Hans": "解除关联",
        "zh-Hant": "解除關聯"
    },
    {
        "key": "unregisterclick",
        "ko": "해제하기",
        "ja": "解除する",
        "de": "unregisterClick",
        "en": "unregisterClick",
        "zh-Hans": "解除",
        "zh-Hant": "解除"
    },
    {
        "key": "unregistered_didim_h_w",
        "ko": "미등록 디딤H/W",
        "ja": "未登録Didim H/W",
        "de": "Unregistered Didim H/W",
        "en": "Unregistered Didim H/W",
        "zh-Hans": "未注册 Didim H/W",
        "zh-Hant": "未註冊 Didim H/W"
    },
    {
        "key": "unregisterstatechange",
        "ko": "해제 상태 변경",
        "ja": "解除状態変更",
        "de": "unregisterStateChange",
        "en": "unregisterStateChange",
        "zh-Hans": "更改解除状态",
        "zh-Hant": "變更解除狀態"
    },
    {
        "key": "unsupported_image_format_only_jpeg_png_gif_allowed",
        "ko": "지원하지 않는 이미지 형식입니다. (jpeg, png, gif만 가능)",
        "ja": "サポートされていない画像形式です。 (jpeg, png, gifのみ可能)",
        "de": "Unsupported image format.  (Only jpeg, png, gif allowed)",
        "en": "Unsupported image format.  (Only jpeg, png, gif allowed)",
        "zh-Hans": "不支持的图片格式。（仅支持 jpeg、png、gif）",
        "zh-Hant": "不支持的圖片格式。（僅支持 jpeg、png、gif）"
    },
    {
        "key": "update_failed",
        "ko": "수정 실패",
        "ja": "更新に失敗しました",
        "de": "Aktualisierung fehlgeschlagen",
        "en": "Update failed",
        "zh-Hans": "更新失败",
        "zh-Hant": "更新失敗"
    },
    {
        "key": "update_organization_name",
        "ko": "{{name}} 기관을 수정하시겠습니까?",
        "ja": "「{{name}}」機関を修正しますか？",
        "de": "Update organization \"{{name}}\"?",
        "en": "Update organization \"{{name}}\"?",
        "zh-Hans": "要修改“{{name}}”机构吗？",
        "zh-Hant": "要修改“{{name}}”機構嗎？"
    },
    {
        "key": "upload",
        "ko": "업로드",
        "ja": "アップロード",
        "de": "Hochladen",
        "en": "Upload",
        "zh-Hans": "上传",
        "zh-Hant": "上傳"
    },
    {
        "key": "upload_condition",
        "ko": "업로드조건",
        "ja": "アップロード条件",
        "de": "Upload-Bedingung",
        "en": "Upload condition",
        "zh-Hans": "上传条件",
        "zh-Hant": "上傳條件"
    },
    {
        "key": "use",
        "ko": "사용",
        "ja": "使用",
        "de": "Use",
        "en": "Use",
        "zh-Hans": "使用",
        "zh-Hant": "使用"
    },
    {
        "key": "use_to_set_the_number_of_classes_per_grade_and_enter_class_names",
        "ko": "* 학년별로 -+를 이용하여 반의 숫자를 입력하고 반이름을 입력해주세요.",
        "ja": "* 学年ごとに -+ でクラス数を入力し、クラス名を入力してください。",
        "de": "* Geben Sie die Anzahl der Klassen mit -+ ein und fügen Sie die Klassennamen hinzu.",
        "en": "* Use -+ to set the number of classes per grade and enter class names.",
        "zh-Hans": "* 请按年级使用 -+ 输入班级数量并输入班级名称。",
        "zh-Hant": "* 請按年級使用 -+ 輸入班級數量並輸入班級名稱。"
    },
    {
        "key": "user",
        "ko": "사용자",
        "ja": "利用者",
        "de": "Benutzer",
        "en": "User",
        "zh-Hans": "用户",
        "zh-Hant": "使用者"
    },
    {
        "key": "user_account",
        "ko": "사용자계정",
        "ja": "利用者アカウント",
        "de": "Benutzerkonto",
        "en": "User account",
        "zh-Hans": "用户账号",
        "zh-Hant": "使用者帳號"
    },
    {
        "key": "user_add_edit",
        "ko": "사용자 추가/수정",
        "ja": "ユーザー追加/編集",
        "de": "User add/edit",
        "en": "User add/edit",
        "zh-Hans": "添加/编辑用户",
        "zh-Hant": "新增/編輯使用者"
    },
    {
        "key": "user_added",
        "ko": "사용자가 추가되었습니다.",
        "ja": "ユーザーが追加されました。",
        "de": "Benutzer wurde hinzugefügt.",
        "en": "User has been added.",
        "zh-Hans": "用户已添加。",
        "zh-Hant": "使用者已新增。"
    },
    {
        "key": "user_added_membership_save_failed",
        "ko": "사용자는 추가되었지만 소속기관 저장에 실패했습니다.",
        "ja": "ユーザーは追加されましたが所属機関の保存に失敗しました。",
        "de": "Benutzer wurde hinzugefügt, aber das Speichern der Organisationen ist fehlgeschlagen.",
        "en": "User was added but saving affiliated organizations failed.",
        "zh-Hans": "用户已添加，但保存所属机构失败。",
        "zh-Hant": "使用者已新增，但儲存所屬機構失敗。"
    },
    {
        "key": "user_detail",
        "ko": "사용자 상세",
        "ja": "ユーザー詳細",
        "de": "Benutzerdetails",
        "en": "User detail",
        "zh-Hans": "用户详情",
        "zh-Hant": "使用者詳情"
    },
    {
        "key": "user_edit",
        "ko": "사용자 수정",
        "ja": "ユーザー編集",
        "de": "Benutzer bearbeiten",
        "en": "Use edit",
        "zh-Hans": "编辑用户",
        "zh-Hant": "編輯使用者"
    },
    {
        "key": "user_info_not_found",
        "ko": "사용자 정보를 찾을 수 없습니다.",
        "ja": "ユーザー情報が見つかりません。",
        "de": "Benutzerinformationen nicht gefunden.",
        "en": "User information not found.",
        "zh-Hans": "找不到用户信息。",
        "zh-Hant": "找不到使用者資訊。"
    },
    {
        "key": "user_info_updated",
        "ko": "사용자 정보가 수정되었습니다.",
        "ja": "ユーザー情報が更新されました。",
        "de": "Benutzerinformationen wurden aktualisiert.",
        "en": "User information has been updated.",
        "zh-Hans": "用户信息已更新。",
        "zh-Hant": "使用者資訊已更新。"
    },
    {
        "key": "user_information_has_been_successfully_updated",
        "ko": "사용자 정보가 성공적으로 수정되었습니다.",
        "ja": "ユーザー情報が正常に更新されました。",
        "de": "User information has been successfully updated.",
        "en": "User information has been successfully updated.",
        "zh-Hans": "用户信息已成功更新。",
        "zh-Hant": "使用者資訊已成功更新。"
    },
    {
        "key": "user_list",
        "ko": "사용자 목록",
        "ja": "ユーザー一覧",
        "de": "Benutzerliste",
        "en": "User list",
        "zh-Hans": "用户列表",
        "zh-Hant": "使用者清單"
    },
    {
        "key": "user_main_progress_complete",
        "ko": "완료",
        "ja": "完了",
        "de": "Abschließen",
        "en": "Complete",
        "zh-Hans": "完成",
        "zh-Hant": "完成"
    },
    {
        "key": "user_main_progress_ongoing",
        "ko": "진행중",
        "ja": "進行中",
        "de": "In Bearbeitung",
        "en": "In progress",
        "zh-Hans": "进行中",
        "zh-Hant": "進行中"
    },
    {
        "key": "user_management",
        "ko": "사용자 관리",
        "ja": "ユーザー管理",
        "de": "Benutzerverwaltung",
        "en": "User management",
        "zh-Hans": "用户管理",
        "zh-Hant": "使用者管理"
    },
    {
        "key": "user_name",
        "ko": "사용자명",
        "ja": "利用者名",
        "de": "Benutzername",
        "en": "User name",
        "zh-Hans": "用户名",
        "zh-Hant": "使用者名"
    },
    {
        "key": "user_not_found",
        "ko": "사용자를 찾을 수 없습니다.",
        "ja": "ユーザーが見つかりません。",
        "de": "User not found.",
        "en": "User not found.",
        "zh-Hans": "找不到用户。",
        "zh-Hant": "找不到使用者。"
    },
    {
        "key": "user_save_failed",
        "ko": "사용자 정보 저장에 실패했습니다.",
        "ja": "ユーザー情報の保存に失敗しました。",
        "de": "Benutzerinformationen konnten nicht gespeichert werden.",
        "en": "Failed to save user information.",
        "zh-Hans": "保存用户信息失败。",
        "zh-Hant": "儲存使用者資訊失敗。"
    },
    {
        "key": "user_updated_membership_save_failed",
        "ko": "사용자 정보는 수정되었지만 소속기관 저장에 실패했습니다.",
        "ja": "ユーザー情報は更新されましたが所属機関の保存に失敗しました。",
        "de": "Benutzerinformationen wurden aktualisiert, aber das Speichern der Organisationen ist fehlgeschlagen.",
        "en": "User information was updated but saving affiliated organizations failed.",
        "zh-Hans": "用户信息已更新，但保存所属机构失败。",
        "zh-Hant": "使用者資訊已更新，但儲存所屬機構失敗。"
    },
    {
        "key": "valid_success_target_rounds",
        "ko": "{{valid}}회 성공 / {{target}}회",
        "ja": "{{valid}}回成功 / {{target}}回",
        "de": "{{valid}} success / {{target}} rounds",
        "en": "{{valid}} success / {{target}} rounds",
        "zh-Hans": "{{valid}}次成功 / {{target}}次",
        "zh-Hant": "{{valid}}次成功 / {{target}}次"
    },
    {
        "key": "value_didim_per_day",
        "ko": "일 {{value}} 디딤",
        "ja": "1日{{value}}ディディム",
        "de": "{{value}} Didim per day",
        "en": "{{value}} Didim per day",
        "zh-Hans": "每天 {{value}} Didim",
        "zh-Hant": "每天 {{value}} Didim"
    },
    {
        "key": "verification_check_failed",
        "ko": "인증코드 확인에 실패했습니다.",
        "ja": "認証コードの確認に失敗しました。",
        "de": "Verification check failed.",
        "en": "Verification check failed.",
        "zh-Hans": "验证码确认失败。",
        "zh-Hant": "驗證碼確認失敗。"
    },
    {
        "key": "verification_code",
        "ko": "코드인증",
        "ja": "認証コード",
        "de": "Verification Code",
        "en": "Verification Code",
        "zh-Hans": "验证码",
        "zh-Hant": "驗證碼"
    },
    {
        "key": "verification_code_does_not_match",
        "ko": "인증코드가 일치하지 않습니다.",
        "ja": "認証コードが一致しません。",
        "de": "Verification code does not match.",
        "en": "Verification code does not match.",
        "zh-Hans": "验证码不一致。",
        "zh-Hant": "驗證碼不一致。"
    },
    {
        "key": "verification_code_has_been_sent_to_email",
        "ko": "{{email}} 메일로 인증코드가 전송되었습니다.",
        "ja": "{{email}} に認証コードを送信しました。",
        "de": "Verification code has been sent to {{email}}.",
        "en": "Verification code has been sent to {{email}}.",
        "zh-Hans": "验证码已发送至 {{email}}。",
        "zh-Hant": "驗證碼已發送至 {{email}}。"
    },
    {
        "key": "verification_code_must_be_6_digits",
        "ko": "인증코드는 6자리 숫자입니다.",
        "ja": "認証コードは6桁の数字です。",
        "de": "Verification code must be 6 digits.",
        "en": "Verification code must be 6 digits.",
        "zh-Hans": "验证码必须为6位数字。",
        "zh-Hant": "驗證碼必須為6位數字。"
    },
    {
        "key": "verification_code_sent",
        "ko": "인증번호를 발송했습니다.",
        "ja": "認証番号を送信しました。",
        "de": "Verification code sent.",
        "en": "Verification code sent.",
        "zh-Hans": "验证码已发送。",
        "zh-Hant": "驗證碼已發送。"
    },
    {
        "key": "verification_complete",
        "ko": "인증이 완료되었습니다.",
        "ja": "認証が完了しました。",
        "de": "Verification complete.",
        "en": "Verification complete.",
        "zh-Hans": "验证完成。",
        "zh-Hant": "驗證完成。"
    },
    {
        "key": "verification_number",
        "ko": "인증번호",
        "ja": "認証番号",
        "de": "Verifizierungsnummer",
        "en": "Verification number",
        "zh-Hans": "验证码",
        "zh-Hant": "驗證碼"
    },
    {
        "key": "version_unknown",
        "ko": "버전 정보 없음.",
        "ja": "バージョン情報なし。",
        "de": "Version unknown.",
        "en": "Version unknown.",
        "zh-Hans": "版本信息未知。",
        "zh-Hant": "版本資訊未知。"
    },
    {
        "key": "very_high",
        "ko": "매우 높음",
        "ja": "非常に高い",
        "de": "Very High",
        "en": "Very High",
        "zh-Hans": "非常高",
        "zh-Hant": "非常高"
    },
    {
        "key": "view",
        "ko": "보기",
        "ja": "表示",
        "de": "Anzeigen",
        "en": "View",
        "zh-Hans": "查看",
        "zh-Hant": "查看"
    },
    {
        "key": "view_all",
        "ko": "전체 보기",
        "ja": "すべて表示",
        "de": "Alle anzeigen",
        "en": "View All",
        "zh-Hans": "查看全部",
        "zh-Hant": "查看全部"
    },
    {
        "key": "view_detail",
        "ko": "상세보기",
        "ja": "詳細を見る",
        "de": "Details anzeigen",
        "en": "View detail",
        "zh-Hans": "查看详情",
        "zh-Hant": "查看詳情"
    },
    {
        "key": "visibility",
        "ko": "공개여부",
        "ja": "公開設定",
        "de": "Visibility",
        "en": "Visibility",
        "zh-Hans": "公开状态",
        "zh-Hant": "公開狀態"
    },
    {
        "key": "warning",
        "ko": "경고",
        "ja": "警告",
        "de": "Warnung",
        "en": "Warning",
        "zh-Hans": "警告",
        "zh-Hant": "警告"
    },
    {
        "key": "watch_linkage",
        "ko": "워치연동",
        "ja": "ウォッチ連携",
        "de": "Uhr-Verknüpfung",
        "en": "Watch linkage",
        "zh-Hans": "手表关联",
        "zh-Hant": "手表關聯"
    },
    {
        "key": "wed",
        "ko": "수",
        "ja": "水",
        "de": "Wed",
        "en": "Wed",
        "zh-Hans": "周三",
        "zh-Hant": "周三"
    },
    {
        "key": "weekend",
        "ko": "주말반",
        "ja": "週末クラス",
        "de": "Weekend",
        "en": "Weekend",
        "zh-Hans": "周末班",
        "zh-Hant": "週末班"
    },
    {
        "key": "weekly",
        "ko": "주간",
        "ja": "週間",
        "de": "Weekly",
        "en": "Weekly",
        "zh-Hans": "每周",
        "zh-Hant": "每週"
    },
    {
        "key": "welfare_facility",
        "ko": "복지시설",
        "ja": "福祉施設",
        "de": "Welfare Facility",
        "en": "Welfare Facility",
        "zh-Hans": "福利设施",
        "zh-Hant": "福利設施"
    },
    {
        "key": "whole_school",
        "ko": "전교",
        "ja": "全校",
        "de": "Gesamte Schule",
        "en": "Whole school",
        "zh-Hans": "全校",
        "zh-Hant": "全校"
    },
    {
        "key": "width_340px_fixed_height_min_243px",
        "ko": "가로 340고정 * 세로는 최소 243",
        "ja": "横340固定 * 縦は最小243",
        "de": "Breite 340 fest * Höhe min. 243",
        "en": "Width 340px fixed * Height min 243px",
        "zh-Hans": "宽度固定 340px * 高度最小 243px",
        "zh-Hant": "寬度固定 340px * 高度最小 243px"
    },
    {
        "key": "will_be_auto_filled_when_zipcode_is_entered",
        "ko": "우편번호 입력시 자동입력됩니다.",
        "ja": "郵便番号入力時に自動入力されます。",
        "de": "Will be auto-filled when zipcode is entered.",
        "en": "Will be auto-filled when zipcode is entered.",
        "zh-Hans": "输入邮政编码时将自动填写。",
        "zh-Hant": "輸入郵遞區號時將自動填寫。"
    },
    {
        "key": "winner_organizations",
        "ko": "당첨기관",
        "ja": "当選機関",
        "de": "Siegerorganisationen",
        "en": "Winner organizations",
        "zh-Hans": "中奖机构",
        "zh-Hant": "中獎機構"
    },
    {
        "key": "winners",
        "ko": "당첨자",
        "ja": "当選者",
        "de": "Winners",
        "en": "Winners",
        "zh-Hans": "中奖者",
        "zh-Hant": "中獎者"
    },
    {
        "key": "withdraw_account",
        "ko": "계정탈퇴",
        "ja": "アカウント退会",
        "de": "Konto kündigen",
        "en": "Withdraw account",
        "zh-Hans": "注销账号",
        "zh-Hant": "註銷帳號"
    },
    {
        "key": "withdrawn",
        "ko": "탈퇴",
        "ja": "退会",
        "de": "Zurückgezogen",
        "en": "Withdrawn",
        "zh-Hans": "已注销",
        "zh-Hant": "已註銷"
    },
    {
        "key": "wuppertal_metropolitan_city",
        "ko": "부퍼탈",
        "ja": "ヴッパータール",
        "de": "Wuppertal",
        "en": "Wuppertal",
        "zh-Hans": "伍珀塔尔",
        "zh-Hant": "伍珀塔爾"
    },
    {
        "key": "year",
        "ko": "년",
        "ja": "年",
        "de": "Jahr",
        "zh-Hans": "年",
        "zh-Hant": "年"
    },
    {
        "key": "yearly",
        "ko": "연간",
        "ja": "年間",
        "de": "Jährlich",
        "en": "Yearly",
        "zh-Hans": "每年",
        "zh-Hant": "每年"
    },
    {
        "key": "yes",
        "ko": "있음",
        "ja": "あり",
        "de": "Ja",
        "en": "Yes",
        "zh-Hans": "是",
        "zh-Hant": "是"
    },
    {
        "key": "you_are_an_administrator_please_use_the_web_page",
        "ko": "관리자입니다. 웹페이지를 이용해주세요.",
        "ja": "管理者です。ウェブページをご利用ください。",
        "de": "You are an administrator. Please use the web page.",
        "en": "You are an administrator. Please use the web page.",
        "zh-Hans": "您是管理员。请使用网页。",
        "zh-Hant": "您是管理員。請使用網頁。"
    },
    {
        "key": "you_can_add_up_to_5_affiliated_organizations",
        "ko": "소속기관은 최대 5개까지 추가할 수 있습니다.",
        "ja": "所属機関は最大5件まで追加できます。",
        "de": "You can add up to 5 affiliated organizations.",
        "en": "You can add up to 5 affiliated organizations.",
        "zh-Hans": "所属机构最多可添加5个。",
        "zh-Hant": "所屬機構最多可新增5個。"
    },
    {
        "key": "you_cannot_join_the_same_division_section_of_the_same_organization_more_than_once",
        "ko": "같은 기관의 같은 세부소속에 중복으로 가입할 수 없습니다.",
        "ja": "同じ機関の同じ詳細所属に重複して加入することはできません。",
        "de": "Sie können derselben Abteilung/Sektion derselben Organisation nicht mehrfach beitreten.",
        "en": "You cannot join the same division/section of the same organization more than once.",
        "zh-Hans": "不能重复加入同一机构的同一详细所属。",
        "zh-Hant": "不能重複加入同一機構的同一詳細所屬。"
    },
    {
        "key": "you_cannot_participate_without_an_affiliation",
        "ko": "무소속은 참여할 수 없습니다.",
        "ja": "無所属は参加できません。",
        "de": "Ohne Zugehörigkeit ist eine Teilnahme nicht möglich.",
        "en": "You cannot participate without an affiliation.",
        "zh-Hans": "无所属时不能参与。",
        "zh-Hant": "無所屬時不能參與。"
    },
    {
        "key": "your_application_has_been_received_we_will_notify_you_of_the_approval_or_rejection_status_as_soon_as_possible",
        "ko": "가입신청이 접수되었습니다. 최대한 빨리 승인 또는 반려 현황을 보내드리겠습니다.",
        "ja": "登録申請を受け付けました。できるだけ早く承認または却下のご連絡をいたします。",
        "de": "Ihre Bewerbung wurde erhalten. Wir benachrichtigen Sie so schnell wie möglich über Genehmigung oder Ablehnung.",
        "en": "Your application has been received. We will notify you of the approval or rejection status as soon as possible.",
        "zh-Hans": "加入申请已收到。我们会尽快通知您批准或驳回状态。",
        "zh-Hant": "加入申請已收到。我們會盡快通知您批准或駁回狀態。"
    },
    {
        "key": "your_changes_will_be_saved",
        "ko": "수정된 내용이 저장됩니다.",
        "ja": "変更内容が保存されます。",
        "de": "Your changes will be saved.",
        "en": "Your changes will be saved.",
        "zh-Hans": "修改内容将被保存。",
        "zh-Hant": "修改內容將被儲存。"
    },
    {
        "key": "youth_facility",
        "ko": "청소년 시설",
        "ja": "青少年施設",
        "de": "Youth Facility",
        "en": "Youth Facility",
        "zh-Hans": "青少年设施",
        "zh-Hant": "青少年設施"
    },
    {
        "key": "zip_code",
        "ko": "우편번호",
        "ja": "郵便番号",
        "de": "Postleitzahl",
        "en": "Zip code",
        "zh-Hans": "邮政编码",
        "zh-Hant": "郵遞區號"
    },
    {
        "key": "zone_goal_reached",
        "ko": "구간 목표 도달",
        "ja": "区間目標達成",
        "de": "Zielbereich erreicht",
        "en": "Zone goal reached",
        "zh-Hans": "达到区间目标",
        "zh-Hant": "達到區間目標"
    }
]